// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://src` | (string & {});
};

/**
 * Action
 *
 * Action.
 */
export type Action = {
    /**
     * Name
     */
    name: string;
    /**
     * Title
     */
    title: string | null;
    /**
     * Method
     */
    method: string;
    /**
     * Href
     */
    href: string;
    /**
     * Operation
     */
    operation: string | null;
};

/**
 * ActionDetailSchema
 */
export type ActionDetailSchema = {
    /**
     * Action Type
     */
    action_type: string;
    /**
     * Entity Type
     */
    entity_type?: string | null;
    /**
     * Entity Id
     */
    entity_id?: string | null;
    /**
     * Entity Name
     */
    entity_name?: string | null;
    /**
     * Detail
     */
    detail: string;
    /**
     * Success
     */
    success?: boolean;
};

/**
 * AdminFeatureFlagResponse
 */
export type AdminFeatureFlagResponse = {
    /**
     * Feature Key
     */
    feature_key: string;
    /**
     * Is Globally Enabled
     */
    is_globally_enabled: boolean;
    /**
     * Disabled Reason
     */
    disabled_reason: string | null;
    /**
     * Updated At
     */
    updated_at?: Date | null;
    /**
     * Updated By
     */
    updated_by?: string | null;
};

/**
 * AdminFeatureFlagUpdate
 */
export type AdminFeatureFlagUpdate = {
    /**
     * Is Globally Enabled
     */
    is_globally_enabled: boolean;
    /**
     * Disabled Reason
     */
    disabled_reason?: string | null;
};

/**
 * AffectedEntitySchema
 */
export type AffectedEntitySchema = {
    /**
     * Entity Type
     */
    entity_type: string;
    /**
     * Entity Id
     */
    entity_id: string;
    /**
     * Name
     */
    name?: string;
    /**
     * Change Type
     */
    change_type?: string | null;
};

/**
 * Agent
 */
export type Agent = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Email
     */
    email: string;
    /**
     * Roles
     */
    roles?: Array<ClusterRole>;
    /**
     * Created By User Id
     */
    created_by_user_id?: string | null;
    /**
     * Tokens
     */
    tokens?: Array<AgentToken>;
};

/**
 * AgentRef
 */
export type AgentRef = {
    /**
     * Agent Id
     */
    agent_id: string;
};

/**
 * AgentToken
 *
 * One agent credential, never the secret: its hint and what it is bound to.
 */
export type AgentToken = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Token Hint
     */
    token_hint?: string;
    /**
     * Agent Id
     */
    agent_id: string;
    /**
     * Organization Id
     */
    organization_id: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Scopes
     */
    scopes?: Array<string>;
    /**
     * Created By User Id
     */
    created_by_user_id?: string | null;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Expires At
     */
    expires_at: Date;
    /**
     * Last Used At
     */
    last_used_at?: Date | null;
    /**
     * Revoked At
     */
    revoked_at?: Date | null;
    /**
     * Status
     *
     * active · expired · revoked
     */
    status: string;
};

/**
 * AgentTokenCreated
 *
 * The one response that carries the raw token. Shown once.
 */
export type AgentTokenCreated = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Token Hint
     */
    token_hint?: string;
    /**
     * Agent Id
     */
    agent_id: string;
    /**
     * Organization Id
     */
    organization_id: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Scopes
     */
    scopes?: Array<string>;
    /**
     * Created By User Id
     */
    created_by_user_id?: string | null;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Expires At
     */
    expires_at: Date;
    /**
     * Last Used At
     */
    last_used_at?: Date | null;
    /**
     * Revoked At
     */
    revoked_at?: Date | null;
    /**
     * Status
     *
     * active · expired · revoked
     */
    status: string;
    /**
     * Token
     */
    token: string;
};

/**
 * AnswerGapRequest
 */
export type AnswerGapRequest = {
    /**
     * Gap Key
     */
    gap_key: string;
    /**
     * Answer
     */
    answer: string;
};

/**
 * ApiKey
 *
 * Schema for an API key.
 */
export type ApiKey = {
    /**
     * Identity
     *
     * ID of the API key
     */
    identity: string;
    /**
     * Name
     *
     * Name of the API key
     */
    name: string;
    /**
     * Created At
     *
     * Creation timestamp
     */
    created_at: Date;
    /**
     * Expires At
     *
     * Expiration timestamp
     */
    expires_at?: Date | null;
    /**
     * Last Used At
     *
     * Last used timestamp
     */
    last_used_at?: Date | null;
};

/**
 * ApiKeyCreated
 *
 * Schema for a newly created API key.
 */
export type ApiKeyCreated = {
    /**
     * Identity
     *
     * ID of the API key
     */
    identity: string;
    /**
     * Name
     *
     * Name of the API key
     */
    name: string;
    /**
     * Created At
     *
     * Creation timestamp
     */
    created_at: Date;
    /**
     * Expires At
     *
     * Expiration timestamp
     */
    expires_at?: Date | null;
    /**
     * Last Used At
     *
     * Last used timestamp
     */
    last_used_at?: Date | null;
    /**
     * Key
     *
     * The API key (only shown once)
     */
    key: string;
};

/**
 * ApiKeysList
 *
 * Schema for a list of API keys.
 */
export type ApiKeysList = {
    /**
     * Api Keys
     *
     * List of API keys
     */
    api_keys: Array<ApiKey>;
};

/**
 * Application
 *
 * API response schema for an Application.
 */
export type Application = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Name
     */
    name: string;
    variant: ApplicationVariant;
    /**
     * Responsible Role Id
     */
    responsible_role_id?: string | null;
    /**
     * Actor Role Ids
     */
    actor_role_ids?: Array<string>;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Process Task Links
     */
    process_task_links?: Array<ProcessTaskLink>;
};

/**
 * ApplicationCommunication
 *
 * API schema for the boundary flows of one pool resolved to an
 * Application — the IT-tier "External interfaces" bucket.
 */
export type ApplicationCommunication = {
    application: DerivedEvidenceRef;
    /**
     * Flows
     */
    flows?: Array<ExternalCommunicationFlow>;
};

/**
 * ApplicationEntitiesView
 *
 * API response schema for listing ApplicationEntities of an Application.
 */
export type ApplicationEntitiesView = {
    /**
     * Entities
     */
    entities: Array<ApplicationEntity>;
    /**
     * Related External Entities
     */
    related_external_entities?: Array<ExternalApplicationEntity>;
};

/**
 * ApplicationEntity
 *
 * API response schema for an ApplicationEntity.
 */
export type ApplicationEntity = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Application Id
     */
    application_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Business Entity Id
     */
    business_entity_id?: string | null;
    /**
     * Transformation Description
     */
    transformation_description?: string | null;
    description?: Artefact | null;
    /**
     * Relationships
     */
    relationships?: Array<ApplicationEntityRelationship>;
};

/**
 * ApplicationEntityRelationship
 *
 * API schema for an ApplicationEntity relationship, direction-tagged.
 */
export type ApplicationEntityRelationship = {
    /**
     * Type
     */
    type: string;
    /**
     * Other Id
     */
    other_id: string;
    direction: RelationshipDirection;
};

/**
 * ApplicationVariant
 *
 * Whether the Application is built and owned in-house or sourced from a third party.
 */
export enum ApplicationVariant {
    BUILD = 'build',
    THIRD_PARTY = 'third_party'
}

/**
 * ApplicationWithEntities
 *
 * API response schema: an Application together with its ApplicationEntities.
 */
export type ApplicationWithEntities = {
    application: Application;
    /**
     * Entities
     */
    entities?: Array<ApplicationEntity>;
};

/**
 * Artefact
 *
 * Response body for Artefact.
 */
export type Artefact = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Mimetype
     */
    mimetype: string;
    /**
     * Links
     */
    links?: {
        [key: string]: Hateoas;
    };
    /**
     * Preview
     */
    preview: string | null;
    /**
     * Diff Status
     */
    diff_status?: 'added' | 'modified' | 'removed' | null;
};

/**
 * ArtefactGroupWithArtefacts
 *
 * Response body for Artefact group with artefacts.
 */
export type ArtefactGroupWithArtefacts = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Diff Status
     */
    diff_status?: 'added' | 'modified' | 'removed' | null;
    /**
     * Artefacts
     */
    artefacts: Array<Artefact | ArtefactGroupWithArtefacts>;
};

/**
 * AskAnswer
 *
 * The box's reply to one question.
 *
 * An object rather than a bare string, which is what let the move to
 * background execution happen without the client changing how it reads an
 * answer: the answer is now nested inside ``AskRun`` exactly as it was, and
 * everything new sits beside it.
 */
export type AskAnswer = {
    /**
     * Answer
     *
     * The box's prose reply, ready to show as written.
     */
    answer: string;
    /**
     * References
     *
     * Entities the answer is about. Empty when it is about nothing in particular.
     */
    references?: Array<AskReference>;
    /**
     * Set only when the box declined a change and offered a thread.
     */
    offer_thread?: ThreadOffer | null;
};

/**
 * AskExchange
 *
 * One earlier question in this sitting, and the answer it got.
 *
 * The same ``AskAnswer`` the current run carries, so the box renders a past
 * exchange with exactly the code it renders the live one with — references and
 * thread offer included, because a thread offered two questions ago is still
 * an offer worth taking.
 */
export type AskExchange = {
    /**
     * Question
     *
     * What was asked.
     */
    question: string;
    /**
     * What the box answered.
     */
    answer: AskAnswer;
};

/**
 * AskReference
 *
 * An entity the answer is about, for the client to render as a link.
 *
 * Everything here has been through ``resolve_references``, so ``entity_id``
 * names something that really exists in the caller's stek. The client can
 * build a link from it without checking first — which is the whole point of
 * resolving on this side rather than letting a hallucinated id out.
 */
export type AskReference = {
    /**
     * Entity Type
     *
     * The kind of entity, as the worktree names it.
     */
    entity_type: string;
    /**
     * Entity Id
     *
     * Resolved id — exists in this stek.
     */
    entity_id: string;
    /**
     * Entity Name
     *
     * What to show, as the answer calls it.
     */
    entity_name: string;
};

/**
 * AskRun
 *
 * One person's current question in one stek: how far it got, and its answer.
 *
 * Returned both when a question is accepted and when the box reopens and asks
 * what happened to it — the same shape either way, so the client has one thing
 * to render rather than two that drift.
 *
 * There is no run id, and that is the design rather than an omission. A run is
 * identified by who asked and where, so reopening the box asks for *my run in
 * this stek*; asking again supersedes. Nothing has to be remembered across a
 * closed tab.
 */
export type AskRun = {
    /**
     * Status
     *
     * "running", "done" or "failed".
     */
    status: string;
    /**
     * Question
     *
     * What was asked — shown above the answer on a reopen.
     */
    question: string;
    /**
     * Started At Ms
     *
     * Epoch milliseconds, for elapsed time that survives a reopen.
     */
    started_at_ms: number;
    /**
     * Set once the run is done. Null while it is running.
     */
    answer?: AskAnswer | null;
    /**
     * Error
     *
     * Reader-facing, and only on a failure. The box's own sentences (timed out, ran out of steps) arrive as answers instead.
     */
    error?: string;
    /**
     * Progress
     *
     * The steps so far, in order. What a reader who arrives mid-run is given, so they see what the live subscribers already saw.
     */
    progress?: Array<string>;
    /**
     * History
     *
     * Completed exchanges before this one, oldest first, from this sitting only. What lets a follow-up be understood as a follow-up, and what the box puts back on screen when it reopens.
     */
    history?: Array<AskExchange>;
};

/**
 * Assessment
 *
 * One topic's answer for the selected scope.
 *
 * ``findings`` and ``claims`` are empty on the overview and populated by the
 * detail read - they are an order of magnitude larger than the card and only
 * the card somebody opens needs them.
 */
export type Assessment = {
    /**
     * Topic Key
     */
    topic_key: string;
    /**
     * Title
     */
    title: string;
    /**
     * Headline
     */
    headline?: string;
    /**
     * Scope Summary
     */
    scope_summary?: string;
    status: AssessmentStatus;
    basis: EvidenceBasis;
    /**
     * Requirement Ids
     */
    requirement_ids?: Array<string>;
    /**
     * Findings
     */
    findings?: Array<ScopeFinding>;
    /**
     * Claims
     */
    claims?: Array<EvidenceClaim>;
    coverage?: Coverage;
    /**
     * Attention
     */
    attention?: Array<string>;
    /**
     * Open Questions
     */
    open_questions?: number;
    /**
     * Exceptions
     */
    exceptions?: Array<RequirementException>;
    /**
     * Conflicts
     */
    conflicts?: number;
    /**
     * Unknowns
     */
    unknowns?: number;
    /**
     * Contradictions
     */
    contradictions?: number;
    freshness: Freshness;
    /**
     * Evaluated
     */
    evaluated?: boolean;
    /**
     * Evaluator Version
     */
    evaluator_version?: string;
};

/**
 * AssessmentStatus
 */
export enum AssessmentStatus {
    SUPPORTED = 'supported',
    NEEDS_ATTENTION = 'needs_attention',
    UNKNOWN = 'unknown',
    CONFLICTING = 'conflicting',
    NOT_APPLICABLE = 'not_applicable',
    NO_REQUIREMENT = 'no_requirement'
}

/**
 * AttentionEventSchema
 *
 * One probe report. Only probe-writable kinds pass — `viewed` and friends
 * are server-derived, and a client claiming them is wrong by definition.
 */
export type AttentionEventSchema = {
    /**
     * Entity Ref
     */
    entity_ref: string;
    kind: SignalKind;
    /**
     * Dwell Ms
     */
    dwell_ms?: number;
};

/**
 * AttentionEventsSchema
 */
export type AttentionEventsSchema = {
    /**
     * Events
     */
    events: Array<AttentionEventSchema>;
};

/**
 * Body_create_api_integration_stek_integration_mgt_integration_settings__integration_type__post
 */
export type BodyCreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePost = {
    /**
     * Api Key
     */
    api_key: string;
    /**
     * Host
     */
    host?: string | null;
};

/**
 * Body_create_api_key__user_api_key_post
 */
export type BodyCreateApiKeyUserApiKeyPost = {
    /**
     * Name
     */
    name: string;
    /**
     * Expires At
     */
    expires_at?: Date | null;
};

/**
 * Body_generate_authorization_code_integrations_oauth2_server_authorize_post
 */
export type BodyGenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePost = {
    /**
     * Consent Request Id
     */
    consent_request_id: string;
    /**
     * Organization Id
     */
    organization_id: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Grant Write Access
     */
    grant_write_access?: boolean;
    /**
     * Grant Events Write Access
     */
    grant_events_write_access?: boolean;
    /**
     * Authorization Token
     */
    authorization_token: string;
    /**
     * Organization Header
     */
    organization_header?: string | null;
    /**
     * Stek Header
     */
    stek_header?: string | null;
};

/**
 * Body_set_attention_probe_enabled_me_attention_probe_enabled_put
 */
export type BodySetAttentionProbeEnabledMeAttentionProbeEnabledPut = {
    /**
     * Enabled
     */
    enabled: boolean;
};

/**
 * Body_set_personal_memory_enabled_me_personal_memory_enabled_put
 */
export type BodySetPersonalMemoryEnabledMePersonalMemoryEnabledPut = {
    /**
     * Enabled
     */
    enabled: boolean;
};

/**
 * Body_start_ask_ask_mgt_answer_question_start_post
 */
export type BodyStartAskAskMgtAnswerQuestionStartPost = {
    /**
     * Question
     */
    question: string;
};

/**
 * Body_start_biz_artefact_management_add_artefact_group_start_post
 */
export type BodyStartBizArtefactManagementAddArtefactGroupStartPost = {
    /**
     * Owner Id
     */
    owner_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Commit Message
     *
     * Added {artefact.name}
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_add_artefact_start_post
 */
export type BodyStartBizArtefactManagementAddArtefactStartPost = {
    /**
     * Owner Id
     */
    owner_id: string;
    /**
     * File
     */
    file_: Blob | File;
    /**
     * Commit Message
     *
     * Added {artefact.name}
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_get_artefact_start_post
 */
export type BodyStartBizArtefactManagementGetArtefactStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Revision
     */
    revision?: string | null;
};

/**
 * Body_start_biz_artefact_management_get_artefacts_tree_start_post
 */
export type BodyStartBizArtefactManagementGetArtefactsTreeStartPost = {
    /**
     * Artefact Group Id
     */
    artefact_group_id: string;
};

/**
 * Body_start_biz_artefact_management_get_history_start_post
 */
export type BodyStartBizArtefactManagementGetHistoryStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Offset
     */
    offset?: number;
};

/**
 * Body_start_biz_artefact_management_remove_artefact_group_start_post
 */
export type BodyStartBizArtefactManagementRemoveArtefactGroupStartPost = {
    /**
     * Artefact Group Id
     */
    artefact_group_id: string;
    /**
     * Commit Message
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_remove_artefact_start_post
 */
export type BodyStartBizArtefactManagementRemoveArtefactStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Commit Message
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_rename_artefact_group_start_post
 */
export type BodyStartBizArtefactManagementRenameArtefactGroupStartPost = {
    /**
     * Artefact Group Id
     */
    artefact_group_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Commit Message
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_rename_artefact_start_post
 */
export type BodyStartBizArtefactManagementRenameArtefactStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Commit Message
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_restore_historical_artefact_start_post
 */
export type BodyStartBizArtefactManagementRestoreHistoricalArtefactStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Revision
     */
    revision: string;
    /**
     * Commit Message
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_update_artefact_content_start_post
 */
export type BodyStartBizArtefactManagementUpdateArtefactContentStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * File
     */
    file_: Blob | File;
    /**
     * Commit Message
     *
     * Added {artefact.name}
     */
    commit_message?: string;
};

/**
 * Body_start_biz_artefact_management_update_artefact_start_post
 */
export type BodyStartBizArtefactManagementUpdateArtefactStartPost = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Content
     */
    content?: Blob | File | null;
    /**
     * Commit Message
     *
     * Added {artefact.name}
     */
    commit_message?: string;
};

/**
 * Body_start_biz_entities__entity_type___entity_id___attribute__restore_post
 */
export type BodyStartBizEntitiesEntityTypeEntityIdAttributeRestorePost = {
    /**
     * Revision
     */
    revision: string;
};

/**
 * Body_start_dev_application_entity_mgt_create_application_entity_start_post
 */
export type BodyStartDevApplicationEntityMgtCreateApplicationEntityStartPost = {
    /**
     * Application Id
     */
    application_id: string;
    /**
     * Name
     */
    name: string;
};

/**
 * Body_start_dev_application_entity_mgt_delete_application_entity_start_post
 */
export type BodyStartDevApplicationEntityMgtDeleteApplicationEntityStartPost = {
    /**
     * Application Entity Id
     */
    application_entity_id: string;
};

/**
 * Body_start_dev_application_entity_mgt_get_application_entities_start_post
 */
export type BodyStartDevApplicationEntityMgtGetApplicationEntitiesStartPost = {
    /**
     * Application Id
     */
    application_id: string;
};

/**
 * Body_start_dev_application_entity_mgt_link_business_entity_start_post
 */
export type BodyStartDevApplicationEntityMgtLinkBusinessEntityStartPost = {
    /**
     * Application Entity Id
     */
    application_entity_id: string;
    /**
     * Business Entity Id
     */
    business_entity_id: string;
    /**
     * Transformation Description
     */
    transformation_description?: string | null;
};

/**
 * Body_start_dev_application_entity_mgt_unlink_business_entity_start_post
 */
export type BodyStartDevApplicationEntityMgtUnlinkBusinessEntityStartPost = {
    /**
     * Application Entity Id
     */
    application_entity_id: string;
};

/**
 * Body_start_dev_application_entity_mgt_update_application_entity_start_post
 */
export type BodyStartDevApplicationEntityMgtUpdateApplicationEntityStartPost = {
    /**
     * Application Entity Id
     */
    application_entity_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Relationships
     */
    relationships?: Array<ApplicationEntityRelationship> | null;
};

/**
 * Body_start_dev_application_mgt_create_application_start_post
 */
export type BodyStartDevApplicationMgtCreateApplicationStartPost = {
    /**
     * Name
     */
    name: string;
    variant?: ApplicationVariant;
    /**
     * Responsible Role Id
     */
    responsible_role_id?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_dev_application_mgt_delete_application_start_post
 */
export type BodyStartDevApplicationMgtDeleteApplicationStartPost = {
    /**
     * Application Id
     */
    application_id: string;
};

/**
 * Body_start_dev_application_mgt_get_application_start_post
 */
export type BodyStartDevApplicationMgtGetApplicationStartPost = {
    /**
     * Application Id
     */
    application_id: string;
    /**
     * Revision
     */
    revision?: string | null;
};

/**
 * Body_start_dev_application_mgt_get_applications_by_domain_start_post
 */
export type BodyStartDevApplicationMgtGetApplicationsByDomainStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_dev_application_mgt_get_applications_by_process_start_post
 */
export type BodyStartDevApplicationMgtGetApplicationsByProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
};

/**
 * Body_start_dev_application_mgt_get_applications_by_product_start_post
 */
export type BodyStartDevApplicationMgtGetApplicationsByProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
};

/**
 * Body_start_dev_application_mgt_get_applications_grouped_by_domain_start_post
 */
export type BodyStartDevApplicationMgtGetApplicationsGroupedByDomainStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
};

/**
 * Body_start_dev_application_mgt_get_applications_grouped_by_process_start_post
 */
export type BodyStartDevApplicationMgtGetApplicationsGroupedByProcessStartPost = {
    /**
     * Product Id
     */
    product_id: string;
};

/**
 * Body_start_dev_application_mgt_get_applications_grouped_by_product_start_post
 */
export type BodyStartDevApplicationMgtGetApplicationsGroupedByProductStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_dev_application_mgt_link_process_task_to_application_start_post
 */
export type BodyStartDevApplicationMgtLinkProcessTaskToApplicationStartPost = {
    /**
     * Application Id
     */
    application_id: string;
    /**
     * Process Task Id
     */
    process_task_id: string;
    mode?: TaskLinkMode;
};

/**
 * Body_start_dev_application_mgt_promote_pool_to_role_start_post
 */
export type BodyStartDevApplicationMgtPromotePoolToRoleStartPost = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * Role Id
     */
    role_id?: string | null;
    /**
     * Rename From
     */
    rename_from?: Array<string> | null;
    /**
     * Proposal Fingerprint
     */
    proposal_fingerprint?: string | null;
    /**
     * Convert To Lane
     */
    convert_to_lane?: boolean;
};

/**
 * Body_start_dev_application_mgt_propose_pool_resolution_start_post
 */
export type BodyStartDevApplicationMgtProposePoolResolutionStartPost = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * Rename From
     */
    rename_from?: Array<string> | null;
    /**
     * Role Id
     */
    role_id?: string | null;
    /**
     * Application Id
     */
    application_id?: string | null;
};

/**
 * Body_start_dev_application_mgt_resolve_pool_as_application_start_post
 */
export type BodyStartDevApplicationMgtResolvePoolAsApplicationStartPost = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * Application Id
     */
    application_id: string;
    /**
     * Absorb Matching Roles
     */
    absorb_matching_roles?: boolean;
    /**
     * App Scope
     */
    app_scope?: string | null;
    /**
     * Proposal Fingerprint
     */
    proposal_fingerprint?: string | null;
    /**
     * Convert To Lane
     */
    convert_to_lane?: boolean;
};

/**
 * Body_start_dev_application_mgt_resolve_pool_as_party_start_post
 */
export type BodyStartDevApplicationMgtResolvePoolAsPartyStartPost = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * Party Id
     */
    party_id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    party_type?: PartyType | null;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * Body_start_dev_application_mgt_resolve_pool_as_reference_start_post
 */
export type BodyStartDevApplicationMgtResolvePoolAsReferenceStartPost = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * Entity Kind
     */
    entity_kind: string;
    /**
     * Entity Id
     */
    entity_id: string;
};

/**
 * Body_start_dev_application_mgt_set_pool_app_scope_start_post
 */
export type BodyStartDevApplicationMgtSetPoolAppScopeStartPost = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * App Scope
     */
    app_scope: string;
};

/**
 * Body_start_dev_application_mgt_unlink_process_task_from_application_start_post
 */
export type BodyStartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPost = {
    /**
     * Application Id
     */
    application_id: string;
    /**
     * Process Task Id
     */
    process_task_id: string;
};

/**
 * Body_start_dev_application_mgt_unresolve_pool_start_post
 */
export type BodyStartDevApplicationMgtUnresolvePoolStartPost = {
    /**
     * Pool Name
     */
    pool_name: string;
};

/**
 * Body_start_dev_application_mgt_update_application_start_post
 */
export type BodyStartDevApplicationMgtUpdateApplicationStartPost = {
    /**
     * Application Id
     */
    application_id: string;
    /**
     * Name
     */
    name?: string | null;
    variant?: ApplicationVariant | null;
    /**
     * Responsible Role Id
     */
    responsible_role_id?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_dev_build_mgt_create_build_ticket_start_post
 */
export type BodyStartDevBuildMgtCreateBuildTicketStartPost = {
    /**
     * Title
     */
    title: string;
    /**
     * Change Keys
     */
    change_keys: Array<string>;
};

/**
 * Body_start_dev_build_mgt_delete_build_ticket_start_post
 */
export type BodyStartDevBuildMgtDeleteBuildTicketStartPost = {
    /**
     * Ticket Identity
     */
    ticket_identity: string;
};

/**
 * Body_start_dev_build_mgt_get_change_detail_start_post
 */
export type BodyStartDevBuildMgtGetChangeDetailStartPost = {
    /**
     * Key
     */
    key: string;
};

/**
 * Body_start_dev_build_mgt_set_build_ticket_built_start_post
 */
export type BodyStartDevBuildMgtSetBuildTicketBuiltStartPost = {
    /**
     * Ticket Identity
     */
    ticket_identity: string;
    /**
     * Built
     */
    built: boolean;
};

/**
 * Body_start_dev_build_mgt_update_build_ticket_start_post
 */
export type BodyStartDevBuildMgtUpdateBuildTicketStartPost = {
    /**
     * Ticket Identity
     */
    ticket_identity: string;
    /**
     * Title
     */
    title?: string | null;
    /**
     * Change Keys
     */
    change_keys?: Array<string> | null;
};

/**
 * Body_start_dev_external_party_mgt_create_external_party_start_post
 */
export type BodyStartDevExternalPartyMgtCreateExternalPartyStartPost = {
    /**
     * Name
     */
    name: string;
    party_type?: PartyType;
    /**
     * Aliases
     */
    aliases?: Array<string> | null;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * Body_start_dev_external_party_mgt_delete_external_party_start_post
 */
export type BodyStartDevExternalPartyMgtDeleteExternalPartyStartPost = {
    /**
     * External Party Id
     */
    external_party_id: string;
};

/**
 * Body_start_dev_external_party_mgt_update_external_party_start_post
 */
export type BodyStartDevExternalPartyMgtUpdateExternalPartyStartPost = {
    /**
     * External Party Id
     */
    external_party_id: string;
    /**
     * Name
     */
    name?: string | null;
    party_type?: PartyType | null;
    /**
     * Aliases
     */
    aliases?: Array<string> | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Clear Description
     */
    clear_description?: boolean;
};

/**
 * Body_start_dev_triage_mgt_add_external_pool_start_post
 */
export type BodyStartDevTriageMgtAddExternalPoolStartPost = {
    /**
     * Issue Key
     */
    issue_key: string;
    /**
     * Proposal Fingerprint
     */
    proposal_fingerprint: string;
    /**
     * Party Id
     */
    party_id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    party_type?: PartyType | null;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * Body_start_dev_triage_mgt_convert_lane_to_pool_start_post
 */
export type BodyStartDevTriageMgtConvertLaneToPoolStartPost = {
    /**
     * Lanes
     */
    lanes: Array<TriageLaneTarget>;
    /**
     * Proposal Fingerprint
     */
    proposal_fingerprint: string;
};

/**
 * Body_start_dev_triage_mgt_convert_pool_to_lane_start_post
 */
export type BodyStartDevTriageMgtConvertPoolToLaneStartPost = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * Proposal Fingerprint
     */
    proposal_fingerprint: string;
};

/**
 * Body_start_dev_triage_mgt_dismiss_triage_issue_start_post
 */
export type BodyStartDevTriageMgtDismissTriageIssueStartPost = {
    /**
     * Issue Key
     */
    issue_key: string;
    /**
     * Fingerprint
     */
    fingerprint: string;
    /**
     * Reason
     */
    reason?: string | null;
};

/**
 * Body_start_dev_triage_mgt_link_lanes_to_application_start_post
 */
export type BodyStartDevTriageMgtLinkLanesToApplicationStartPost = {
    /**
     * Application Id
     */
    application_id: string;
    /**
     * Lanes
     */
    lanes: Array<TriageLaneTarget>;
    /**
     * Clear Role
     */
    clear_role?: boolean;
};

/**
 * Body_start_dev_triage_mgt_propose_restructure_start_post
 */
export type BodyStartDevTriageMgtProposeRestructureStartPost = {
    /**
     * Issue Key
     */
    issue_key: string;
};

/**
 * Body_start_dev_triage_mgt_reopen_triage_issue_start_post
 */
export type BodyStartDevTriageMgtReopenTriageIssueStartPost = {
    /**
     * Issue Key
     */
    issue_key: string;
};

/**
 * Body_start_dev_triage_mgt_resolve_named_recipient_start_post
 */
export type BodyStartDevTriageMgtResolveNamedRecipientStartPost = {
    /**
     * Issue Key
     */
    issue_key: string;
    /**
     * Resolution
     */
    resolution: string;
    /**
     * Application Id
     */
    application_id?: string | null;
    /**
     * Role Id
     */
    role_id?: string | null;
    /**
     * Entity Kind
     */
    entity_kind?: string | null;
    /**
     * Entity Id
     */
    entity_id?: string | null;
};

/**
 * Body_start_dev_triage_mgt_unify_lanes_start_post
 */
export type BodyStartDevTriageMgtUnifyLanesStartPost = {
    /**
     * Survivor Name
     */
    survivor_name: string;
    /**
     * Merge Names
     */
    merge_names: Array<string>;
    /**
     * Role Id
     */
    role_id?: string | null;
};

/**
 * Body_start_domain_business_entity_mgt_convert_to_domain_term_start_post
 */
export type BodyStartDomainBusinessEntityMgtConvertToDomainTermStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_create_business_entity_start_post
 */
export type BodyStartDomainBusinessEntityMgtCreateBusinessEntityStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Confidentiality Level
     */
    confidentiality_level?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Definition
     */
    definition?: Blob | File | null;
    /**
     * Relationships
     *
     * JSON string containing an array of relationship objects. Each relationship should have 'type', 'other_id', and 'direction' fields. Example: '[{"type": "depends on", "other_id": "entity2", "direction": "outgoing"}]'
     */
    relationships?: string | null;
};

/**
 * Body_start_domain_business_entity_mgt_create_business_rule_start_post
 */
export type BodyStartDomainBusinessEntityMgtCreateBusinessRuleStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
    /**
     * Title
     */
    title: string;
    /**
     * Content
     */
    content?: Blob | File | null;
};

/**
 * Body_start_domain_business_entity_mgt_delete_business_entity_start_post
 */
export type BodyStartDomainBusinessEntityMgtDeleteBusinessEntityStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_delete_business_rule_start_post
 */
export type BodyStartDomainBusinessEntityMgtDeleteBusinessRuleStartPost = {
    /**
     * Business Rule Id
     */
    business_rule_id: string;
    /**
     * Business Entity Id
     */
    business_entity_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_business_entities_by_process_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_business_entities_by_product_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_business_entities_grouped_by_domain_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_business_entities_grouped_by_process_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPost = {
    /**
     * Product Id
     */
    product_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_business_entities_grouped_by_product_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_business_entities_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetBusinessEntitiesStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_business_entity_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetBusinessEntityStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_business_rule_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetBusinessRuleStartPost = {
    /**
     * Business Rule Id
     */
    business_rule_id: string;
    /**
     * Business Entity Id
     */
    business_entity_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_cross_domain_links_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetCrossDomainLinksStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_get_linkable_business_entities_start_post
 */
export type BodyStartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_list_business_rules_start_post
 */
export type BodyStartDomainBusinessEntityMgtListBusinessRulesStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_remove_linked_concept_start_post
 */
export type BodyStartDomainBusinessEntityMgtRemoveLinkedConceptStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
    /**
     * Other Id
     */
    other_id: string;
};

/**
 * Body_start_domain_business_entity_mgt_update_business_entity_start_post
 */
export type BodyStartDomainBusinessEntityMgtUpdateBusinessEntityStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Confidentiality Level
     */
    confidentiality_level?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Definition
     */
    definition?: Blob | File | null;
    /**
     * Relationships
     *
     * JSON string containing an array of relationship objects. Each relationship should have 'type', 'other_id', and 'direction' fields. Example: '[{"type": "depends on", "other_id": "entity2", "direction": "outgoing"}]'
     */
    relationships?: string | null;
};

/**
 * Body_start_domain_business_entity_mgt_update_business_rule_start_post
 */
export type BodyStartDomainBusinessEntityMgtUpdateBusinessRuleStartPost = {
    /**
     * Business Rule Id
     */
    business_rule_id: string;
    /**
     * Business Entity Id
     */
    business_entity_id: string;
    /**
     * Title
     */
    title?: string | null;
    /**
     * Content
     */
    content?: Blob | File | null;
};

/**
 * Body_start_domain_business_entity_mgt_update_linked_concepts_start_post
 */
export type BodyStartDomainBusinessEntityMgtUpdateLinkedConceptsStartPost = {
    /**
     * Business Entity Id
     */
    business_entity_id: string;
    /**
     * Other Ids
     */
    other_ids?: Array<string>;
};

/**
 * Body_start_domain_domain_mgt_create_domain_start_post
 */
export type BodyStartDomainDomainMgtCreateDomainStartPost = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_domain_domain_mgt_delete_domain_start_post
 */
export type BodyStartDomainDomainMgtDeleteDomainStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_domain_domain_mgt_get_domain_start_post
 */
export type BodyStartDomainDomainMgtGetDomainStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_domain_domain_mgt_update_domain_orders_start_post
 */
export type BodyStartDomainDomainMgtUpdateDomainOrdersStartPost = {
    /**
     * Domain Ids
     */
    domain_ids: Array<string>;
};

/**
 * Body_start_domain_domain_mgt_update_domain_start_post
 */
export type BodyStartDomainDomainMgtUpdateDomainStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Order Index
     */
    order_index?: number | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_domain_domain_term_mgt_convert_to_business_entity_start_post
 */
export type BodyStartDomainDomainTermMgtConvertToBusinessEntityStartPost = {
    /**
     * Domain Term Id
     */
    domain_term_id: string;
};

/**
 * Body_start_domain_domain_term_mgt_create_domain_term_start_post
 */
export type BodyStartDomainDomainTermMgtCreateDomainTermStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_domain_domain_term_mgt_delete_domain_term_start_post
 */
export type BodyStartDomainDomainTermMgtDeleteDomainTermStartPost = {
    /**
     * Domain Term Id
     */
    domain_term_id: string;
};

/**
 * Body_start_domain_domain_term_mgt_get_domain_term_start_post
 */
export type BodyStartDomainDomainTermMgtGetDomainTermStartPost = {
    /**
     * Domain Term Id
     */
    domain_term_id: string;
};

/**
 * Body_start_domain_domain_term_mgt_get_domain_terms_start_post
 */
export type BodyStartDomainDomainTermMgtGetDomainTermsStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_domain_domain_term_mgt_update_domain_term_start_post
 */
export type BodyStartDomainDomainTermMgtUpdateDomainTermStartPost = {
    /**
     * Domain Term Id
     */
    domain_term_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_domain_role_mgt_create_role_start_post
 */
export type BodyStartDomainRoleMgtCreateRoleStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_domain_role_mgt_delete_role_start_post
 */
export type BodyStartDomainRoleMgtDeleteRoleStartPost = {
    /**
     * Role Id
     */
    role_id: string;
};

/**
 * Body_start_domain_role_mgt_get_role_start_post
 */
export type BodyStartDomainRoleMgtGetRoleStartPost = {
    /**
     * Role Id
     */
    role_id: string;
};

/**
 * Body_start_domain_role_mgt_get_roles_start_post
 */
export type BodyStartDomainRoleMgtGetRolesStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_domain_role_mgt_update_role_start_post
 */
export type BodyStartDomainRoleMgtUpdateRoleStartPost = {
    /**
     * Role Id
     */
    role_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_process_lane_mgt_get_lane_by_bpmn_id_start_post
 */
export type BodyStartProcessLaneMgtGetLaneByBpmnIdStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
};

/**
 * Body_start_process_lane_mgt_get_lane_by_role_id_start_post
 */
export type BodyStartProcessLaneMgtGetLaneByRoleIdStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Role Id
     */
    role_id: string;
};

/**
 * Body_start_process_lane_mgt_get_lane_start_post
 */
export type BodyStartProcessLaneMgtGetLaneStartPost = {
    /**
     * Lane Id
     */
    lane_id: string;
};

/**
 * Body_start_process_lane_mgt_get_lanes_by_process_start_post
 */
export type BodyStartProcessLaneMgtGetLanesByProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
};

/**
 * Body_start_process_process_element_mgt_archive_process_element_start_post
 */
export type BodyStartProcessProcessElementMgtArchiveProcessElementStartPost = {
    /**
     * Task Id
     */
    task_id: string;
};

/**
 * Body_start_process_process_element_mgt_delete_event_start_post
 */
export type BodyStartProcessProcessElementMgtDeleteEventStartPost = {
    /**
     * Event Id
     */
    event_id: string;
};

/**
 * Body_start_process_process_element_mgt_delete_flow_start_post
 */
export type BodyStartProcessProcessElementMgtDeleteFlowStartPost = {
    /**
     * Flow Id
     */
    flow_id: string;
};

/**
 * Body_start_process_process_element_mgt_delete_gateway_start_post
 */
export type BodyStartProcessProcessElementMgtDeleteGatewayStartPost = {
    /**
     * Gateway Id
     */
    gateway_id: string;
};

/**
 * Body_start_process_process_element_mgt_delete_task_start_post
 */
export type BodyStartProcessProcessElementMgtDeleteTaskStartPost = {
    /**
     * Task Id
     */
    task_id: string;
};

/**
 * Body_start_process_process_element_mgt_generate_user_interface_start_post
 */
export type BodyStartProcessProcessElementMgtGenerateUserInterfaceStartPost = {
    /**
     * Task Id
     */
    task_id: string;
};

/**
 * Body_start_process_process_element_mgt_get_event_start_post
 */
export type BodyStartProcessProcessElementMgtGetEventStartPost = {
    /**
     * Event Id
     */
    event_id: string;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_flow_start_post
 */
export type BodyStartProcessProcessElementMgtGetFlowStartPost = {
    /**
     * Flow Id
     */
    flow_id: string;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_gateway_start_post
 */
export type BodyStartProcessProcessElementMgtGetGatewayStartPost = {
    /**
     * Gateway Id
     */
    gateway_id: string;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_process_element_by_bpmn_id_start_post
 */
export type BodyStartProcessProcessElementMgtGetProcessElementByBpmnIdStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_process_elements_by_entity_start_post
 */
export type BodyStartProcessProcessElementMgtGetProcessElementsByEntityStartPost = {
    /**
     * Entity Id
     */
    entity_id: string;
};

/**
 * Body_start_process_process_element_mgt_get_process_elements_by_process_start_post
 */
export type BodyStartProcessProcessElementMgtGetProcessElementsByProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_process_elements_grouped_by_process_start_post
 */
export type BodyStartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_process_tasks_by_stek_start_post
 */
export type BodyStartProcessProcessElementMgtGetProcessTasksByStekStartPost = {
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_get_task_start_post
 */
export type BodyStartProcessProcessElementMgtGetTaskStartPost = {
    /**
     * Task Id
     */
    task_id: string;
    /**
     * Include Archived
     */
    include_archived?: boolean;
};

/**
 * Body_start_process_process_element_mgt_unarchive_process_element_start_post
 */
export type BodyStartProcessProcessElementMgtUnarchiveProcessElementStartPost = {
    /**
     * Process Element Id
     */
    process_element_id: string;
};

/**
 * Body_start_process_process_element_mgt_update_event_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateEventStartPost = {
    /**
     * Event Id
     */
    event_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_process_process_element_mgt_update_flow_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateFlowStartPost = {
    /**
     * Flow Id
     */
    flow_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_process_process_element_mgt_update_gateway_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateGatewayStartPost = {
    /**
     * Gateway Id
     */
    gateway_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_process_process_element_mgt_update_process_element_entity_refs_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPost = {
    /**
     * Process Element Id
     */
    process_element_id: string;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
};

/**
 * Body_start_process_process_element_mgt_update_task_evidence_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateTaskEvidenceStartPost = {
    /**
     * Task Id
     */
    task_id: string;
    /**
     * Generates Evidence
     */
    generates_evidence: boolean;
    /**
     * Evidence Instructions
     */
    evidence_instructions?: Blob | File | null;
};

/**
 * Body_start_process_process_element_mgt_update_task_start_post
 */
export type BodyStartProcessProcessElementMgtUpdateTaskStartPost = {
    /**
     * Task Id
     */
    task_id: string;
    /**
     * Bpmn Id
     */
    bpmn_id?: string | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Ui Code
     */
    ui_code?: Blob | File | null;
};

/**
 * Body_start_process_process_mgt_create_process_start_post
 */
export type BodyStartProcessProcessMgtCreateProcessStartPost = {
    /**
     * Product Id
     */
    product_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Process Definition
     */
    process_definition?: Blob | File | null;
};

/**
 * Body_start_process_process_mgt_delete_process_start_post
 */
export type BodyStartProcessProcessMgtDeleteProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
};

/**
 * Body_start_process_process_mgt_deploy_process_start_post
 */
export type BodyStartProcessProcessMgtDeployProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Definition Path
     */
    definition_path: string;
};

/**
 * Body_start_process_process_mgt_get_process_diagram_start_post
 */
export type BodyStartProcessProcessMgtGetProcessDiagramStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Revision
     */
    revision?: string | null;
};

/**
 * Body_start_process_process_mgt_get_process_start_post
 */
export type BodyStartProcessProcessMgtGetProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
};

/**
 * Body_start_process_process_mgt_get_process_thumbnails_by_product_start_post
 */
export type BodyStartProcessProcessMgtGetProcessThumbnailsByProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
};

/**
 * Body_start_process_process_mgt_get_processes_by_product_start_post
 */
export type BodyStartProcessProcessMgtGetProcessesByProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
};

/**
 * Body_start_process_process_mgt_move_process_start_post
 */
export type BodyStartProcessProcessMgtMoveProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Target Product Id
     */
    target_product_id: string;
};

/**
 * Body_start_process_process_mgt_update_process_orders_start_post
 */
export type BodyStartProcessProcessMgtUpdateProcessOrdersStartPost = {
    /**
     * Process Ids
     */
    process_ids: Array<string>;
};

/**
 * Body_start_process_process_mgt_update_process_start_post
 */
export type BodyStartProcessProcessMgtUpdateProcessStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Order Index
     */
    order_index?: number | null;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Process Definition
     */
    process_definition?: Blob | File | null;
};

/**
 * Body_start_product_product_mgt_create_product_start_post
 */
export type BodyStartProductProductMgtCreateProductStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_product_product_mgt_delete_product_start_post
 */
export type BodyStartProductProductMgtDeleteProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
};

/**
 * Body_start_product_product_mgt_get_product_start_post
 */
export type BodyStartProductProductMgtGetProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
};

/**
 * Body_start_product_product_mgt_get_products_by_domain_start_post
 */
export type BodyStartProductProductMgtGetProductsByDomainStartPost = {
    /**
     * Domain Id
     */
    domain_id: string;
};

/**
 * Body_start_product_product_mgt_move_product_start_post
 */
export type BodyStartProductProductMgtMoveProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
    /**
     * Target Domain Id
     */
    target_domain_id: string;
};

/**
 * Body_start_product_product_mgt_update_product_orders_start_post
 */
export type BodyStartProductProductMgtUpdateProductOrdersStartPost = {
    /**
     * Product Ids
     */
    product_ids: Array<string>;
};

/**
 * Body_start_product_product_mgt_update_product_start_post
 */
export type BodyStartProductProductMgtUpdateProductStartPost = {
    /**
     * Product Id
     */
    product_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Order Index
     */
    order_index?: number | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_stek_live_mgt_get_compliance_evidence_start_post
 */
export type BodyStartStekLiveMgtGetComplianceEvidenceStartPost = {
    /**
     * Process Instance Id
     */
    process_instance_id: string;
    /**
     * Hours
     */
    hours?: number;
};

/**
 * Body_start_stek_live_mgt_get_element_metrics_start_post
 */
export type BodyStartStekLiveMgtGetElementMetricsStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Hours
     */
    hours?: number;
    /**
     * Start Time
     */
    start_time?: Date | null;
    /**
     * End Time
     */
    end_time?: Date | null;
    /**
     * Stek Release
     */
    stek_release?: string | null;
};

/**
 * Body_start_stek_live_mgt_get_metrics_start_post
 */
export type BodyStartStekLiveMgtGetMetricsStartPost = {
    /**
     * Stek Id
     */
    stek_id?: string | null;
    /**
     * Domain Id
     */
    domain_id?: string | null;
    /**
     * Product Id
     */
    product_id?: string | null;
    /**
     * Process Id
     */
    process_id?: string | null;
    /**
     * Hours
     */
    hours?: number;
    /**
     * Start Time
     */
    start_time?: Date | null;
    /**
     * End Time
     */
    end_time?: Date | null;
    /**
     * Stek Release
     */
    stek_release?: string | null;
};

/**
 * Body_start_stek_live_mgt_get_process_instances_start_post
 */
export type BodyStartStekLiveMgtGetProcessInstancesStartPost = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Hours
     */
    hours?: number;
    /**
     * Start Time
     */
    start_time?: Date | null;
    /**
     * End Time
     */
    end_time?: Date | null;
    /**
     * Stek Release
     */
    stek_release?: string | null;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Offset
     */
    offset?: number;
};

/**
 * Body_start_stek_live_mgt_get_recent_activity_start_post
 */
export type BodyStartStekLiveMgtGetRecentActivityStartPost = {
    /**
     * Stek Id
     */
    stek_id?: string | null;
    /**
     * Domain Id
     */
    domain_id?: string | null;
    /**
     * Product Id
     */
    product_id?: string | null;
    /**
     * Process Id
     */
    process_id?: string | null;
    /**
     * Process Instance Id
     */
    process_instance_id?: string | null;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Offset
     */
    offset?: number;
    /**
     * Hours
     */
    hours?: number | null;
    /**
     * Stek Release
     */
    stek_release?: string | null;
};

/**
 * Body_start_stek_live_mgt_ingest_event_start_post
 */
export type BodyStartStekLiveMgtIngestEventStartPost = {
    /**
     * Stek Release
     */
    stek_release: string;
    /**
     * Event Type
     */
    event_type?: string;
    payload?: IngestEventPayload;
    /**
     * Timestamp
     */
    timestamp?: Date | null;
    /**
     * Process Instance Id
     */
    process_instance_id?: string | null;
    /**
     * Domain Id
     */
    domain_id?: string | null;
    /**
     * Product Id
     */
    product_id?: string | null;
    /**
     * Process Id
     */
    process_id?: string | null;
    /**
     * Process Element Id
     */
    process_element_id?: string | null;
    /**
     * Business Key
     */
    business_key?: string | null;
};

/**
 * Body_start_stek_stek_mgt_create_stek_start_post
 */
export type BodyStartStekStekMgtCreateStekStartPost = {
    /**
     * Name
     */
    name: string;
    /**
     * Fqdn
     */
    fqdn?: string;
    /**
     * Logo
     */
    logo?: Blob | File | null;
    /**
     * Description
     */
    description?: Blob | File | null;
};

/**
 * Body_start_stek_stek_mgt_generate_stek_details_start_post
 */
export type BodyStartStekStekMgtGenerateStekDetailsStartPost = {
    /**
     * Sources
     */
    sources: Array<string>;
    /**
     * Stek Id
     */
    stek_id: string;
};

/**
 * Body_start_stek_stek_mgt_import_stek_start_post
 */
export type BodyStartStekStekMgtImportStekStartPost = {
    /**
     * File
     */
    file: Blob | File;
    /**
     * Name
     */
    name?: string | null;
};

/**
 * Body_start_stek_stek_mgt_manage_stek_start_post
 */
export type BodyStartStekStekMgtManageStekStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Dev Mode Enabled
     */
    dev_mode_enabled?: boolean | null;
};

/**
 * Body_start_stek_stek_mgt_update_stek_start_post
 */
export type BodyStartStekStekMgtUpdateStekStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Logo
     */
    logo?: Blob | File | null;
    /**
     * Description
     */
    description?: Blob | File | null;
    /**
     * Mission
     */
    mission?: Blob | File | null;
    /**
     * Vision
     */
    vision?: Blob | File | null;
    /**
     * Core Values
     */
    core_values?: Blob | File | null;
    /**
     * Specializations
     */
    specializations?: Blob | File | null;
    /**
     * Target Markets
     */
    target_markets?: Blob | File | null;
    /**
     * Fqdn
     */
    fqdn?: string | null;
};

/**
 * Body_start_stek_stek_mgt_update_strategy_start_post
 */
export type BodyStartStekStekMgtUpdateStrategyStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Mission Vision
     */
    mission_vision: Blob | File;
};

/**
 * Body_start_stek_stek_release_mgt_get_release_start_post
 */
export type BodyStartStekStekReleaseMgtGetReleaseStartPost = {
    /**
     * Release Name
     */
    release_name: string;
};

/**
 * Body_start_strategy_strategy_mgt_accept_proposed_competitor_start_post
 */
export type BodyStartStrategyStrategyMgtAcceptProposedCompetitorStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Entry Id
     */
    entry_id: string;
    /**
     * Action Index
     */
    action_index: number;
};

/**
 * Body_start_strategy_strategy_mgt_create_competitor_start_post
 */
export type BodyStartStrategyStrategyMgtCreateCompetitorStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Is Group
     */
    is_group?: boolean;
    /**
     * Position
     */
    position?: string | null;
    /**
     * Profile
     */
    profile?: string | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Their Position
     */
    their_position?: string | null;
    /**
     * Where We Win
     */
    where_we_win?: string | null;
    /**
     * Threat Level
     */
    threat_level?: string;
    /**
     * Sources
     */
    sources?: Array<string> | null;
};

/**
 * Body_start_strategy_strategy_mgt_create_objective_start_post
 */
export type BodyStartStrategyStrategyMgtCreateObjectiveStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Key Results
     */
    key_results?: Array<KeyResultInput>;
};

/**
 * Body_start_strategy_strategy_mgt_create_trend_start_post
 */
export type BodyStartStrategyStrategyMgtCreateTrendStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Direction
     */
    direction?: string;
    /**
     * Sources
     */
    sources?: Array<string> | null;
};

/**
 * Body_start_strategy_strategy_mgt_create_watcher_start_post
 */
export type BodyStartStrategyStrategyMgtCreateWatcherStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Watcher Type
     */
    watcher_type?: string;
    /**
     * Interval
     */
    interval?: string;
};

/**
 * Body_start_strategy_strategy_mgt_decline_proposed_competitor_start_post
 */
export type BodyStartStrategyStrategyMgtDeclineProposedCompetitorStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Entry Id
     */
    entry_id: string;
    /**
     * Action Index
     */
    action_index: number;
};

/**
 * Body_start_strategy_strategy_mgt_delete_competitor_start_post
 */
export type BodyStartStrategyStrategyMgtDeleteCompetitorStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Competitor Id
     */
    competitor_id: string;
};

/**
 * Body_start_strategy_strategy_mgt_delete_objective_start_post
 */
export type BodyStartStrategyStrategyMgtDeleteObjectiveStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Objective Id
     */
    objective_id: string;
};

/**
 * Body_start_strategy_strategy_mgt_delete_trend_start_post
 */
export type BodyStartStrategyStrategyMgtDeleteTrendStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Trend Id
     */
    trend_id: string;
};

/**
 * Body_start_strategy_strategy_mgt_delete_watcher_start_post
 */
export type BodyStartStrategyStrategyMgtDeleteWatcherStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Watcher Id
     */
    watcher_id: string;
};

/**
 * Body_start_strategy_strategy_mgt_get_competitor_history_start_post
 */
export type BodyStartStrategyStrategyMgtGetCompetitorHistoryStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Competitor Id
     */
    competitor_id: string;
};

/**
 * Body_start_strategy_strategy_mgt_get_horizons_start_post
 */
export type BodyStartStrategyStrategyMgtGetHorizonsStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
};

/**
 * Body_start_strategy_strategy_mgt_get_market_start_post
 */
export type BodyStartStrategyStrategyMgtGetMarketStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
};

/**
 * Body_start_strategy_strategy_mgt_get_objectives_start_post
 */
export type BodyStartStrategyStrategyMgtGetObjectivesStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
};

/**
 * Body_start_strategy_strategy_mgt_get_proposed_competitors_start_post
 */
export type BodyStartStrategyStrategyMgtGetProposedCompetitorsStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
};

/**
 * Body_start_strategy_strategy_mgt_get_watchers_start_post
 */
export type BodyStartStrategyStrategyMgtGetWatchersStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
};

/**
 * Body_start_strategy_strategy_mgt_update_competitor_start_post
 */
export type BodyStartStrategyStrategyMgtUpdateCompetitorStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Competitor Id
     */
    competitor_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Is Group
     */
    is_group?: boolean | null;
    /**
     * Position
     */
    position?: string | null;
    /**
     * Profile
     */
    profile?: string | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Their Position
     */
    their_position?: string | null;
    /**
     * Where We Win
     */
    where_we_win?: string | null;
    /**
     * Threat Level
     */
    threat_level?: string | null;
    /**
     * Sources
     */
    sources?: Array<string> | null;
    /**
     * What Changed
     */
    what_changed?: string | null;
};

/**
 * Body_start_strategy_strategy_mgt_update_horizons_start_post
 */
export type BodyStartStrategyStrategyMgtUpdateHorizonsStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Horizons
     */
    horizons: Blob | File;
};

/**
 * Body_start_strategy_strategy_mgt_update_objective_start_post
 */
export type BodyStartStrategyStrategyMgtUpdateObjectiveStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Objective Id
     */
    objective_id: string;
    /**
     * Title
     */
    title?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Key Results
     */
    key_results?: Array<KeyResultInput> | null;
};

/**
 * Body_start_strategy_strategy_mgt_update_trend_start_post
 */
export type BodyStartStrategyStrategyMgtUpdateTrendStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Trend Id
     */
    trend_id: string;
    /**
     * Title
     */
    title?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Direction
     */
    direction?: string | null;
    /**
     * Sources
     */
    sources?: Array<string> | null;
};

/**
 * Body_start_strategy_strategy_mgt_update_watcher_start_post
 */
export type BodyStartStrategyStrategyMgtUpdateWatcherStartPost = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Watcher Id
     */
    watcher_id: string;
    /**
     * Title
     */
    title?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Interval
     */
    interval?: string | null;
    /**
     * Enabled
     */
    enabled?: boolean | null;
};

/**
 * Body_start_thread_thread_mgt_catch_up_start_post
 */
export type BodyStartThreadThreadMgtCatchUpStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
};

/**
 * Body_start_thread_thread_mgt_contribute_to_thread_start_post
 */
export type BodyStartThreadThreadMgtContributeToThreadStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Content
     */
    content: string;
    /**
     * Source Type
     */
    source_type?: string;
    /**
     * Source Name
     */
    source_name?: string | null;
    /**
     * Context Items
     */
    context_items?: Array<ThreadContextItem> | null;
};

/**
 * Body_start_thread_thread_mgt_create_thread_start_post
 */
export type BodyStartThreadThreadMgtCreateThreadStartPost = {
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description?: string | null;
    kind?: ThreadKind | null;
    /**
     * Subject Entity Type
     */
    subject_entity_type?: string | null;
    /**
     * Subject Entity Id
     */
    subject_entity_id?: string | null;
    /**
     * Context Items
     */
    context_items?: Array<ThreadContextItem> | null;
};

/**
 * Body_start_thread_thread_mgt_delete_thread_file_start_post
 */
export type BodyStartThreadThreadMgtDeleteThreadFileStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * File Id
     */
    file_id: string;
};

/**
 * Body_start_thread_thread_mgt_generate_accept_message_start_post
 */
export type BodyStartThreadThreadMgtGenerateAcceptMessageStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
};

/**
 * Body_start_thread_thread_mgt_get_thread_file_start_post
 */
export type BodyStartThreadThreadMgtGetThreadFileStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * File Id
     */
    file_id: string;
};

/**
 * Body_start_thread_thread_mgt_get_thread_start_post
 */
export type BodyStartThreadThreadMgtGetThreadStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Include Entries
     */
    include_entries?: boolean;
    /**
     * Since Sequence
     */
    since_sequence?: number | null;
};

/**
 * Body_start_thread_thread_mgt_list_thread_user_changes_start_post
 */
export type BodyStartThreadThreadMgtListThreadUserChangesStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
};

/**
 * Body_start_thread_thread_mgt_read_entity_versions_start_post
 */
export type BodyStartThreadThreadMgtReadEntityVersionsStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Entity Type
     */
    entity_type: string;
    /**
     * Entity Id
     */
    entity_id: string;
};

/**
 * Body_start_thread_thread_mgt_resolve_conflict_start_post
 */
export type BodyStartThreadThreadMgtResolveConflictStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Entity Type
     */
    entity_type: string;
    /**
     * Entity Id
     */
    entity_id: string;
    /**
     * Resolution
     */
    resolution: string;
    /**
     * Content
     */
    content?: string | null;
};

/**
 * Body_start_thread_thread_mgt_resolve_safe_conflicts_start_post
 */
export type BodyStartThreadThreadMgtResolveSafeConflictsStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
};

/**
 * Body_start_thread_thread_mgt_resolve_thread_start_post
 */
export type BodyStartThreadThreadMgtResolveThreadStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Action
     */
    action: string;
    /**
     * Reason
     */
    reason: string;
    /**
     * Why
     */
    why?: string | null;
};

/**
 * Body_start_thread_thread_mgt_respond_to_proposal_start_post
 */
export type BodyStartThreadThreadMgtRespondToProposalStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Entry Id
     */
    entry_id: string;
    /**
     * Response
     */
    response: 'confirm' | 'cancel';
};

/**
 * Body_start_thread_thread_mgt_set_auto_apply_start_post
 */
export type BodyStartThreadThreadMgtSetAutoApplyStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Enabled
     */
    enabled: boolean;
};

/**
 * Body_start_thread_thread_mgt_unresolve_conflict_start_post
 */
export type BodyStartThreadThreadMgtUnresolveConflictStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Entity Type
     */
    entity_type: string;
    /**
     * Entity Id
     */
    entity_id: string;
};

/**
 * Body_start_thread_thread_mgt_upload_thread_file_start_post
 */
export type BodyStartThreadThreadMgtUploadThreadFileStartPost = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * File
     */
    file_: Blob | File;
};

/**
 * Body_start_workspace_worktree_mgt_get_worktree_start_post
 */
export type BodyStartWorkspaceWorktreeMgtGetWorktreeStartPost = {
    /**
     * Workspace Id
     */
    workspace_id: string;
    /**
     * Revision
     */
    revision?: string | null;
    /**
     * Revision Entity Type
     */
    revision_entity_type?: string | null;
    /**
     * Revision Entity Id
     */
    revision_entity_id?: string | null;
};

/**
 * Body_test_integration_connection_stek_integration_mgt_integration_test__integration_type__post
 */
export type BodyTestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePost = {
    /**
     * Api Key
     */
    api_key: string;
    /**
     * Host
     */
    host?: string | null;
};

/**
 * Body_token_endpoint_integrations_oauth2_server_token_post
 */
export type BodyTokenEndpointIntegrationsOauth2ServerTokenPost = {
    /**
     * Grant Type
     */
    grant_type: string;
    /**
     * Code
     */
    code?: string | null;
    /**
     * Redirect Uri
     */
    redirect_uri?: string | null;
    /**
     * Code Verifier
     */
    code_verifier?: string | null;
    /**
     * Client Id
     */
    client_id?: string | null;
    /**
     * Refresh Token
     */
    refresh_token?: string | null;
};

/**
 * Body_upload_media__whats_new_whats_new_mgt_uploads_post
 */
export type BodyUploadMediaWhatsNewWhatsNewMgtUploadsPost = {
    /**
     * File
     */
    file: Blob | File;
};

/**
 * BuildTicket
 *
 * API schema for one build ticket.
 *
 * No ``deleted`` field: a tombstoned ticket never reaches the wire — the read
 * drops it and the write endpoints only ever return a live ticket — so exposing
 * the flag would only invite a client to render one.
 */
export type BuildTicket = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Number
     */
    number: number;
    /**
     * Title
     */
    title: string;
    /**
     * Changes
     */
    changes?: Array<BuildTicketChange>;
    /**
     * Status
     */
    status?: 'open' | 'built';
    /**
     * Created By Email
     */
    created_by_email?: string;
    /**
     * Created By Name
     */
    created_by_name?: string;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Built By Email
     */
    built_by_email?: string | null;
    /**
     * Built By Name
     */
    built_by_name?: string | null;
    /**
     * Built At
     */
    built_at?: Date | null;
};

/**
 * BuildTicketChange
 *
 * API schema for one drift key a build ticket covers.
 */
export type BuildTicketChange = {
    /**
     * Key
     */
    key: string;
    /**
     * Name
     */
    name?: string;
    level?: DriftLevel | null;
    /**
     * Built Fingerprint
     */
    built_fingerprint?: string;
};

/**
 * BusinessEntity
 *
 * Business entity response.
 */
export type BusinessEntity = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    confidentiality_level?: ConfidentialityLevel | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    definition?: Artefact | null;
    /**
     * Attribute Count
     */
    attribute_count?: number;
    /**
     * Relationships
     */
    relationships: Array<BusinessEntityRelationship>;
    /**
     * Linked Concepts
     */
    linked_concepts?: Array<BusinessEntityLink>;
};

/**
 * BusinessEntityInTree
 *
 * Business entity representation inside worktree.
 */
export type BusinessEntityInTree = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
};

/**
 * BusinessEntityLink
 *
 * A directional, untyped cross-domain linked concept for API requests/responses.
 */
export type BusinessEntityLink = {
    /**
     * Other Id
     */
    other_id: string;
    direction: RelationshipDirection;
};

/**
 * BusinessEntityRelationship
 *
 * Business entity relationship for API requests/responses.
 */
export type BusinessEntityRelationship = {
    /**
     * Type
     */
    type: string;
    /**
     * Other Id
     */
    other_id: string;
    direction: RelationshipDirection;
};

/**
 * BusinessRule
 *
 * API schema for a BusinessRule.
 */
export type BusinessRule = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Business Entity Id
     */
    business_entity_id: string;
    /**
     * Number
     */
    number: number;
    /**
     * Title
     */
    title: string;
    content?: Artefact | null;
};

/**
 * CancelSubscriptionResponse
 */
export type CancelSubscriptionResponse = {
    /**
     * Feature Key
     */
    feature_key: string;
    /**
     * Status
     */
    status: string;
    /**
     * Period End
     */
    period_end: Date | null;
    /**
     * Message
     */
    message: string;
};

/**
 * CatchUpResultSchema
 *
 * Outcome of catching a thread branch up with main.
 *
 * Returned by the open/view catch-up endpoint so the client can decide what to
 * refresh: ``caught_up`` (master changes were merged into the branch — refetch
 * + re-sync the worktree), ``absorbed`` (no merge, but a conflicted/held-back
 * repo copied main's non-conflicting changes onto the branch — content moved,
 * so refetch just the same), ``has_conflicts`` (the catch-up is blocked — show
 * the behind-main banner). ``already_current`` means nothing moved AT ALL (a
 * true no-op probe) — never set when an absorb landed.
 */
export type CatchUpResultSchema = {
    /**
     * Caught Up
     */
    caught_up?: boolean;
    /**
     * Already Current
     */
    already_current?: boolean;
    /**
     * Has Conflicts
     */
    has_conflicts?: boolean;
    /**
     * Absorbed
     */
    absorbed?: boolean;
};

/**
 * ChangeOrgFeatureSubscriptionRequest
 *
 * Body for PATCH /admin/organizations/{org_id}/features/{feature}/subscription.
 */
export type ChangeOrgFeatureSubscriptionRequest = {
    /**
     * Plan Tier
     */
    plan_tier?: string;
    /**
     * Price Per Unit
     */
    price_per_unit?: number | null;
    /**
     * Reason
     */
    reason?: string | null;
};

/**
 * ChangeOrgFeatureSubscriptionResponse
 *
 * Wrapper returned by the override endpoint: the updated org + any warnings.
 */
export type ChangeOrgFeatureSubscriptionResponse = {
    org: OrgAdminRow;
    /**
     * Warnings
     */
    warnings: Array<string>;
};

/**
 * ChangedProcessElementInfo
 *
 * API schema for one element named by a diagram change.
 */
export type ChangedProcessElementInfo = {
    /**
     * Name
     */
    name: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Lane Bpmn Id
     */
    lane_bpmn_id?: string | null;
    /**
     * Element Type
     */
    element_type?: string;
};

/**
 * CheckoutSessionRequest
 */
export type CheckoutSessionRequest = {
    /**
     * Feature Id
     */
    feature_id: string;
    /**
     * Tier Id
     */
    tier_id?: string | null;
    /**
     * Variant Id
     */
    variant_id?: string | null;
    /**
     * Success Path
     */
    success_path?: string | null;
};

/**
 * CheckoutSessionResponse
 */
export type CheckoutSessionResponse = {
    /**
     * Checkout Url
     */
    checkout_url: string;
    /**
     * Session Id
     */
    session_id: string;
};

/**
 * ClientRegistrationRequest
 *
 * Client registration request.
 */
export type ClientRegistrationRequest = {
    /**
     * Redirect Uris
     */
    redirect_uris: Array<string>;
    /**
     * Client Name
     */
    client_name?: string | null;
    /**
     * Scope
     */
    scope?: string | null;
    /**
     * Token Endpoint Auth Method
     */
    token_endpoint_auth_method?: string;
    /**
     * Grant Types
     */
    grant_types?: Array<string>;
    /**
     * Response Types
     */
    response_types?: Array<string>;
};

/**
 * ClusterRole
 *
 * The role of the user across the organization.
 */
export enum ClusterRole {
    USER = 'user',
    STEK_MANAGER = 'stek-manager',
    USER_MANAGER = 'user-manager',
    ORGANIZATION_MANAGER = 'organization-manager',
    VIEWER = 'viewer'
}

/**
 * Competitor
 *
 * Response body for a Competitor.
 */
export type Competitor = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Is Group
     */
    is_group?: boolean;
    /**
     * Position
     */
    position?: string | null;
    /**
     * Profile
     */
    profile?: string | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Their Position
     */
    their_position?: string | null;
    /**
     * Where We Win
     */
    where_we_win?: string | null;
    /**
     * Threat Level
     */
    threat_level: string;
    /**
     * Sources
     */
    sources?: Array<string>;
    /**
     * Checked At
     */
    checked_at?: Date | null;
    /**
     * What Changed
     */
    what_changed?: string | null;
    /**
     * Order Index
     */
    order_index?: number;
};

/**
 * CompetitorChange
 *
 * One moment in a competitor's life, read out of market.json's history.
 */
export type CompetitorChange = {
    /**
     * Revision
     */
    revision: string;
    /**
     * Kind
     */
    kind: string;
    /**
     * Author
     */
    author?: string | null;
    /**
     * Changed At
     */
    changed_at?: string | null;
    /**
     * Summary
     */
    summary?: string | null;
    /**
     * Fields
     */
    fields?: Array<string>;
};

/**
 * ComplianceEvidenceItem
 *
 * A single compliance evidence item in the event payload.
 *
 * Represents proof of task/process execution for audit purposes.
 */
export type ComplianceEvidenceItem = {
    /**
     * Id
     *
     * Unique identifier for this evidence item
     */
    id: string;
    /**
     * Type of evidence: 'uri' (link to document) or 'description' (text proof)
     */
    type: ComplianceEvidenceType;
    /**
     * Value
     *
     * The evidence content: URL for 'uri' type, text description for 'description' type
     */
    value: string;
    /**
     * Description
     *
     * Human-readable description of what this evidence proves
     */
    description: string;
    /**
     * Timestamp
     *
     * When this evidence was created (ISO 8601 format)
     */
    timestamp: Date;
    /**
     * Created By
     *
     * User ID or email of who created this evidence
     */
    created_by?: string | null;
};

/**
 * ComplianceEvidenceType
 *
 * Types of compliance evidence.
 *
 * URI: Link to external evidence (documents, screenshots, etc.)
 * DESCRIPTION: Text description of evidence
 */
export enum ComplianceEvidenceType {
    URI = 'uri',
    DESCRIPTION = 'description'
}

/**
 * ComplianceEvidenceView
 *
 * View model for compliance evidence with event context.
 */
export type ComplianceEvidenceView = {
    /**
     * Id
     */
    id: string;
    /**
     * Type
     */
    type: string;
    /**
     * Value
     */
    value: string;
    /**
     * Description
     */
    description: string;
    /**
     * Timestamp
     */
    timestamp: Date;
    /**
     * Created By
     */
    created_by: string | null;
    /**
     * Event Id
     */
    event_id: string;
    /**
     * Event Type
     */
    event_type: string;
    /**
     * Event Timestamp
     */
    event_timestamp: Date;
    /**
     * Process Instance Id
     */
    process_instance_id: string;
    /**
     * Business Key
     */
    business_key: string | null;
    /**
     * Process Element Id
     */
    process_element_id: string | null;
    /**
     * Process Element Name
     */
    process_element_name: string | null;
};

/**
 * ComplianceOverview
 *
 * Everything the Compliance page shows in one read.
 */
export type ComplianceOverview = {
    /**
     * Stek Id
     */
    stek_id: string;
    scope?: ScopeSelector;
    /**
     * Assessments
     */
    assessments?: Array<Assessment>;
    /**
     * Open Questions
     */
    open_questions?: number;
    /**
     * Source Count
     */
    source_count?: number;
    /**
     * Attention
     */
    attention?: Array<string>;
    /**
     * Requirements
     */
    requirements?: Array<Requirement>;
    refresh: RefreshStatus;
    freshness: Freshness;
    view?: EvidenceView;
    /**
     * Thread Preview
     */
    thread_preview?: boolean;
    /**
     * Empty
     */
    empty?: boolean;
};

/**
 * ComplianceProof
 *
 * Container for compliance evidence in event payload.
 *
 * Events can include one or more pieces of evidence to prove compliance
 * with controls, requirements, or audit needs.
 */
export type ComplianceProof = {
    /**
     * Evidence
     *
     * List of evidence items attached to this event
     */
    evidence: Array<ComplianceEvidenceItem>;
    /**
     * Metadata
     *
     * Optional metadata about the compliance proof
     */
    metadata?: {
        [key: string]: string;
    };
};

/**
 * Confidence
 */
export enum Confidence {
    HIGH = 'high',
    MEDIUM = 'medium',
    LOW = 'low'
}

/**
 * ConfidentialityLevel
 *
 * Data confidentiality classification for a business entity.
 */
export enum ConfidentialityLevel {
    PUBLIC = 'public',
    INTERNAL = 'internal',
    CONFIDENTIAL = 'confidential',
    RESTRICTED = 'restricted'
}

/**
 * ConflictAiHintsSchema
 *
 * Facilitator triage for a pending conflict (869dyvvta). Nullable end-to-end.
 */
export type ConflictAiHintsSchema = {
    /**
     * Recommend
     */
    recommend: string;
    /**
     * Confidence
     */
    confidence: string;
    /**
     * Safe
     */
    safe?: boolean;
    /**
     * Reason
     */
    reason?: string;
};

/**
 * ConflictContextSchema
 *
 * Where a conflicted entity lives + what depends on it (for the reconcile page).
 */
export type ConflictContextSchema = {
    /**
     * Path
     */
    path?: Array<string>;
    /**
     * Referenced By Count
     */
    referenced_by_count?: number;
    /**
     * Shown On
     */
    shown_on?: string | null;
};

/**
 * ConflictProvenanceSchema
 */
export type ConflictProvenanceSchema = {
    main?: ConflictSideProvenanceSchema | null;
    thread?: ConflictSideProvenanceSchema | null;
};

/**
 * ConflictRecordSchema
 */
export type ConflictRecordSchema = {
    /**
     * Repo
     */
    repo: string;
    /**
     * Entity Type
     */
    entity_type: string;
    /**
     * Entity Id
     */
    entity_id: string;
    /**
     * Name
     */
    name?: string;
    /**
     * Conflict Kind
     */
    conflict_kind: string;
    /**
     * Renamed On
     */
    renamed_on?: string | null;
    /**
     * Files
     */
    files?: Array<string>;
    /**
     * Status
     */
    status?: string;
    /**
     * Resolution
     */
    resolution?: string | null;
    decided_by?: EntrySourceSchema | null;
    /**
     * Decided At
     */
    decided_at?: Date | null;
    /**
     * Superseded Resolution
     */
    superseded_resolution?: string | null;
    /**
     * Superseded Revert Skipped
     */
    superseded_revert_skipped?: boolean;
    /**
     * Summary
     */
    summary?: string;
    context?: ConflictContextSchema | null;
    provenance?: ConflictProvenanceSchema | null;
    ai_hints?: ConflictAiHintsSchema | null;
    /**
     * Auto Resolve Blocked
     */
    auto_resolve_blocked?: boolean;
};

/**
 * ConflictSideProvenanceSchema
 *
 * Who changed one side of a conflict, where, and why (869dyvvaq).
 */
export type ConflictSideProvenanceSchema = {
    /**
     * Kind
     */
    kind: string;
    /**
     * Title
     */
    title?: string;
    actor?: EntrySourceSchema | null;
    /**
     * At
     */
    at?: Date | null;
    /**
     * Quote
     */
    quote?: string | null;
};

/**
 * ConsentContext
 *
 * Safe display data returned by GET /consent/{id} for the consent UI.
 */
export type ConsentContext = {
    /**
     * App Name
     */
    app_name: string;
    /**
     * Client Id
     */
    client_id: string;
    /**
     * Trust Level
     */
    trust_level: 'unverified' | 'verified_domain' | 'pre_registered';
    /**
     * Verified Domain
     */
    verified_domain?: string | null;
    /**
     * Redirect Host
     */
    redirect_host: string;
    /**
     * Is Localhost
     */
    is_localhost?: boolean;
    /**
     * Is Custom Scheme
     */
    is_custom_scheme?: boolean;
    /**
     * Requested Scopes
     */
    requested_scopes: Array<string>;
    /**
     * Requires Acknowledgement
     */
    requires_acknowledgement?: boolean;
};

/**
 * ConsumerRef
 */
export type ConsumerRef = {
    /**
     * Consumer Id
     */
    consumer_id: string;
};

/**
 * Contributor
 *
 * An author or committer of a HistoryEntry.
 */
export type Contributor = {
    /**
     * Name
     */
    name: string;
    /**
     * Email
     */
    email: string;
    /**
     * Date
     */
    date: string;
};

/**
 * Coverage
 *
 * How much of the selected scope was assessed - of the MODEL, not the business.
 */
export type Coverage = {
    /**
     * Assessed
     */
    assessed?: number;
    /**
     * Total
     */
    total?: number;
    /**
     * Unassessed
     */
    unassessed?: Array<ScopeAnchor>;
};

/**
 * CreateAgentRequest
 */
export type CreateAgentRequest = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Initial Cluster Roles
     */
    initial_cluster_roles?: Array<ClusterRole> | null;
};

/**
 * CreateAgentTokenRequest
 *
 * Two booleans, never scope strings: the server computes the scopes.
 */
export type CreateAgentTokenRequest = {
    /**
     * Agent Id
     */
    agent_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Grant Write Access
     */
    grant_write_access?: boolean;
    /**
     * Grant Events Write Access
     */
    grant_events_write_access?: boolean;
    /**
     * Expires In Days
     */
    expires_in_days?: number | null;
};

/**
 * CreateReleaseRequest
 *
 * Request to create a new stek release.
 */
export type CreateReleaseRequest = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * CreateUser
 *
 * Create a new user.
 */
export type CreateUser = {
    /**
     * Email
     */
    email: string;
    /**
     * Name
     */
    name?: string | null;
};

/**
 * CreateUserWithInvitation
 *
 * Create a new user via invitation.
 */
export type CreateUserWithInvitation = {
    /**
     * Email
     */
    email: string;
    /**
     * Name
     */
    name: string;
    /**
     * Token
     */
    token: string;
};

/**
 * CreateWhatsNewEntry
 *
 * Request body for creating a What's New entry.
 */
export type CreateWhatsNewEntry = {
    /**
     * Title
     */
    title: string;
    /**
     * Body
     */
    body: string;
    /**
     * Image Url
     */
    image_url?: string | null;
    /**
     * Video Url
     */
    video_url?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Created At
     */
    created_at?: Date | null;
};

/**
 * CrossDomainLink
 *
 * A directed cross-domain linked concept, denormalised with both endpoints' domains.
 */
export type CrossDomainLink = {
    source: CrossDomainLinkEndpoint;
    target: CrossDomainLinkEndpoint;
};

/**
 * CrossDomainLinkEndpoint
 *
 * One end of a cross-domain link: the entity plus its domain.
 */
export type CrossDomainLinkEndpoint = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Domain Name
     */
    domain_name: string;
};

/**
 * DeleteRequirementRequest
 */
export type DeleteRequirementRequest = {
    /**
     * Requirement Id
     */
    requirement_id: string;
};

/**
 * DerivedEvidenceRef
 *
 * API schema for a named pointer to a model object participating in evidence.
 */
export type DerivedEvidenceRef = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Label
     */
    label?: string | null;
    /**
     * Canonical Id
     */
    canonical_id?: string | null;
};

/**
 * DiffStatResponse
 *
 * Diff statistics for a single file.
 */
export type DiffStatResponse = {
    /**
     * Path
     */
    path: string;
    /**
     * Additions
     */
    additions: number;
    /**
     * Deletions
     */
    deletions: number;
    /**
     * Old Path
     */
    old_path?: string | null;
};

/**
 * Domain
 *
 * Request body for Domain.
 */
export type Domain = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
};

/**
 * DomainCommitResponse
 *
 * Snapshot of a domain at a specific release.
 */
export type DomainCommitResponse = {
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Domain Name
     */
    domain_name: string;
    /**
     * Commit Id
     */
    commit_id: string;
};

/**
 * DomainDiffResponse
 *
 * Diff for a single domain between two releases.
 */
export type DomainDiffResponse = {
    /**
     * From Ref
     */
    from_ref: string;
    /**
     * To Ref
     */
    to_ref: string;
    /**
     * Files Changed
     */
    files_changed: number;
    /**
     * Additions
     */
    additions: number;
    /**
     * Deletions
     */
    deletions: number;
    /**
     * Changed Files
     */
    changed_files: Array<DiffStatResponse>;
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Domain Name
     */
    domain_name: string;
};

/**
 * DomainInTree
 *
 * Domain representation inside worktree, does not describe Domain.
 */
export type DomainInTree = {
    /**
     * Identity
     */
    identity: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Order Index
     */
    order_index: number;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * Diff Status
     */
    diff_status?: 'added' | 'modified' | 'removed' | null;
    /**
     * Products
     */
    products: Array<ProductInTree>;
    /**
     * Business Entities
     */
    business_entities?: Array<BusinessEntityInTree>;
};

/**
 * DomainRole
 *
 * The domain roles in relation to the user.
 */
export type DomainRole = {
    /**
     * Role Name
     */
    role_name: string;
    /**
     * Domain Name
     */
    domain_name: string;
    /**
     * Authorized
     */
    authorized: boolean;
};

/**
 * DomainTerm
 *
 * API schema for a DomainTerm.
 */
export type DomainTerm = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
};

/**
 * DriftArtefactChange
 *
 * API schema for one description / definition / document that moved.
 *
 * ``diff`` is a unified text diff, or ``null`` with ``diff_omitted`` naming
 * why: ``binary`` (git holds an LFS pointer, so ``size_before``/``size_after``
 * are the honest "replaced" statement), ``diagram`` (a BPMN definition, whose
 * real diff is the element list) or ``too_large``.
 */
export type DriftArtefactChange = {
    /**
     * Artefact Id
     */
    artefact_id: string;
    /**
     * Name
     */
    name: string;
    facet: DriftFacet;
    kind: DriftKind;
    /**
     * Mimetype
     */
    mimetype?: string;
    /**
     * Size Before
     */
    size_before?: number | null;
    /**
     * Size After
     */
    size_after?: number | null;
    /**
     * Diff
     */
    diff?: string | null;
    /**
     * Diff Omitted
     */
    diff_omitted?: string;
};

/**
 * DriftChange
 *
 * API schema for one entity that is designed differently from what was built.
 *
 * ``key`` is the drift key (``<domain_id>/<relpath>``) the write endpoints take
 * back verbatim; ``fingerprint`` is what ``set_build_ticket_built`` freezes, so
 * both are exposed rather than hidden behind an opaque handle.
 */
export type DriftChange = {
    /**
     * Key
     */
    key: string;
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
    level: DriftLevel;
    kind: DriftKind;
    /**
     * Name
     */
    name: string;
    /**
     * Breadcrumb
     */
    breadcrumb?: Array<string>;
    /**
     * Facets
     */
    facets?: Array<DriftFacet>;
    /**
     * Fingerprint
     */
    fingerprint?: string;
    /**
     * Ticket Identity
     */
    ticket_identity?: string | null;
    /**
     * Changed Since Built
     */
    changed_since_built?: boolean;
};

/**
 * DriftChangeDetail
 *
 * API schema for "before → after" on ONE drift row.
 *
 * A separate call from ``get_drift`` on purpose: the list renders hundreds of
 * rows and only a handful are expanded, and a description diff needs blob
 * content that cannot travel inline. One section per facet.
 */
export type DriftChangeDetail = {
    /**
     * Key
     */
    key: string;
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
    level: DriftLevel;
    kind: DriftKind;
    /**
     * Name
     */
    name: string;
    /**
     * Present When Built
     */
    present_when_built?: boolean;
    /**
     * Present At Head
     */
    present_at_head?: boolean;
    /**
     * Fields
     */
    fields?: Array<DriftFieldChange>;
    diagram?: DriftDiagramChange | null;
    /**
     * Artefacts
     */
    artefacts?: Array<DriftArtefactChange>;
};

/**
 * DriftCounts
 *
 * API schema for the page's headline numbers, by kind and by level.
 */
export type DriftCounts = {
    /**
     * Total
     */
    total?: number;
    /**
     * Added
     */
    added?: number;
    /**
     * Changed
     */
    changed?: number;
    /**
     * Removed
     */
    removed?: number;
    /**
     * By Level
     */
    by_level?: {
        [key: string]: number;
    };
    /**
     * Built
     */
    built?: number;
    /**
     * Waiting
     */
    waiting?: number;
    /**
     * In Ticket
     */
    in_ticket?: number;
    /**
     * Loose
     */
    loose?: number;
};

/**
 * DriftDiagramChange
 *
 * API schema for a process's diagram change, stated as elements.
 *
 * The BPMN XML is never diffed as text: it is machine-written and its layout
 * section moves on a drag that changes nothing. Sequence flows appear here and
 * nowhere else — ``get_drift`` folds them into their process.
 */
export type DriftDiagramChange = {
    /**
     * Added
     */
    added?: Array<ChangedProcessElementInfo>;
    /**
     * Removed
     */
    removed?: Array<ChangedProcessElementInfo>;
    /**
     * Updated
     */
    updated?: Array<ChangedProcessElementInfo>;
    /**
     * Definition Before
     *
     * The BPMN XML as built, when readable and present.
     */
    definition_before?: string | null;
    /**
     * Definition After
     *
     * The BPMN XML at HEAD, when readable and present.
     */
    definition_after?: string | null;
};

/**
 * DriftFacet
 *
 * Which of the entity's three own components moved.
 *
 * One facet per fingerprint component: ``details`` = its ``_meta.json``,
 * ``description_or_diagram`` = its ``application_artefacts/`` (a description
 * for most entities, the BPMN definition for a process), ``documents`` = its
 * ``user_artefacts/``. Populated for ``changed`` only — on an add or a remove
 * the whole entity moved.
 *
 * ``details`` rides along with a description edit rather than isolating a
 * "structured fields only" change: an application artefact's id, name, mimetype
 * and preview are shadowed INTO ``_meta.json`` (``_with_app_artefacts``), so
 * writing a description really does move the details component too.
 */
export enum DriftFacet {
    DETAILS = 'details',
    DESCRIPTION_OR_DIAGRAM = 'description_or_diagram',
    DOCUMENTS = 'documents'
}

/**
 * DriftFieldChange
 *
 * API schema for one ``_meta.json`` field that moved on an expanded row.
 *
 * ``label`` is the field projected to the product's word; ``field`` is kept
 * alongside it so a client can key off something stable. ``before``/``after``
 * are rendered strings, and ``null`` on a side means the field does not exist
 * there — which is how an added or removed entity reports the one side it has.
 */
export type DriftFieldChange = {
    /**
     * Field
     */
    field: string;
    /**
     * Label
     */
    label: string;
    kind: DriftKind;
    /**
     * Before
     */
    before?: string | null;
    /**
     * After
     */
    after?: string | null;
};

/**
 * DriftKind
 *
 * What happened to the entity since it was last marked built.
 *
 * ``removed`` covers both a vanished directory and the product's normal soft
 * delete (``archived_at`` set); ``added`` covers a restore (``archived_at``
 * cleared).
 */
export enum DriftKind {
    ADDED = 'added',
    CHANGED = 'changed',
    REMOVED = 'removed'
}

/**
 * DriftLedger
 *
 * API schema for what the drift was computed against: the built ledger.
 *
 * ``seeded_at`` is ``null`` until somebody has marked everything built — the
 * page's first-run state, where the whole design counts as waiting.
 */
export type DriftLedger = {
    /**
     * Seeded At
     */
    seeded_at?: Date | null;
    /**
     * Seeded By
     */
    seeded_by?: string | null;
    /**
     * Entries
     *
     * Entities the ledger records as built.
     */
    entries?: number;
    /**
     * Unreadable Domain Ids
     */
    unreadable_domain_ids?: Array<string>;
};

/**
 * DriftLevel
 *
 * The level a drift item is attributed to, read off the VFS path shape.
 *
 * ``domain`` is the repo root; the rest are the id-keyed entity directories
 * under it. Sequence flows have no level of their own — they fold into their
 * process (see ``DriftChange``).
 */
export enum DriftLevel {
    DOMAIN = 'domain',
    ROLE = 'role',
    BUSINESS_ENTITY = 'business_entity',
    PRODUCT = 'product',
    PROCESS = 'process',
    LANE = 'lane',
    TASK = 'task',
    GATEWAY = 'gateway',
    EVENT = 'event'
}

/**
 * DriftSuggestion
 *
 * API schema for a ticket the page offers to create from loose changes.
 */
export type DriftSuggestion = {
    /**
     * Identity
     */
    identity: string;
    level: DriftLevel;
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Entity Id
     */
    entity_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Whole Domain
     */
    whole_domain?: boolean;
    /**
     * Change Keys
     */
    change_keys?: Array<string>;
};

/**
 * EditSite
 *
 * API schema for one exact edit site of a non-automated resolution step.
 */
export type EditSite = {
    process: DerivedEvidenceRef;
    /**
     * Bpmn Id
     */
    bpmn_id?: string | null;
    /**
     * Transformation
     */
    transformation: string;
};

/**
 * EnterContext
 *
 * What the visitor is about to enter — feeds the sign-on page's
 * identification card (projects, branch, creator, data class, services,
 * session expiry). Informational only; access was already decided.
 */
export type EnterContext = {
    /**
     * Projects
     */
    projects?: Array<string>;
    /**
     * Branch
     */
    branch?: string;
    /**
     * Creator
     */
    creator?: string;
    /**
     * Data Classification
     */
    data_classification?: string;
    /**
     * Services
     */
    services?: Array<string>;
    /**
     * Expires At
     */
    expires_at?: Date | null;
};

/**
 * EnterResponse
 */
export type EnterResponse = {
    /**
     * Url
     */
    url: string;
    /**
     * Expires In
     */
    expires_in: number;
    context?: EnterContext;
};

/**
 * EntitlementResponse
 */
export type EntitlementResponse = {
    /**
     * Available
     */
    available: boolean;
    /**
     * Reason
     */
    reason?: string | null;
    /**
     * Status
     */
    status: string | null;
    /**
     * Current Usage
     */
    current_usage: number;
    /**
     * Effective Cap
     */
    effective_cap: number;
    /**
     * Near Cap Warning
     */
    near_cap_warning: boolean;
    /**
     * Period Start
     */
    period_start: Date | null;
    /**
     * Period End
     */
    period_end: Date | null;
    /**
     * Plan Name
     */
    plan_name: string | null;
    /**
     * Overage
     */
    overage?: boolean;
    /**
     * Scheduled Plan Tier
     */
    scheduled_plan_tier?: string | null;
    /**
     * Scheduled Change At
     */
    scheduled_change_at?: Date | null;
};

/**
 * EntityInfo
 *
 * Entity information.
 */
export type EntityInfo = {
    /**
     * Identity
     */
    identity: string;
    entity_type: EntityType;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * Thumbnail
     */
    thumbnail?: string | null;
    parent?: EntityInfo | null;
};

/**
 * EntityRef
 *
 * Reference from a ProcessElement to a BusinessEntity with a free-form label.
 */
export type EntityRef = {
    /**
     * Entity Id
     */
    entity_id: string;
    /**
     * Label
     */
    label: string;
};

/**
 * EntitySnapshotResponse
 *
 * A read-only view of an entity and its children as of one git revision.
 *
 * Only the fields for the requested entity type are populated. Descriptions
 * (and other artefact bodies) are NOT included — the frontend reads them via
 * the artefact-at-revision path. Linked/cross-repo sections (linked apps/views,
 * documents, business rules) also stay current in the version view.
 */
export type EntitySnapshotResponse = {
    domain?: Domain | null;
    /**
     * Roles
     */
    roles?: Array<Role>;
    /**
     * Domain Terms
     */
    domain_terms?: Array<DomainTerm>;
    /**
     * Products
     */
    products?: Array<ProductInTree>;
    /**
     * Business Entities
     */
    business_entities?: Array<BusinessEntity>;
    role?: Role | null;
    product?: Product | null;
    /**
     * Product Processes
     */
    product_processes?: Array<ProcessInTree>;
    domain_term?: DomainTerm | null;
    business_entity?: BusinessEntity | null;
    application?: Application | null;
    /**
     * Application Entities
     */
    application_entities?: Array<ApplicationEntity>;
    process?: Process | null;
    /**
     * Process Elements
     */
    process_elements?: Array<ProcessTask | ProcessGateway | ProcessEvent | ProcessFlow>;
    /**
     * Process Element
     */
    process_element?: ProcessTask | ProcessGateway | ProcessEvent | ProcessFlow | null;
};

/**
 * EntityTaskRef
 *
 * A process task that references a business entity, returned when querying entity usage.
 */
export type EntityTaskRef = {
    /**
     * Task Id
     */
    task_id: string;
    /**
     * Task Name
     */
    task_name: string;
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Process Name
     */
    process_name: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Label
     */
    label: string;
};

/**
 * EntityType
 */
export enum EntityType {
    ORGANIZATION = 'organization',
    STEK = 'stek',
    DOMAIN = 'domain',
    PRODUCT = 'product',
    ROLE = 'role',
    PROCESS = 'process',
    TASK = 'task',
    GATEWAY = 'gateway',
    EVENT = 'event',
    FLOW = 'flow',
    ARTEFACT = 'artefact',
    ARTEFACT_GROUP = 'artefact_group',
    BUSINESS_ENTITY = 'business_entity',
    DOMAIN_TERM = 'domain_term',
    DOCUMENT = 'document',
    APPLICATION = 'application',
    APPLICATION_ENTITY = 'application_entity'
}

/**
 * EntityVersionsSchema
 *
 * A conflicted entity's content at base / master / branch, shaped for a diff.
 *
 * ``content_type`` drives the frontend ``DiffViewer`` dispatch (text / BPMN /
 * binary). Each side is the textual content at that revision (``_meta.json``
 * pretty-printed, a process-definition's XML, …) or ``None`` when the file is
 * absent at that revision (a deleted side) or the content is binary.
 */
export type EntityVersionsSchema = {
    /**
     * Content Type
     */
    content_type?: string;
    /**
     * Base
     */
    base?: string | null;
    /**
     * Master
     */
    master?: string | null;
    /**
     * Branch
     */
    branch?: string | null;
};

/**
 * EntrySourceSchema
 */
export type EntrySourceSchema = {
    /**
     * Type
     */
    type: string;
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
};

/**
 * ErrorType
 *
 * An exhaustive list of domain errors.
 *
 * The list MUST be extended for application specific error messages. The convention is:
 * <DOMAIN>_<ERROR_DESCRIPTION>
 *
 * Please be kind to you coding mates and give it a descriptive name, no need for shorthands.
 */
export enum ErrorType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13
}

/**
 * EvidenceBasis
 *
 * Which world a claim describes. Planned changes are kept out of the
 * current-state answer entirely rather than being weighed into it.
 */
export enum EvidenceBasis {
    PLANNED = 'planned',
    DOCUMENTED_CURRENT_STATE = 'documented_current_state',
    OPERATIONALLY_EVIDENCED = 'operationally_evidenced'
}

/**
 * EvidenceClaim
 *
 * One source's statement about one subject.
 */
export type EvidenceClaim = {
    /**
     * Key
     */
    key: string;
    /**
     * Topic Keys
     */
    topic_keys?: Array<string>;
    subject: ScopeAnchor;
    /**
     * Predicate
     */
    predicate: string;
    polarity: Polarity;
    /**
     * Value
     */
    value?: string | null;
    /**
     * Qualifiers
     */
    qualifiers?: {
        [key: string]: string;
    };
    evidence_kind: EvidenceKind;
    basis: EvidenceBasis;
    source: SourceRef;
    confidence: Confidence;
    /**
     * Note
     */
    note?: string;
};

/**
 * EvidenceKind
 *
 * What KIND of thing a source is. Never ranked into a single score: a
 * contract and an observation answer different questions, and averaging them
 * is how "we intend to" becomes "we do".
 */
export enum EvidenceKind {
    DOCUMENTED_INTENTION = 'documented_intention',
    USER_DECLARATION = 'user_declaration',
    CONTRACTUAL_COMMITMENT = 'contractual_commitment',
    CONFIGURATION_EVIDENCE = 'configuration_evidence',
    OPERATIONAL_OBSERVATION = 'operational_observation'
}

/**
 * EvidenceView
 *
 * Which world the page is asking about - the "Evidence" selector.
 *
 * Three separate questions, never one blended answer:
 *
 * * ``CURRENT`` - how things are documented to work today. The default, and
 * the only one that should ever be read as a statement about the business.
 * * ``WITH_PLANNED`` - what the documented plans would make true. Planned
 * claims are read as current FOR THIS VIEW ONLY, which is how a plan can be
 * inspected without a prospective architecture note ever quietly supporting
 * a badge about today.
 * * ``OPERATIONAL`` - only what was actually observed running. The narrowest
 * and the most expensive to satisfy.
 */
export enum EvidenceView {
    CURRENT = 'current',
    WITH_PLANNED = 'with_planned',
    OPERATIONAL = 'operational'
}

/**
 * ExternalApplicationEntity
 *
 * API schema for an ApplicationEntity in another Application, for diagram stubs.
 */
export type ExternalApplicationEntity = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Application Id
     */
    application_id: string;
    /**
     * Application Name
     */
    application_name: string;
};

/**
 * ExternalCommunicationFlow
 *
 * API schema for one derived message flow crossing the organisation
 * boundary. ``direction`` is from the organisation's point of view
 * (outgoing = the internal node is the flow's source).
 */
export type ExternalCommunicationFlow = {
    direction: RelationshipDirection;
    process: DerivedEvidenceRef;
    element?: DerivedEvidenceRef | null;
    /**
     * Applications
     */
    applications?: Array<DerivedEvidenceRef>;
    /**
     * Payload
     */
    payload?: Array<DerivedEvidenceRef>;
    /**
     * Message Name
     */
    message_name?: string | null;
    /**
     * Pool Name
     */
    pool_name?: string | null;
};

/**
 * ExternalCommunicationMap
 *
 * API response schema for the Stek's derived external communication map —
 * computed, never stored. ``parties`` is the business tier,
 * ``applications`` the IT tier, ``unresolved`` surfaces on both.
 */
export type ExternalCommunicationMap = {
    /**
     * Parties
     */
    parties?: Array<ExternalPartyCommunication>;
    /**
     * Applications
     */
    applications?: Array<ApplicationCommunication>;
    /**
     * Unresolved
     */
    unresolved?: Array<UntypedParty>;
};

/**
 * ExternalParty
 *
 * API response schema for a typed ExternalParty.
 */
export type ExternalParty = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Name
     */
    name: string;
    party_type: PartyType;
    /**
     * Aliases
     */
    aliases?: Array<string>;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * ExternalPartyCommunication
 *
 * API schema for all derived communication flows of one ExternalParty.
 */
export type ExternalPartyCommunication = {
    party: ExternalPartyRef;
    /**
     * Flows
     */
    flows?: Array<ExternalCommunicationFlow>;
};

/**
 * ExternalPartyRef
 *
 * API schema for a lightweight pointer to a typed ExternalParty.
 */
export type ExternalPartyRef = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    party_type: PartyType;
};

/**
 * ExtractRequirementsRequest
 */
export type ExtractRequirementsRequest = {
    /**
     * Artefact Id
     */
    artefact_id: string;
};

/**
 * FeatureSummary
 *
 * Subscription summary for one (org × feature) pair.
 */
export type FeatureSummary = {
    /**
     * Feature Key
     */
    feature_key: string;
    /**
     * Plan Name
     */
    plan_name: string;
    /**
     * Plan Tier
     */
    plan_tier: string;
    /**
     * Status
     */
    status: string;
    /**
     * Events Used
     */
    events_used: number;
    /**
     * Events Cap
     */
    events_cap: number;
};

/**
 * FirebaseUser
 *
 * Firebase user record with authentication details.
 */
export type FirebaseUser = {
    /**
     * Uid
     *
     * Firebase user UID
     */
    uid: string;
    /**
     * Email
     *
     * User email address
     */
    email?: string | null;
    /**
     * Email Verified
     *
     * Whether email is verified
     */
    email_verified?: boolean;
    /**
     * Display Name
     *
     * User display name
     */
    display_name?: string | null;
    /**
     * Photo Url
     *
     * User profile photo URL
     */
    photo_url?: string | null;
    /**
     * Phone Number
     *
     * User phone number
     */
    phone_number?: string | null;
    /**
     * Disabled
     *
     * Whether account is disabled
     */
    disabled?: boolean;
    /**
     * Provider Data
     *
     * List of sign-in providers
     */
    provider_data?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Tokens Valid After Time
     *
     * Tokens issued before this time are invalid
     */
    tokens_valid_after_time?: Date | null;
    /**
     * User Metadata Creation Time
     *
     * Account creation time
     */
    user_metadata_creation_time?: Date | null;
    /**
     * User Metadata Last Sign In Time
     *
     * Last sign-in time
     */
    user_metadata_last_sign_in_time?: Date | null;
    /**
     * User Metadata Last Refresh Time
     *
     * Last token refresh time
     */
    user_metadata_last_refresh_time?: Date | null;
    /**
     * Custom Claims
     *
     * Custom user claims
     */
    custom_claims?: {
        [key: string]: unknown;
    } | null;
    /**
     * Tenant Id
     *
     * Tenant ID for multi-tenancy
     */
    tenant_id?: string | null;
    /**
     * Mfa Info
     *
     * Multi-factor authentication enrollments
     */
    mfa_info?: Array<FirebaseUserMfaInfo>;
};

/**
 * FirebaseUserMfaInfo
 *
 * MFA information for a Firebase user.
 */
export type FirebaseUserMfaInfo = {
    /**
     * Uid
     *
     * Unique identifier for the MFA enrollment
     */
    uid: string;
    /**
     * Phone Number
     *
     * Phone number for MFA
     */
    phone_number?: string | null;
    /**
     * Display Name
     *
     * Display name for MFA enrollment
     */
    display_name?: string | null;
    /**
     * Enrollment Time
     *
     * When MFA was enrolled
     */
    enrollment_time?: Date | null;
    /**
     * Factor Id
     *
     * Type of MFA factor (e.g., 'phone')
     */
    factor_id: string;
};

/**
 * FollowUpState
 */
export enum FollowUpState {
    ASKED = 'asked',
    DEFERRED = 'deferred',
    NOT_APPLICABLE = 'not_applicable',
    RESOLVED = 'resolved'
}

/**
 * Freshness
 *
 * When this was computed, and what it could not read.
 */
export type Freshness = {
    /**
     * Evaluated At
     */
    evaluated_at: Date;
    /**
     * Evaluated Revision
     */
    evaluated_revision?: string | null;
    /**
     * Extracted At
     */
    extracted_at?: Date | null;
    /**
     * Stale Sources
     */
    stale_sources?: Array<SourceRef>;
    /**
     * Unreadable Sources
     */
    unreadable_sources?: Array<SourceRef>;
    /**
     * Unanalysed Sources
     */
    unanalysed_sources?: Array<SourceRef>;
};

/**
 * GapFollowUpRequest
 */
export type GapFollowUpRequest = {
    /**
     * Gap Key
     */
    gap_key: string;
    state: FollowUpState;
    /**
     * Reason
     */
    reason?: string | null;
    /**
     * Revisit After
     */
    revisit_after?: Date | null;
};

/**
 * GapKind
 *
 * Why a fact is missing — which decides how it is asked for.
 */
export enum GapKind {
    MISSING_FACT = 'missing_fact',
    AMBIGUOUS_EVIDENCE = 'ambiguous_evidence',
    UNRESOLVED_PATH = 'unresolved_path',
    STALE_SOURCE = 'stale_source',
    UNREAD_SOURCE = 'unread_source',
    NO_REQUIREMENT = 'no_requirement'
}

/**
 * GeneratedAcceptMessageSchema
 *
 * The LLM-suggested accept message for a thread (an editable suggestion).
 *
 * Split into the decision protocol's two parts so the accept dialog can
 * pre-fill its ``What`` and ``Why`` fields independently.
 */
export type GeneratedAcceptMessageSchema = {
    /**
     * What
     */
    what: string;
    /**
     * Why
     */
    why?: string | null;
};

/**
 * GetReleaseDiffRequest
 *
 * Request to get diff between releases.
 */
export type GetReleaseDiffRequest = {
    /**
     * To Release
     */
    to_release: string;
    /**
     * From Release
     */
    from_release?: string | null;
};

/**
 * GetTaskEvaluationsRequest
 *
 * Request to get task evaluations for a specific task name.
 */
export type GetTaskEvaluationsRequest = {
    /**
     * Task Name
     *
     * Name of the task to get evaluations for
     */
    task_name: string;
};

/**
 * GetTaskProvidersRequest
 *
 * Request to get task providers for a specific task type.
 */
export type GetTaskProvidersRequest = {
    /**
     * Type of task to get providers for
     */
    task_type: TaskType;
};

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
    /**
     * Detail
     */
    detail?: Array<ValidationError>;
};

/**
 * Hateoas
 *
 * Response body for Hoteos.
 */
export type Hateoas = {
    /**
     * Href
     */
    href: string;
    /**
     * Type
     */
    type: string;
};

/**
 * HeartbeatRequest
 */
export type HeartbeatRequest = {
    /**
     * Last Activity At
     */
    last_activity_at?: number;
};

/**
 * HeartbeatResponse
 */
export type HeartbeatResponse = {
    /**
     * Host
     */
    host: string;
    /**
     * Active
     */
    active: boolean;
    /**
     * Expires At
     */
    expires_at: Date;
    /**
     * Extended
     */
    extended?: boolean;
};

/**
 * HintPreferences
 *
 * User hint/UI preferences.
 */
export type HintPreferences = {
    /**
     * Hints Enabled
     */
    hints_enabled?: boolean | null;
    /**
     * Seen Hints
     */
    seen_hints?: Array<string> | null;
    /**
     * Setup Checklist
     */
    setup_checklist?: {
        [key: string]: SetupChecklistEntry;
    } | null;
};

/**
 * HttpDetail
 */
export type HttpDetail = {
    /**
     * Message
     */
    message: string;
    /**
     * Type
     */
    type: unknown;
};

/**
 * HttpExceptionModel
 */
export type HttpExceptionModel = {
    /**
     * Detail
     */
    detail: Array<HttpDetail>;
};

/**
 * InformationGap
 *
 * One thing the assessment needed and did not have, phrased as a question.
 */
export type InformationGap = {
    /**
     * Key
     */
    key: string;
    /**
     * Topic Key
     */
    topic_key: string;
    kind: GapKind;
    /**
     * Missing
     */
    missing: string;
    /**
     * Question
     */
    question: string;
    /**
     * Relevance
     */
    relevance?: string;
    /**
     * Scope
     */
    scope?: Array<ScopeAnchor>;
    /**
     * Requirement Ids
     */
    requirement_ids?: Array<string>;
    /**
     * Weight
     */
    weight?: number;
    /**
     * Evidence Version
     */
    evidence_version?: string;
};

/**
 * IngestEventPayload
 *
 * Event payload structure for ingesting live mode events.
 *
 * The payload can contain arbitrary data, but compliance_proof follows
 * a specific structure when present.
 */
export type IngestEventPayload = {
    /**
     * Optional compliance evidence attached to this event
     */
    compliance_proof?: ComplianceProof | null;
    [key: string]: unknown;
};

/**
 * Integration
 *
 * Integration on a Stek level.
 */
export type Integration = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * User Id
     */
    user_id?: string | null;
    integration_type: IntegrationType;
    /**
     * Integration Method
     */
    integration_method: 'oauth2' | 'api_key' | null;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Updated At
     */
    updated_at: Date;
    /**
     * Last Sync At
     */
    last_sync_at?: Date | null;
    /**
     * Is Active
     */
    is_active: boolean;
    settings?: IntegrationSettings | null;
};

/**
 * IntegrationSettings
 *
 * Base model for integration settings.
 */
export type IntegrationSettings = {
    /**
     * Api Key
     */
    api_key?: string;
    /**
     * Host
     */
    host?: string | null;
};

/**
 * IntegrationStatus
 */
export enum IntegrationStatus {
    CONNECTED = 'connected',
    MISSING_INTEGRATION = 'missing_integration',
    MISSING_CREDENTIALS = 'missing_credentials',
    ERROR = 'error'
}

/**
 * IntegrationType
 *
 * Types of integrations that can be configured for an stek.
 */
export enum IntegrationType {
    CLICKUP = 'clickup',
    GITLAB = 'gitlab',
    MCP_OAUTH2 = 'mcp_oauth2'
}

/**
 * InvitationValidation
 *
 * Response for invitation token validation.
 */
export type InvitationValidation = {
    /**
     * Email
     */
    email: string;
    /**
     * Organization Name
     */
    organization_name: string;
};

/**
 * KeyResult
 *
 * Response body for a Key Result.
 */
export type KeyResult = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Label
     */
    label: string;
    /**
     * Start Value
     */
    start_value?: string | null;
    /**
     * Target Value
     */
    target_value?: string | null;
    /**
     * Current Value
     */
    current_value?: string | null;
};

/**
 * KeyResultInput
 *
 * Inbound key-result data for create/update (no identity = new key result).
 */
export type KeyResultInput = {
    /**
     * Identity
     */
    identity?: string | null;
    /**
     * Label
     */
    label: string;
    /**
     * Start Value
     */
    start_value?: string | null;
    /**
     * Target Value
     */
    target_value?: string | null;
    /**
     * Current Value
     */
    current_value?: string | null;
};

/**
 * Lane
 *
 * Request body for Lane.
 */
export type Lane = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Role Id
     */
    role_id?: string | null;
};

/**
 * LinkPreview
 *
 * Link preview data model for API responses.
 */
export type LinkPreview = {
    /**
     * Title
     */
    title?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Image
     */
    image?: string | null;
    /**
     * Domain
     */
    domain?: string | null;
    integration_status?: IntegrationStatus | null;
};

/**
 * LinkableBusinessEntity
 *
 * A BusinessEntity in another domain, offered as a cross-domain link target.
 */
export type LinkableBusinessEntity = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Domain Name
     */
    domain_name: string;
};

/**
 * ListAgentTokensRequest
 */
export type ListAgentTokensRequest = {
    /**
     * Agent Id
     */
    agent_id?: string | null;
};

/**
 * LiveMetrics
 *
 * Aggregated metrics for live mode monitoring.
 */
export type LiveMetrics = {
    /**
     * Entity Id
     */
    entity_id: string;
    /**
     * Entity Type
     */
    entity_type: string;
    /**
     * Time Range Start
     */
    time_range_start: Date;
    /**
     * Time Range End
     */
    time_range_end: Date;
    /**
     * Total Events
     */
    total_events: number;
    /**
     * Events By Type
     */
    events_by_type: {
        [key: string]: number;
    };
    /**
     * Error Count
     */
    error_count: number;
    /**
     * Error Rate
     */
    error_rate: number;
    /**
     * Process Instance Count
     */
    process_instance_count?: number | null;
    /**
     * Active Process Count
     */
    active_process_count?: number | null;
    /**
     * Completed Process Count
     */
    completed_process_count?: number | null;
    /**
     * Failed Process Count
     */
    failed_process_count?: number | null;
    /**
     * Avg Process Duration Seconds
     */
    avg_process_duration_seconds?: number | null;
    /**
     * Time Series Data
     */
    time_series_data: Array<{
        [key: string]: unknown;
    }>;
};

/**
 * Market
 *
 * Response body for a stek's market picture.
 */
export type Market = {
    /**
     * Competitors
     */
    competitors?: Array<Competitor>;
    /**
     * Trends
     */
    trends?: Array<Trend>;
};

/**
 * McpConsumer
 *
 * A dynamically registered MCP consumer (OAuth + consent), listed next to
 * the agents: who it is, whom it acts as, what it may do, and whether it is
 * still alive.
 */
export type McpConsumer = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     *
     * Clean consumer name, e.g. Claude Code
     */
    name: string;
    /**
     * Label
     *
     * Consumer · person, e.g. Claude Code · Ard
     */
    label: string;
    /**
     * Client Name
     */
    client_name: string;
    /**
     * User Id
     */
    user_id?: string | null;
    /**
     * User Name
     */
    user_name?: string;
    /**
     * User Email
     */
    user_email?: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Scopes
     */
    scopes?: Array<string>;
    /**
     * Connected At
     */
    connected_at: Date;
    /**
     * Last Active At
     */
    last_active_at?: Date | null;
    /**
     * Expires At
     */
    expires_at?: Date | null;
    /**
     * Status
     *
     * active · expired
     */
    status: string;
};

/**
 * MeUser
 *
 * User object which exposes all authorizations roles in all organizatios for the user.
 */
export type MeUser = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Email
     */
    email: string;
    /**
     * Roles
     */
    roles: {
        [key: string]: Array<ClusterRole>;
    };
    /**
     * Permissions
     */
    permissions: {
        [key: string]: UserPermissions;
    };
    /**
     * Capabilities
     */
    capabilities?: {
        [key: string]: OrganizationCapabilities;
    };
    /**
     * Profile Picture
     */
    profile_picture?: string | null;
    preferences?: HintPreferences | null;
    /**
     * Is Platform Admin
     */
    is_platform_admin?: boolean;
};

/**
 * MemoryEntrySchema
 *
 * One remembered thing, as shown in the transparency view.
 */
export type MemoryEntrySchema = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Organization Id
     */
    organization_id: string | null;
    /**
     * Slot Kind
     */
    slot_kind: string;
    /**
     * Slot Key
     */
    slot_key: string | null;
    /**
     * Entry Type
     */
    entry_type: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string;
    /**
     * Content
     */
    content: string;
    /**
     * Status
     */
    status: string | null;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Updated At
     */
    updated_at: Date;
};

/**
 * ModelConfig
 *
 * Model configuration for task evaluation.
 */
export type ModelConfig = {
    /**
     * Model provider (OpenAI or Anthropic)
     */
    provider?: ModelProvider;
    /**
     * Model
     *
     * Model name (e.g., gpt-4.1, claude-3-sonnet)
     */
    model?: string;
    /**
     * Temperature
     *
     * Model temperature (0.0 to 1.0)
     */
    temperature?: number;
    /**
     * Max Tokens
     *
     * Maximum tokens to generate
     */
    max_tokens?: number;
};

/**
 * ModelProvider
 *
 * Available model providers.
 */
export enum ModelProvider {
    OPENAI = 'openai',
    ANTHROPIC = 'anthropic'
}

/**
 * MovedGroup
 */
export type MovedGroup = {
    /**
     * Kind
     */
    kind: 'released' | 'started-running' | 'changed';
    /**
     * Items
     */
    items?: Array<MovedItem>;
};

/**
 * MovedItem
 */
export type MovedItem = {
    /**
     * Text
     */
    text: string;
};

/**
 * OAuthMetadata
 *
 * OAuth2 server metadata for discovery.
 */
export type OAuthMetadata = {
    /**
     * Issuer
     */
    issuer: string;
    /**
     * Authorization Endpoint
     */
    authorization_endpoint: string;
    /**
     * Token Endpoint
     */
    token_endpoint: string;
    /**
     * Registration Endpoint
     */
    registration_endpoint?: string | null;
    /**
     * Revocation Endpoint
     */
    revocation_endpoint?: string | null;
    /**
     * Scopes Supported
     */
    scopes_supported?: Array<string>;
    /**
     * Response Types Supported
     */
    response_types_supported?: Array<string>;
    /**
     * Grant Types Supported
     */
    grant_types_supported?: Array<string>;
    /**
     * Code Challenge Methods Supported
     */
    code_challenge_methods_supported?: Array<string>;
    /**
     * Token Endpoint Auth Methods Supported
     */
    token_endpoint_auth_methods_supported?: Array<string>;
    /**
     * Client Id Metadata Document Supported
     */
    client_id_metadata_document_supported?: boolean;
};

/**
 * OAuthProtectedResourceMetadata
 *
 * OAuth2 protected resource metadata for discovery (RFC 9728).
 */
export type OAuthProtectedResourceMetadata = {
    /**
     * Resource
     */
    resource: string;
    /**
     * Authorization Servers
     */
    authorization_servers: Array<string>;
    /**
     * Scopes Supported
     */
    scopes_supported?: Array<string>;
    /**
     * Resource Name
     */
    resource_name?: string | null;
    /**
     * Resource Documentation
     */
    resource_documentation?: string | null;
};

/**
 * Objective
 *
 * Response body for an Objective.
 */
export type Objective = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Order Index
     */
    order_index?: number;
    /**
     * Key Results
     */
    key_results?: Array<KeyResult>;
};

/**
 * OrgAdminRow
 *
 * Platform admin view of a single Organisation.
 */
export type OrgAdminRow = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Plan Name
     */
    plan_name: string;
    /**
     * Plan Tier
     */
    plan_tier: string;
    /**
     * Status
     */
    status: string;
    /**
     * Events Used
     */
    events_used: number;
    /**
     * Events Cap
     */
    events_cap: number;
    /**
     * Features
     */
    features: Array<FeatureSummary>;
};

/**
 * Organization
 *
 * Organization within Gotoko.
 */
export type Organization = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Parent Id
     */
    parent_id?: string | null;
};

/**
 * OrganizationActivityReportResponse
 *
 * Activity report response.
 */
export type OrganizationActivityReportResponse = {
    /**
     * Time Period Days
     */
    time_period_days: number;
    /**
     * Report Generated At
     */
    report_generated_at: Date;
    /**
     * Organizations
     */
    organizations: Array<OrganizationActivityResponse>;
};

/**
 * OrganizationActivityResponse
 *
 * Organization activity response.
 */
export type OrganizationActivityResponse = {
    /**
     * Organization Id
     */
    organization_id: string;
    /**
     * Organization Name
     */
    organization_name: string;
    /**
     * Total Users
     */
    total_users: number;
    /**
     * Last Activity At
     */
    last_activity_at: Date | null;
    /**
     * Active Users In Period
     */
    active_users_in_period: number;
    /**
     * Total Auth Events In Period
     */
    total_auth_events_in_period: number;
    /**
     * User Activities
     */
    user_activities: Array<UserActivityResponse>;
};

/**
 * OrganizationCapabilities
 *
 * Org/platform-derived capabilities for an organization.
 *
 * Unlike ``UserPermissions`` (which is role-derived and per-user), capabilities are the same for
 * every user in the org. Some are a function of the org's persistence mode AND a per-org
 * feature flag; some are global feature flags. Resolved server-side.
 *
 * - ``threads``: thread features are available. Requires *both* that the org is VFS_FIRST
 * (threads stage mutations on a per-thread branch via a branch-scoped UoW, which needs the
 * VFS-first path) and that the org has the ``threads`` feature flag enabled.
 * - ``external_communication``: the external-communication map and external parties are
 * available. Same AND-gate: VFS_FIRST (the map derives process definitions through the
 * VFS-first read path) plus the ``external_communication`` feature flag.
 * - ``business_rules``: business rules functionality is available. Gated globally by an env-based
 * feature flag, independent of persistence mode.
 * - ``watchers``: strategy watchers functionality is available. Gated globally by an env-based
 * feature flag, independent of persistence mode.
 * - ``build``: the Build nav-rail mode is available. Gated globally by an env-based feature
 * flag, independent of persistence mode.
 * - ``ask_box``: the ask box is available in this environment. Gated globally by an env-based
 * feature flag. The box itself additionally requires ``threads`` — every refusal it gives
 * ends by offering a thread — so the frontend ANDs the two rather than reading this alone.
 * - ``personal_agent``: the personal agent's context substrate is on for this org — attention
 * is collected, personal memory is extracted, the Personal Memory settings tab shows. Same
 * AND-gate as threads: VFS_FIRST plus the ``personal_agent`` feature flag.
 * - ``enabled_triage_rules``: the per-issue-type triage rules enabled for the org (D-0
 * amendment). Keys are ``issue_type`` strings plus ``unresolved-external-pool`` for the
 * pool-queue tier. Server-side gates (``get_triage_issues`` + the pool pre-sort) enforce
 * the same set; this surface lets the frontend filter as belt-and-braces and decide which
 * triage entry points to render. Meaningless unless ``external_communication`` is true.
 *
 * Search is not a capability: it works in every persistence mode, so the UI always shows it.
 */
export type OrganizationCapabilities = {
    /**
     * Threads
     */
    threads?: boolean;
    /**
     * External Communication
     */
    external_communication?: boolean;
    /**
     * Business Rules
     */
    business_rules?: boolean;
    /**
     * Watchers
     */
    watchers?: boolean;
    /**
     * Build
     */
    build?: boolean;
    /**
     * Ask Box
     */
    ask_box?: boolean;
    /**
     * Personal Agent
     */
    personal_agent?: boolean;
    /**
     * Enabled Triage Rules
     */
    enabled_triage_rules?: Array<string>;
};

/**
 * OrganizationUser
 *
 * User model scoped to a specific organization.
 */
export type OrganizationUser = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Email
     */
    email: string;
    /**
     * Roles
     */
    roles: Array<ClusterRole>;
    /**
     * Name
     */
    name: string;
    /**
     * Profile Picture
     */
    profile_picture?: string | null;
    /**
     * Status
     */
    status?: string | null;
    /**
     * Invitation Sent At
     */
    invitation_sent_at?: Date | null;
    /**
     * Invitation Expires At
     */
    invitation_expires_at?: Date | null;
    /**
     * Actions
     */
    _actions?: Array<Action>;
};

/**
 * Page[ProcessInstanceMetrics]
 */
export type PageProcessInstanceMetrics = {
    /**
     * Items
     */
    items: Array<ProcessInstanceMetrics>;
    /**
     * Limit
     */
    limit: number;
    /**
     * Offset
     */
    offset: number;
    /**
     * Has More
     */
    has_more: boolean;
    /**
     * Total
     */
    total?: number | null;
};

/**
 * Page[StekEvent]
 */
export type PageStekEvent = {
    /**
     * Items
     */
    items: Array<StekEvent>;
    /**
     * Limit
     */
    limit: number;
    /**
     * Offset
     */
    offset: number;
    /**
     * Has More
     */
    has_more: boolean;
    /**
     * Total
     */
    total?: number | null;
};

/**
 * PartyType
 *
 * What kind of organisation an ExternalParty is to the Stek's organisation.
 *
 * Strictly external counterparties: a pool that is really an internal actor
 * resolves to a domain Role (the triage's promote-to-role answer), never to
 * a party.
 */
export enum PartyType {
    CUSTOMER = 'customer',
    SUPPLIER = 'supplier',
    PARTNER = 'partner',
    AUTHORITY = 'authority',
    INSURER = 'insurer',
    OTHER = 'other'
}

/**
 * PersonalContextExportSchema
 *
 * The portability payload. Loosely typed on purpose — it is a data dump,
 * and pinning its shape here would mean changing two places per store.
 */
export type PersonalContextExportSchema = {
    /**
     * Format Version
     */
    format_version: number;
    /**
     * Exported At
     */
    exported_at: string;
    /**
     * Chat Entries
     */
    chat_entries: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Chat Digests
     */
    chat_digests: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Memories
     */
    memories: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Attention
     */
    attention: {
        [key: string]: unknown;
    };
    /**
     * Covers
     */
    covers: {
        [key: string]: unknown;
    };
    /**
     * Not Included
     */
    not_included: string;
};

/**
 * PersonalFollowUpState
 *
 * One person's state on one shared gap. Never part of the assessment.
 */
export type PersonalFollowUpState = {
    /**
     * Gap Key
     */
    gap_key: string;
    state: FollowUpState;
    /**
     * Reason
     */
    reason?: string | null;
    /**
     * Asked At
     */
    asked_at?: Date | null;
    /**
     * Updated At
     */
    updated_at: Date;
    /**
     * Revisit After
     */
    revisit_after?: Date | null;
    /**
     * Evidence Version
     */
    evidence_version?: string;
};

/**
 * PersonalHome
 *
 * One person's landing page for one stek.
 */
export type PersonalHome = {
    /**
     * Name
     */
    name: string;
    /**
     * Standing
     */
    standing: string;
    /**
     * Watching
     */
    watching: 'design-and-run' | 'design-only' | 'nothing';
    /**
     * Moved
     */
    moved?: Array<MovedGroup>;
    /**
     * Suggestions
     */
    suggestions?: Array<Suggestion>;
    /**
     * Open Findings
     */
    open_findings?: number | null;
};

/**
 * PersonalMemoryEnabledSchema
 */
export type PersonalMemoryEnabledSchema = {
    /**
     * Enabled
     */
    enabled: boolean;
};

/**
 * PersonalMemorySettingsSchema
 *
 * Both off-switches, as stored — the settings page must show state, not guesses.
 */
export type PersonalMemorySettingsSchema = {
    /**
     * Personal Memory Enabled
     */
    personal_memory_enabled: boolean;
    /**
     * Attention Probe Enabled
     */
    attention_probe_enabled: boolean;
};

/**
 * PlanOverrideAuditRow
 *
 * One manual plan-override audit entry.
 */
export type PlanOverrideAuditRow = {
    /**
     * Id
     */
    id: number;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Actor Email
     */
    actor_email: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Feature
     */
    feature: string;
    /**
     * Before Status
     */
    before_status: string | null;
    /**
     * Before Tier
     */
    before_tier: string | null;
    /**
     * After Status
     */
    after_status: string;
    /**
     * After Tier
     */
    after_tier: string;
    /**
     * Before Price Per Unit
     */
    before_price_per_unit: number | null;
    /**
     * After Price Per Unit
     */
    after_price_per_unit: number | null;
    /**
     * Reason
     */
    reason: string | null;
    /**
     * Payment Provider Subscription Id
     */
    payment_provider_subscription_id: string | null;
    /**
     * Warnings
     */
    warnings: Array<string>;
};

/**
 * Polarity
 *
 * What the passage does to the predicate. ``UNKNOWN`` is a real answer: a
 * source that raises the question and leaves it open is evidence OF a gap.
 */
export enum Polarity {
    AFFIRMS = 'affirms',
    DENIES = 'denies',
    UNKNOWN = 'unknown'
}

/**
 * PolicyAcceptance
 *
 * Schema for a policy acceptance record
 *
 * Returned when retrieving policy acceptance history
 */
export type PolicyAcceptance = {
    /**
     * Id
     *
     * ID of the acceptance record
     */
    id: number;
    /**
     * User Id
     *
     * ID of the user who accepted
     */
    user_id: string;
    /**
     * Policy Type
     *
     * Type of policy accepted
     */
    policy_type: string;
    /**
     * Version
     *
     * Version of the policy accepted
     */
    version: string;
    /**
     * Accepted At
     *
     * When the policy was accepted
     */
    accepted_at: Date;
    /**
     * User Agent
     *
     * User agent when accepted
     */
    user_agent?: string | null;
};

/**
 * PolicyAcceptanceRequest
 *
 * Schema for recording user acceptance of a policy (privacy/terms)
 *
 * Used when user explicitly accepts a policy with version information
 */
export type PolicyAcceptanceRequest = {
    /**
     * Policy Type
     *
     * Type of policy: 'privacy_policy' or 'terms_conditions'
     */
    policy_type: string;
    /**
     * Version
     *
     * Policy version (optional, defaults to current version)
     */
    version?: string | null;
    /**
     * User Agent
     *
     * User agent string (optional)
     */
    user_agent?: string | null;
};

/**
 * PolicyAcceptanceStatus
 *
 * Schema for checking if user has accepted current policies.
 * Used to determine if user needs to accept new policy versions.
 */
export type PolicyAcceptanceStatus = {
    /**
     * Needs Privacy Policy Acceptance
     *
     * Needs to accept a (new) privacy policy.
     */
    needs_privacy_policy_acceptance: boolean;
    /**
     * Privacy Policy Accepted
     *
     * Has accepted current privacy policy
     */
    privacy_policy_accepted: boolean;
    /**
     * Privacy Policy Version
     *
     * Version of privacy policy accepted
     */
    privacy_policy_version?: string | null;
    /**
     * Privacy Policy Accepted At
     *
     * When privacy policy was accepted
     */
    privacy_policy_accepted_at?: Date | null;
    /**
     * Needs Terms Conditions Acceptance
     *
     * Needs to accept a (new) terms of use.
     */
    needs_terms_conditions_acceptance: boolean;
    /**
     * Terms Conditions Accepted
     *
     * Has accepted current terms of use
     */
    terms_conditions_accepted: boolean;
    /**
     * Terms Conditions Version
     *
     * Version of terms of use accepted
     */
    terms_conditions_version?: string | null;
    /**
     * Terms Conditions Accepted At
     *
     * When terms of use were accepted
     */
    terms_conditions_accepted_at?: Date | null;
};

/**
 * PoolResolutionPreview
 *
 * API schema for the decision-time BPMN preview of a pool resolution:
 * the opt-in rename composed with the eventual pool→lane end-state per
 * affected process. ``proposal_fingerprint`` pins the whole preview; the
 * resolve verbs' one-click accept (``convert_to_lane``) requires it and
 * refuses on drift.
 */
export type PoolResolutionPreview = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * Proposal Fingerprint
     */
    proposal_fingerprint: string;
    /**
     * Processes
     */
    processes?: Array<ProcessProposal>;
};

/**
 * PoolRolePromotion
 *
 * API schema for one domain's role of a promoted pool.
 */
export type PoolRolePromotion = {
    role: DerivedEvidenceRef;
    domain: DerivedEvidenceRef;
    /**
     * Created
     */
    created: boolean;
};

/**
 * PoolTriageDecision
 *
 * API schema for one pool-triage decision record — the durable,
 * revisitable outcome of resolving a pool (party / application /
 * internal_function / internal_reference). At most one record per pool is
 * ``active``; retracted records are history.
 */
export type PoolTriageDecision = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * Resolution
     */
    resolution: string;
    /**
     * App Scope
     */
    app_scope?: string | null;
    target?: DerivedEvidenceRef | null;
    /**
     * Target Kind
     */
    target_kind?: string | null;
    /**
     * Created Target
     */
    created_target?: boolean;
    /**
     * Role Ids
     */
    role_ids?: Array<string>;
    /**
     * Created Role Ids
     */
    created_role_ids?: Array<string>;
    /**
     * Absorbed Role Ids
     */
    absorbed_role_ids?: Array<string>;
    /**
     * Recipient Only
     */
    recipient_only?: boolean;
    /**
     * Linked Task Ids
     */
    linked_task_ids?: Array<string>;
    /**
     * Renamed Pools
     */
    renamed_pools?: Array<RenamedPool>;
    /**
     * Flow Count
     */
    flow_count?: number;
    /**
     * Processes
     */
    processes?: Array<DerivedEvidenceRef>;
    /**
     * Decided By Email
     */
    decided_by_email?: string;
    /**
     * Decided By Name
     */
    decided_by_name?: string;
    /**
     * Decided At
     */
    decided_at: Date;
    suggestion?: PoolTriageSuggestion | null;
    /**
     * Followed Suggestion
     */
    followed_suggestion?: boolean | null;
    /**
     * Status
     */
    status?: string;
    /**
     * Retracted By Email
     */
    retracted_by_email?: string | null;
    /**
     * Retracted At
     */
    retracted_at?: Date | null;
};

/**
 * PoolTriageSuggestion
 *
 * API schema for the AI triage guidance of one unresolved external pool:
 * the four-way pre-sort (party / application / internal function / internal
 * reference; "manual" = a human must look). AI suggests, the user decides.
 *
 * ``unify_with``/``rename_to`` mark sibling pool spellings judged to be ONE
 * internal function: the losing spelling(s) carry the surviving term in
 * ``rename_to`` (the survivor keeps None). Never safe.
 */
export type PoolTriageSuggestion = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * Recommend
     */
    recommend: string;
    party_type?: PartyType | null;
    matched_entity?: DerivedEvidenceRef | null;
    /**
     * Matched Entity Type
     */
    matched_entity_type?: string | null;
    /**
     * Confidence
     */
    confidence: string;
    /**
     * Safe
     */
    safe?: boolean;
    /**
     * Reason
     */
    reason: string;
    /**
     * Unify With
     */
    unify_with?: Array<string>;
    /**
     * Rename To
     */
    rename_to?: string | null;
    /**
     * App Scope
     */
    app_scope?: string | null;
};

/**
 * PortalSessionRequest
 */
export type PortalSessionRequest = {
    /**
     * Feature Key
     */
    feature_key?: string | null;
    /**
     * Return Path
     */
    return_path?: string | null;
};

/**
 * PortalSessionResponse
 */
export type PortalSessionResponse = {
    /**
     * Portal Url
     */
    portal_url: string;
};

/**
 * PrepareResponse
 */
export type PrepareResponse = {
    /**
     * Auth Url
     */
    auth_url: string;
};

/**
 * Process
 *
 * Request body for Product.
 */
export type Process = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    process_definition?: Artefact | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * Is Generating
     */
    is_generating?: boolean;
};

/**
 * ProcessElement
 *
 * Request body for Task.
 */
export type ProcessElement = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Is Archived
     */
    is_archived?: boolean;
    /**
     * Archived At
     */
    archived_at?: Date | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    type: ProcessElementType;
    /**
     * Subtype
     */
    subtype?: string | null;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
    /**
     * Document Count
     */
    document_count?: number;
};

/**
 * ProcessElementMetrics
 *
 * Aggregated live metrics for a single BPMN element within a process.
 *
 * Powers the live overlay on the BPMN: how many running instances are parked
 * here now, how many passed through in the period, the average dwell time, and
 * how many errors occurred at this element.
 */
export type ProcessElementMetrics = {
    /**
     * Element Id
     */
    element_id: string;
    /**
     * Here Now
     */
    here_now?: number;
    /**
     * Throughput
     */
    throughput?: number;
    /**
     * Avg Duration Seconds
     */
    avg_duration_seconds?: number | null;
    /**
     * Error Count
     */
    error_count?: number;
};

/**
 * ProcessElementType
 */
export enum ProcessElementType {
    TASK = 'task',
    GATEWAY = 'gateway',
    EVENT = 'event',
    FLOW = 'flow'
}

/**
 * ProcessEvent
 */
export type ProcessEvent = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Is Archived
     */
    is_archived?: boolean;
    /**
     * Archived At
     */
    archived_at?: Date | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    type?: ProcessElementType;
    /**
     * Subtype
     */
    subtype?: string | null;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
    /**
     * Document Count
     */
    document_count?: number;
};

/**
 * ProcessFlow
 */
export type ProcessFlow = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Is Archived
     */
    is_archived?: boolean;
    /**
     * Archived At
     */
    archived_at?: Date | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    type?: ProcessElementType;
    /**
     * Subtype
     */
    subtype?: string | null;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
    /**
     * Document Count
     */
    document_count?: number;
};

/**
 * ProcessGateway
 */
export type ProcessGateway = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Is Archived
     */
    is_archived?: boolean;
    /**
     * Archived At
     */
    archived_at?: Date | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    type?: ProcessElementType;
    /**
     * Subtype
     */
    subtype?: string | null;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
    /**
     * Document Count
     */
    document_count?: number;
};

/**
 * ProcessInTree
 *
 * Process representation inside worktree, does not describe Process.
 */
export type ProcessInTree = {
    /**
     * Identity
     */
    identity: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Order Index
     */
    order_index: number;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * Diff Status
     */
    diff_status?: 'added' | 'modified' | 'removed' | null;
};

/**
 * ProcessInstanceMetrics
 *
 * Runtime metrics for a single process instance.
 */
export type ProcessInstanceMetrics = {
    /**
     * Process Instance Id
     */
    process_instance_id: string;
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Business Key
     */
    business_key?: string | null;
    /**
     * Stek Release
     */
    stek_release: string;
    /**
     * Started At
     */
    started_at: Date;
    /**
     * Last Event At
     */
    last_event_at: Date;
    /**
     * Duration Seconds
     */
    duration_seconds?: number | null;
    /**
     * Total Events
     */
    total_events: number;
    /**
     * Error Count
     */
    error_count: number;
    /**
     * Compliance Proof Count
     */
    compliance_proof_count?: number;
    /**
     * Status
     */
    status: 'running' | 'completed' | 'failed' | 'stale';
    /**
     * Current Step
     */
    current_step?: string | null;
    /**
     * Current Element Id
     */
    current_element_id?: string | null;
    /**
     * Events By Type
     */
    events_by_type: {
        [key: string]: number;
    };
};

/**
 * ProcessProposal
 *
 * API schema for one process's proposed restructure (after-XML + summary).
 */
export type ProcessProposal = {
    process: DerivedEvidenceRef;
    /**
     * Proposed Xml
     */
    proposed_xml: string;
    /**
     * Summary
     */
    summary?: Array<string>;
    /**
     * Removed
     */
    removed?: Array<RemovedElement>;
};

/**
 * ProcessTask
 */
export type ProcessTask = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
    /**
     * Is Archived
     */
    is_archived?: boolean;
    /**
     * Archived At
     */
    archived_at?: Date | null;
    /**
     * Short Description
     */
    short_description?: string | null;
    type?: ProcessElementType;
    /**
     * Subtype
     */
    subtype?: string | null;
    /**
     * Entity Refs
     */
    entity_refs?: Array<EntityRef>;
    /**
     * Document Count
     */
    document_count?: number;
    /**
     * Process Id
     */
    process_id?: string | null;
    ui_code?: Artefact | null;
    /**
     * Generates Evidence
     */
    generates_evidence?: boolean;
    evidence_instructions?: Artefact | null;
};

/**
 * ProcessTaskLink
 *
 * API schema for a typed link from an Application to a ProcessTask.
 */
export type ProcessTaskLink = {
    /**
     * Process Task Id
     */
    process_task_id: string;
    mode?: TaskLinkMode;
};

/**
 * Product
 *
 * Request body for Product.
 */
export type Product = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
};

/**
 * ProductInTree
 *
 * Product representation inside worktree, does not describe Product.
 */
export type ProductInTree = {
    /**
     * Identity
     */
    identity: string;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    /**
     * Name
     */
    name: string;
    /**
     * Order Index
     */
    order_index: number;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * Diff Status
     */
    diff_status?: 'added' | 'modified' | 'removed' | null;
    /**
     * Processes
     */
    processes: Array<ProcessInTree>;
};

/**
 * ProposedCompetitor
 *
 * A competitor that is not part of the stek's market yet.
 *
 * ``state`` is "suggested" (waiting on an answer, addressed by entry_id +
 * action_index) or "pending" (accepted, written to the thread's branch, and
 * waiting on the thread itself — no action left to address).
 */
export type ProposedCompetitor = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * State
     */
    state: string;
    /**
     * Entry Id
     */
    entry_id?: string | null;
    /**
     * Action Index
     */
    action_index?: number | null;
    /**
     * Name
     */
    name: string;
    /**
     * Is Group
     */
    is_group?: boolean;
    /**
     * Position
     */
    position?: string | null;
    /**
     * Profile
     */
    profile?: string | null;
    /**
     * Website
     */
    website?: string | null;
    /**
     * Their Position
     */
    their_position?: string | null;
    /**
     * Where We Win
     */
    where_we_win?: string | null;
    /**
     * Threat Level
     */
    threat_level?: string | null;
    /**
     * Sources
     */
    sources?: Array<string>;
};

/**
 * ReferenceSchema
 */
export type ReferenceSchema = {
    /**
     * Type
     */
    type: string;
    /**
     * Entity Type
     */
    entity_type?: string | null;
    /**
     * Entity Id
     */
    entity_id?: string | null;
    /**
     * Entity Name
     */
    entity_name?: string | null;
    /**
     * Thread Id
     */
    thread_id?: string | null;
    /**
     * Title
     */
    title?: string | null;
    /**
     * Status
     */
    status?: string | null;
};

/**
 * RefreshState
 */
export enum RefreshState {
    NEVER_RUN = 'never_run',
    RUNNING = 'running',
    IDLE = 'idle',
    FAILED = 'failed'
}

/**
 * RefreshStatus
 *
 * What the last extraction run did. A failed run reports as failed.
 */
export type RefreshStatus = {
    state: RefreshState;
    /**
     * Started At
     */
    started_at?: Date | null;
    /**
     * Finished At
     */
    finished_at?: Date | null;
    /**
     * Revision
     */
    revision?: string | null;
    /**
     * Extractor Version
     */
    extractor_version?: string;
    /**
     * Sources Read
     */
    sources_read?: number;
    /**
     * Sources Unreadable
     */
    sources_unreadable?: number;
    /**
     * Sources Unanalysed
     */
    sources_unanalysed?: number;
    /**
     * Claims
     */
    claims?: number;
    /**
     * Error
     */
    error?: string | null;
};

/**
 * RegisterSessionRequest
 */
export type RegisterSessionRequest = {
    /**
     * Host
     */
    host: string;
    /**
     * Organization Id
     */
    organization_id: string;
    /**
     * Services
     */
    services?: Array<string>;
    context: SessionContext;
    /**
     * Ttl Seconds
     */
    ttl_seconds?: number;
};

/**
 * RegisterSessionResponse
 */
export type RegisterSessionResponse = {
    /**
     * Session Id
     */
    session_id: string;
    /**
     * Host
     */
    host: string;
    /**
     * Expires At
     */
    expires_at: Date;
    /**
     * Enter Url
     */
    enter_url: string;
};

/**
 * RegrantAgentTokenRequest
 */
export type RegrantAgentTokenRequest = {
    /**
     * Token Id
     */
    token_id: string;
    /**
     * Grant Write Access
     */
    grant_write_access?: boolean;
    /**
     * Grant Events Write Access
     */
    grant_events_write_access?: boolean;
};

/**
 * RelationshipDirection
 *
 * Direction of a relationship from the perspective of the current entity.
 */
export enum RelationshipDirection {
    OUTGOING = 'outgoing',
    INCOMING = 'incoming'
}

/**
 * ReleaseDiffResponse
 *
 * Combined diff across a stek's repos — every domain, plus the stek repo.
 */
export type ReleaseDiffResponse = {
    /**
     * From Release
     */
    from_release: string | null;
    /**
     * To Release
     */
    to_release: string;
    /**
     * Domain Diffs
     */
    domain_diffs: Array<DomainDiffResponse>;
    stek_diff?: RepoDiffResponse | null;
    /**
     * Total Files Changed
     */
    total_files_changed: number;
    /**
     * Total Additions
     */
    total_additions: number;
    /**
     * Total Deletions
     */
    total_deletions: number;
};

/**
 * RemovedElement
 *
 * API schema for one flow node a proposed restructure deletes.
 */
export type RemovedElement = {
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Link Count
     */
    link_count?: number;
};

/**
 * RenamedPool
 *
 * API schema for one pool spelling a decision renamed away (into the
 * record's own ``pool_name``) and the processes it was rewritten in.
 */
export type RenamedPool = {
    /**
     * Pool Name
     */
    pool_name: string;
    /**
     * Processes
     */
    processes?: Array<DerivedEvidenceRef>;
};

/**
 * RepoDiffResponse
 *
 * Diff for a single repo between two releases.
 */
export type RepoDiffResponse = {
    /**
     * From Ref
     */
    from_ref: string;
    /**
     * To Ref
     */
    to_ref: string;
    /**
     * Files Changed
     */
    files_changed: number;
    /**
     * Additions
     */
    additions: number;
    /**
     * Deletions
     */
    deletions: number;
    /**
     * Changed Files
     */
    changed_files: Array<DiffStatResponse>;
};

/**
 * Requirement
 *
 * What must be true, for which parts of the business.
 */
export type Requirement = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Topic Key
     */
    topic_key: string;
    /**
     * Title
     */
    title: string;
    /**
     * Condition
     */
    condition?: {
        [key: string]: unknown;
    };
    scope?: ScopeSelector;
    status: RequirementStatus;
    source?: SourceRef | null;
    /**
     * Confirmed By
     */
    confirmed_by?: string | null;
    /**
     * Confirmed At
     */
    confirmed_at?: Date | null;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Updated At
     */
    updated_at: Date;
    /**
     * Exceptions
     */
    exceptions?: Array<RequirementException>;
};

/**
 * RequirementException
 *
 * An accepted exception - reported alongside satisfaction, never folded in.
 */
export type RequirementException = {
    /**
     * Identity
     */
    identity: string;
    scope: ScopeSelector;
    /**
     * Reason
     */
    reason: string;
    /**
     * Owner
     */
    owner: string;
    /**
     * Recorded At
     */
    recorded_at: Date;
    /**
     * Review At
     */
    review_at?: Date | null;
    /**
     * Legal Obligation
     */
    legal_obligation?: boolean;
};

/**
 * RequirementStatus
 *
 * A requirement extracted from a document is PROPOSED until a person says
 * it is the requirement they meant. Only a confirmed requirement can turn a
 * card red.
 */
export enum RequirementStatus {
    PROPOSED = 'proposed',
    CONFIRMED = 'confirmed',
    RETIRED = 'retired'
}

/**
 * ResolutionStep
 *
 * API schema for one ordered step of an issue's derived resolution plan:
 * either an automatable verb with prefilled arguments, or edit-site
 * pointers. ``status`` is recomputed from evidence on every derivation.
 */
export type ResolutionStep = {
    /**
     * Order
     */
    order: number;
    /**
     * Title
     */
    title: string;
    /**
     * Status
     */
    status: string;
    /**
     * Verb
     */
    verb?: string | null;
    /**
     * Args Hint
     */
    args_hint?: {
        [key: string]: unknown;
    } | null;
    /**
     * Edit Sites
     */
    edit_sites?: Array<EditSite>;
    /**
     * Note
     */
    note?: string | null;
};

/**
 * RestructureProposal
 *
 * API schema for a restructure preview. The fingerprint pins the preview
 * to its inputs; the apply endpoint requires it and refuses on drift.
 */
export type RestructureProposal = {
    /**
     * Issue Key
     */
    issue_key: string;
    /**
     * Proposal Fingerprint
     */
    proposal_fingerprint: string;
    /**
     * Processes
     */
    processes?: Array<ProcessProposal>;
};

/**
 * ReviewCustomTopicRequest
 */
export type ReviewCustomTopicRequest = {
    /**
     * Key
     */
    key: string;
    /**
     * Reviewed
     */
    reviewed?: boolean;
    /**
     * Retire
     */
    retire?: boolean;
};

/**
 * RevocationRequest
 *
 * Token revocation request.
 */
export type RevocationRequest = {
    /**
     * Token
     */
    token: string;
    /**
     * Token Type Hint
     */
    token_type_hint?: string | null;
    /**
     * Client Id
     */
    client_id?: string | null;
};

/**
 * Role
 *
 * Request body for Role.
 */
export type Role = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Domain Id
     */
    domain_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Responsibilities
     */
    responsibilities?: Array<RoleResponsibility>;
    /**
     * Short Description
     */
    short_description?: string | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    description?: Artefact | null;
};

/**
 * RoleResponsibility
 *
 * Process Task is a RoleResponsibility.
 */
export type RoleResponsibility = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Process Name
     */
    process_name: string;
    /**
     * Bpmn Id
     */
    bpmn_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Short Description
     */
    short_description?: string | null;
};

/**
 * ScopeAnchor
 *
 * One named subject a requirement or finding is about.
 */
export type ScopeAnchor = {
    kind: ScopeAnchorKind;
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name?: string;
    /**
     * Parent Id
     */
    parent_id?: string | null;
};

/**
 * ScopeAnchorKind
 *
 * The existing stable entity kinds a requirement can be anchored to.
 *
 * Deployment and environment are deliberately absent: the model has no
 * deployment entity, and inventing one to hang a requirement off would make
 * the scope look more precise than the evidence behind it.
 */
export enum ScopeAnchorKind {
    STEK = 'stek',
    DOMAIN = 'domain',
    PROCESS = 'process',
    PROCESS_TASK = 'process_task',
    APPLICATION = 'application',
    APPLICATION_ENTITY = 'application_entity',
    BUSINESS_ENTITY = 'business_entity',
    EXTERNAL_PARTY = 'external_party'
}

/**
 * ScopeFinding
 *
 * One scope's answer, with the claims that produced it.
 */
export type ScopeFinding = {
    scope: ScopeAnchor;
    status: AssessmentStatus;
    /**
     * Reason
     */
    reason?: string;
    /**
     * Dimension
     */
    dimension?: string | null;
    /**
     * Downstream
     */
    downstream?: boolean;
    /**
     * Supporting Claim Keys
     */
    supporting_claim_keys?: Array<string>;
    /**
     * Contradicting Claim Keys
     */
    contradicting_claim_keys?: Array<string>;
    /**
     * Unknowns
     */
    unknowns?: Array<string>;
};

/**
 * ScopeRequest
 *
 * The page's scope and evidence selectors.
 */
export type ScopeRequest = {
    /**
     * Scope Anchors
     */
    scope_anchors?: Array<ScopeAnchor>;
    /**
     * Scope Selector
     */
    scope_selector?: string | null;
    view?: EvidenceView;
};

/**
 * ScopeSelector
 *
 * What a requirement applies to: named anchors plus the qualification in words.
 */
export type ScopeSelector = {
    /**
     * Anchors
     */
    anchors?: Array<ScopeAnchor>;
    /**
     * Selector
     */
    selector?: string | null;
    /**
     * Include Downstream
     */
    include_downstream?: boolean;
};

/**
 * SearchResponse
 */
export type SearchResponse = {
    /**
     * Results
     */
    results: Array<SearchResultItem>;
};

/**
 * SearchResultItem
 */
export type SearchResultItem = {
    /**
     * Id
     */
    id: string;
    /**
     * Type
     */
    type: string;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Breadcrumbs
     */
    breadcrumbs?: Array<string> | null;
};

/**
 * SessionContext
 *
 * What the preview serves — shown to colleagues on the entry page.
 *
 * Informational labels supplied by the relay (projects/branch as
 * prepared, creator conversation, data classification). Not authorization
 * state: entry stays gated on org membership regardless of what is
 * written here.
 */
export type SessionContext = {
    /**
     * Projects
     */
    projects?: Array<string>;
    /**
     * Branch
     */
    branch?: string;
    /**
     * Creator
     */
    creator?: string;
    /**
     * Data Classification
     */
    data_classification: 'synthetic' | 'restricted';
};

/**
 * SessionStatusResponse
 */
export type SessionStatusResponse = {
    /**
     * Host
     */
    host: string;
    /**
     * Active
     */
    active: boolean;
    /**
     * Expires At
     */
    expires_at: Date;
};

/**
 * SetCustomTopicRequest
 */
export type SetCustomTopicRequest = {
    /**
     * Key
     */
    key: string;
    /**
     * Title
     */
    title: string;
    /**
     * Question
     */
    question: string;
    /**
     * Criteria
     */
    criteria?: string | null;
    /**
     * Predicates
     */
    predicates?: Array<string>;
    /**
     * Distinctions
     */
    distinctions?: Array<string>;
    /**
     * Evidence Needs
     */
    evidence_needs?: Array<string>;
};

/**
 * SetRequirementExceptionRequest
 *
 * Record or withdraw an accepted exception on a requirement.
 */
export type SetRequirementExceptionRequest = {
    /**
     * Requirement Id
     */
    requirement_id: string;
    /**
     * Exception Id
     */
    exception_id?: string | null;
    /**
     * Reason
     */
    reason?: string | null;
    /**
     * Scope Anchors
     */
    scope_anchors?: Array<ScopeAnchor>;
    /**
     * Scope Selector
     */
    scope_selector?: string | null;
    /**
     * Review At
     */
    review_at?: Date | null;
    /**
     * Legal Obligation
     */
    legal_obligation?: boolean;
    /**
     * Remove
     */
    remove?: boolean;
};

/**
 * SetRequirementRequest
 *
 * Create or update a requirement. Omit ``requirement_id`` to create one.
 */
export type SetRequirementRequest = {
    /**
     * Requirement Id
     */
    requirement_id?: string | null;
    /**
     * Topic Key
     */
    topic_key: string;
    /**
     * Title
     */
    title: string;
    /**
     * Condition
     */
    condition?: {
        [key: string]: unknown;
    };
    /**
     * Scope Anchors
     */
    scope_anchors?: Array<ScopeAnchor>;
    /**
     * Scope Selector
     */
    scope_selector?: string | null;
    /**
     * Include Downstream
     */
    include_downstream?: boolean;
    status?: RequirementStatus;
};

/**
 * SetupAdoptionItem
 *
 * One row of the (unweighted) adoption checklist.
 */
export type SetupAdoptionItem = {
    /**
     * Id
     */
    id: string;
    /**
     * Done
     */
    done: boolean;
};

/**
 * SetupChecklistEntry
 *
 * Per-stek snooze/dismiss state for the setup-completeness card.
 */
export type SetupChecklistEntry = {
    /**
     * Snoozed Until
     */
    snoozed_until?: Date | null;
    /**
     * Dismissed
     */
    dismissed?: boolean;
};

/**
 * SetupCompletenessItem
 *
 * One row of the setup-completeness checklist.
 */
export type SetupCompletenessItem = {
    /**
     * Id
     */
    id: string;
    /**
     * Category
     */
    category: 'strategy' | 'structure' | 'process';
    /**
     * Weight
     */
    weight: number;
    /**
     * Fraction
     */
    fraction: number;
    /**
     * Done
     */
    done: boolean;
    /**
     * Current
     */
    current: number;
    /**
     * Target
     */
    target: number;
};

/**
 * SetupStatus
 *
 * Response body for the stek setup-completeness card.
 */
export type SetupStatus = {
    /**
     * Score
     */
    score: number;
    /**
     * Is New
     */
    is_new: boolean;
    /**
     * Completeness
     */
    completeness: Array<SetupCompletenessItem>;
    /**
     * Adoption
     */
    adoption: Array<SetupAdoptionItem>;
};

/**
 * SignalKind
 *
 * What kind of evidence an observation is. Closed — no plugin registry.
 */
export enum SignalKind {
    VIEWED = 'viewed',
    DWELL = 'dwell',
    ELEMENT_FOCUSED = 'element_focused',
    EDITED = 'edited',
    MEMORY_UPDATED = 'memory_updated',
    ENTITY_ACTIVITY = 'entity_activity',
    THREAD_CONTEXT = 'thread_context'
}

/**
 * SourceKind
 */
export enum SourceKind {
    ARTEFACT = 'artefact',
    ENTITY_DESCRIPTION = 'entity_description',
    MODEL_RELATIONSHIP = 'model_relationship',
    USER_ANSWER = 'user_answer',
    RUN_EVIDENCE = 'run_evidence'
}

/**
 * SourceRef
 *
 * Where a claim came from, precisely enough to open it.
 */
export type SourceRef = {
    kind: SourceKind;
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name?: string;
    /**
     * Location
     */
    location?: string | null;
    /**
     * Passage
     */
    passage?: string | null;
    /**
     * Revision
     */
    revision?: string | null;
    entity?: ScopeAnchor | null;
    /**
     * Updated At
     */
    updated_at?: Date | null;
};

/**
 * Stek
 *
 * Request body for Stek.
 */
export type Stek = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
    /**
     * Fqdn
     */
    fqdn: string;
    logo?: Artefact | null;
    description?: Artefact | null;
    mission?: Artefact | null;
    vision?: Artefact | null;
    mission_vision?: Artefact | null;
    core_values?: Artefact | null;
    specializations?: Artefact | null;
    target_markets?: Artefact | null;
    /**
     * User Artefact Group Id
     */
    user_artefact_group_id?: string | null;
    /**
     * Dev Mode Enabled
     */
    dev_mode_enabled?: boolean;
};

/**
 * StekDrift
 *
 * API schema for the stek's build drift: changes, tickets, suggestions and
 * counts in ONE payload — they are derived together and the page needs all of
 * them, so splitting them into separate endpoints would recompute the same
 * scan three times and let the three halves disagree.
 */
export type StekDrift = {
    /**
     * Stek Id
     */
    stek_id: string;
    ledger?: DriftLedger;
    /**
     * Changes
     */
    changes?: Array<DriftChange>;
    counts?: DriftCounts;
    /**
     * Tickets
     */
    tickets?: Array<BuildTicket>;
    /**
     * Suggestions
     */
    suggestions?: Array<DriftSuggestion>;
};

/**
 * StekEvent
 *
 * An event from a running Stek for live mode monitoring.
 */
export type StekEvent = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Event Type
     */
    event_type: string;
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Stek Release
     */
    stek_release: string;
    /**
     * Process Instance Id
     */
    process_instance_id: string;
    /**
     * Domain Id
     */
    domain_id?: string | null;
    /**
     * Product Id
     */
    product_id?: string | null;
    /**
     * Process Id
     */
    process_id?: string | null;
    /**
     * Process Element Id
     */
    process_element_id?: string | null;
    /**
     * Business Key
     */
    business_key?: string | null;
    /**
     * Payload
     */
    payload: {
        [key: string]: unknown;
    };
    /**
     * Timestamp
     *
     * The moment the event occurred in the running Stek (Business Time)
     */
    timestamp: Date;
    /**
     * Created At
     *
     * The moment the event was ingested by our backend (System Time)
     */
    created_at: Date;
};

/**
 * StekGeneratedDetails
 *
 * Subsections that define the structure of a stek.
 */
export type StekGeneratedDetails = {
    /**
     * Description
     */
    description?: string | null;
    /**
     * Mission
     */
    mission?: string | null;
    /**
     * Vision
     */
    vision?: string | null;
    /**
     * Core Values
     */
    core_values?: string | null;
    /**
     * Specializations
     */
    specializations?: string | null;
    /**
     * Target Markets
     */
    target_markets?: string | null;
};

/**
 * StekReleaseResponse
 *
 * Response for a stek release.
 */
export type StekReleaseResponse = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string | null;
    /**
     * Created By
     */
    created_by: string;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Domain Commits
     */
    domain_commits: Array<DomainCommitResponse>;
    /**
     * Stek Commit
     */
    stek_commit?: string | null;
};

/**
 * StekRole
 *
 * API schema for one stek role with its domain — the triage's
 * link-to-existing-role picker candidates.
 */
export type StekRole = {
    role: DerivedEvidenceRef;
    domain: DerivedEvidenceRef;
};

/**
 * StrategyDiff
 *
 * Thread diff_status for the three stek-level Strategy sidebar items
 * (mission/vision, objectives, horizons). None when not viewing a thread.
 */
export type StrategyDiff = {
    /**
     * Mission Vision
     */
    mission_vision?: 'added' | 'modified' | 'removed' | null;
    /**
     * Objectives
     */
    objectives?: 'added' | 'modified' | 'removed' | null;
    /**
     * Horizons
     */
    horizons?: 'added' | 'modified' | 'removed' | null;
};

/**
 * SubscriptionAdminRow
 *
 * A flattened view of a (org × feature) subscription for admin reporting.
 */
export type SubscriptionAdminRow = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Org Id
     */
    org_id: string;
    /**
     * Feature
     */
    feature: string;
    /**
     * Status
     */
    status: string;
    /**
     * Plan Tier
     */
    plan_tier: string;
    /**
     * Monthly Cap
     */
    monthly_cap: number;
    /**
     * Payment Provider Subscription Id
     */
    payment_provider_subscription_id: string | null;
    /**
     * Current Period Start
     */
    current_period_start: Date | null;
    /**
     * Current Period End
     */
    current_period_end: Date | null;
    /**
     * Cancel At Period End
     */
    cancel_at_period_end: boolean;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Updated At
     */
    updated_at: Date;
};

/**
 * Suggestion
 *
 * One statement worth a person's morning.
 *
 * Carries no verb, no apply, no status and no assignee — by design and for
 * the whole demo. ``fix`` says what KIND of fix the underlying finding has so
 * a reader knows what conversation they are about to have; acting on it still
 * runs through a thread.
 */
export type Suggestion = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Statement
     */
    statement: string;
    /**
     * Kind
     */
    kind: 'design' | 'run';
    about: SuggestionSubject;
    /**
     * Fix
     */
    fix: 'automatic' | 'question' | 'judgement';
    /**
     * Fix Line
     */
    fix_line?: string | null;
    /**
     * Because
     */
    because?: string | null;
};

/**
 * SuggestionSubject
 *
 * What a suggestion covers, plus the noun saying what those things are.
 *
 * The noun ships with the list because the axis differs by rule type —
 * "seven processes" and "six recipients" are both correct, for different
 * findings, and a client that assumed either would be wrong half the time.
 */
export type SuggestionSubject = {
    /**
     * Noun
     */
    noun: string;
    /**
     * Items
     */
    items?: Array<string>;
    /**
     * Total
     */
    total: number;
};

/**
 * SupportedProvidersResponse
 *
 * Response containing the supported providers for a task type.
 */
export type SupportedProvidersResponse = {
    /**
     * The task type
     */
    task_type: TaskType;
    /**
     * Supported Providers
     *
     * List of supported providers for this task type
     */
    supported_providers: Array<ModelProvider>;
};

/**
 * TaskEvaluationListResponse
 *
 * Response for listing task evaluations.
 */
export type TaskEvaluationListResponse = {
    /**
     * Results
     *
     * List of task evaluation results
     */
    results: Array<TaskEvaluationResult>;
};

/**
 * TaskEvaluationRequest
 *
 * Request for task evaluation.
 */
export type TaskEvaluationRequest = {
    /**
     * Type of task to evaluate
     */
    task_type: TaskType;
    /**
     * Task Config
     *
     * Configuration parameters for the task
     */
    task_config: {
        [key: string]: unknown;
    };
    /**
     * Agent Config
     *
     * Agent configuration (name, system_message, description)
     */
    agent_config: {
        [key: string]: unknown;
    };
    /**
     * Model configuration
     */
    llm_config: ModelConfig;
};

/**
 * TaskEvaluationResult
 *
 * Result of a task evaluation.
 */
export type TaskEvaluationResult = {
    /**
     * Task Name
     *
     * Name of the task
     */
    task_name: string;
    /**
     * Timestamp
     *
     * Timestamp of the task execution
     */
    timestamp: string;
    /**
     * Execution Time Seconds
     *
     * Execution time in seconds
     */
    execution_time_seconds: number;
    /**
     * Agent Name
     *
     * Name of the agent used
     */
    agent_name: string;
    /**
     * Agent System Message
     *
     * System message used for instructing the agent
     */
    agent_system_message?: string | null;
    /**
     * Agent Description
     *
     * Description of the agent
     */
    agent_description?: string | null;
    /**
     * Prompt
     *
     * Prompt used for the task
     */
    prompt: string;
    /**
     * Context Prompt
     *
     * Context prompt used for the task
     */
    context_prompt?: string | null;
    /**
     * Function
     *
     * Function used to execute the task
     */
    function: string;
    /**
     * Output
     *
     * Output of the task
     */
    output: string;
    /**
     * Llm Config
     *
     * LLM configuration used
     */
    llm_config: {
        [key: string]: unknown;
    };
    /**
     * Variation Id
     *
     * Variation identifier if part of a batch run
     */
    variation_id?: string | null;
};

/**
 * TaskLinkMode
 *
 * How an application relates to a process task.
 *
 * A task performed by a human *in* an application is supported, not executed:
 * ``automates`` means the software performs the task, ``supports`` means a
 * human performs the task using the software, ``records`` means the software
 * only captures the task's outcome after the fact.
 */
export enum TaskLinkMode {
    AUTOMATES = 'automates',
    SUPPORTS = 'supports',
    RECORDS = 'records'
}

/**
 * TaskType
 *
 * Available task types for evaluation.
 */
export enum TaskType {
    GENERATE_DESCRIPTION = 'generate_description',
    GENERATE_DEFINITION_XML = 'generate_definition_xml',
    GENERATE_USER_INTERFACE = 'generate_user_interface'
}

/**
 * ThreadContextItem
 *
 * A typed piece of background context for the agent (thread- or message-level).
 *
 * ``kind`` selects the renderer; ``data`` is a flat, kind-specific string map,
 * so new kinds need no schema change.
 */
export type ThreadContextItem = {
    kind: ThreadContextKind;
    /**
     * Data
     */
    data?: {
        [key: string]: string;
    };
};

/**
 * ThreadContextKind
 *
 * Kinds of thread/message context. v1 renders ENTITY; the rest are declared
 * for the roadmap and become active as their renderers land.
 */
export enum ThreadContextKind {
    ENTITY = 'entity',
    ONBOARDING = 'onboarding',
    VIEW = 'view',
    STRATEGY = 'strategy',
    SELECTION = 'selection',
    DOCUMENT = 'document',
    FILE = 'file',
    LIVE_METRIC = 'live_metric',
    LIVE_EVENT = 'live_event',
    ARTEFACT = 'artefact',
    ERROR = 'error',
    TIME_RANGE = 'time_range'
}

/**
 * ThreadEntrySchema
 */
export type ThreadEntrySchema = {
    /**
     * Id
     */
    id: string;
    /**
     * Type
     */
    type: string;
    source: EntrySourceSchema;
    /**
     * Content
     */
    content?: string | null;
    /**
     * References
     */
    references?: Array<ReferenceSchema>;
    /**
     * Context Items
     */
    context_items?: Array<ThreadContextItem>;
    /**
     * Resolution Reason
     */
    resolution_reason?: string | null;
    /**
     * Sequence
     */
    sequence: number;
    /**
     * Timestamp
     */
    timestamp: Date;
    /**
     * Visibility
     */
    visibility?: string | null;
    action_detail?: ActionDetailSchema | null;
    /**
     * Message Reason
     */
    message_reason?: string | null;
};

/**
 * ThreadKind
 *
 * A thread's purpose; None for a plain collaboration thread.
 */
export enum ThreadKind {
    STRATEGY_ONBOARDING = 'strategy_onboarding',
    BUSINESS_ONBOARDING = 'business_onboarding',
    STRATEGY_HIGHLIGHT = 'strategy_highlight',
    MARKET_RESEARCH = 'market_research',
    PROCESS_BPMN = 'process_bpmn'
}

/**
 * ThreadListSchema
 */
export type ThreadListSchema = {
    /**
     * Threads
     */
    threads: Array<ThreadSchema>;
    /**
     * Count
     */
    count: number;
};

/**
 * ThreadOffer
 *
 * The thread the box offered when it declined a change.
 *
 * Present only on a refusal. It carries the same offer the prose makes, in a
 * form a button can be built from, so the client never has to read English to
 * decide whether to show one.
 *
 * The entity is optional in two ways that look the same from here: the box
 * offered a thread about nothing in particular, or it named an entity that did
 * not survive resolution. Either way the offer stands and the thread is opened
 * without one, which ``create_thread`` allows.
 */
export type ThreadOffer = {
    /**
     * Title
     *
     * What the thread would be called.
     */
    title: string;
    /**
     * Entity Type
     *
     * The entity it would be about, when there is one.
     */
    entity_type?: string | null;
    /**
     * Entity Id
     *
     * Resolved id — set only when it exists in this stek.
     */
    entity_id?: string | null;
};

/**
 * ThreadSchema
 */
export type ThreadSchema = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Status
     */
    status: string;
    /**
     * Kind
     */
    kind?: string | null;
    /**
     * Origin Watcher Id
     */
    origin_watcher_id?: string | null;
    /**
     * Subject Entity Type
     */
    subject_entity_type?: string | null;
    /**
     * Subject Entity Id
     */
    subject_entity_id?: string | null;
    /**
     * Context Items
     */
    context_items?: Array<ThreadContextItem>;
    /**
     * Branch
     */
    branch: string;
    created_by?: EntrySourceSchema | null;
    /**
     * Created At
     */
    created_at?: Date | null;
    /**
     * Resolved At
     */
    resolved_at?: Date | null;
    resolved_by?: EntrySourceSchema | null;
    /**
     * Resolution Reason
     */
    resolution_reason?: string | null;
    /**
     * Participants
     */
    participants?: Array<string>;
    /**
     * Entry Count
     */
    entry_count?: number;
    /**
     * Affected Entities
     */
    affected_entities?: Array<AffectedEntitySchema>;
    /**
     * Change Summary
     */
    change_summary?: string | null;
    /**
     * Has Pending Agent Run
     */
    has_pending_agent_run?: boolean;
    /**
     * Agent Run Started At
     */
    agent_run_started_at?: number | null;
    /**
     * Agent Progress Steps
     */
    agent_progress_steps?: Array<string>;
    /**
     * Conflicts
     */
    conflicts?: Array<ConflictRecordSchema>;
    /**
     * Auto Apply
     */
    auto_apply?: boolean;
};

/**
 * ThreadWithEntriesSchema
 */
export type ThreadWithEntriesSchema = {
    thread: ThreadSchema;
    /**
     * Entries
     */
    entries?: Array<ThreadEntrySchema>;
};

/**
 * TokenRef
 */
export type TokenRef = {
    /**
     * Token Id
     */
    token_id: string;
};

/**
 * TokenRequest
 *
 * Request body for token exchange endpoint.
 */
export type TokenRequest = {
    /**
     * Code
     */
    code: string;
    /**
     * State
     */
    state: string;
    /**
     * Redirect Uri
     */
    redirect_uri: string;
    /**
     * Integration Type
     */
    integration_type: string;
};

/**
 * TopicDefinition
 *
 * A reusable question definition - built-in, or one the customer wrote.
 */
export type TopicDefinition = {
    /**
     * Key
     */
    key: string;
    /**
     * Version
     */
    version?: number;
    /**
     * Title
     */
    title: string;
    /**
     * Question
     */
    question: string;
    /**
     * Neutral Headline
     */
    neutral_headline?: string;
    /**
     * Evidence Needs
     */
    evidence_needs?: Array<string>;
    /**
     * Predicates
     */
    predicates?: Array<string>;
    /**
     * Distinctions
     */
    distinctions?: Array<string>;
    /**
     * Condition Fields
     */
    condition_fields?: Array<string>;
    /**
     * Dimensions
     */
    dimensions?: Array<TopicDimension>;
    /**
     * Has Evaluator
     */
    has_evaluator?: boolean;
    /**
     * Identity
     */
    identity?: string | null;
    /**
     * Custom
     */
    custom?: boolean;
    /**
     * Reviewed
     */
    reviewed?: boolean;
    /**
     * Reviewed By
     */
    reviewed_by?: string | null;
    /**
     * Reviewed At
     */
    reviewed_at?: Date | null;
    /**
     * Criteria
     */
    criteria?: string | null;
};

/**
 * TopicDetail
 *
 * The reasoning, sources, scope and unknowns behind one card.
 */
export type TopicDetail = {
    definition: TopicDefinition;
    assessment: Assessment;
    /**
     * Requirements
     */
    requirements?: Array<Requirement>;
};

/**
 * TopicDetailRequest
 */
export type TopicDetailRequest = {
    /**
     * Scope Anchors
     */
    scope_anchors?: Array<ScopeAnchor>;
    /**
     * Scope Selector
     */
    scope_selector?: string | null;
    view?: EvidenceView;
    /**
     * Topic Key
     */
    topic_key: string;
};

/**
 * TopicDimension
 *
 * One independently assessed dimension of a profile topic.
 */
export type TopicDimension = {
    /**
     * Key
     */
    key: string;
    /**
     * Title
     */
    title: string;
    /**
     * Question
     */
    question: string;
    /**
     * Predicates
     */
    predicates?: Array<string>;
};

/**
 * Trend
 *
 * Response body for a market Trend.
 */
export type Trend = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Direction
     */
    direction: string;
    /**
     * Sources
     */
    sources?: Array<string>;
    /**
     * Order Index
     */
    order_index?: number;
};

/**
 * TriageIssue
 *
 * API schema for one derived triage issue — a detected divergence between
 * the diagrams and the BPMN standard / house style. ``fingerprint`` pins the
 * evidence a dismissal attaches to.
 */
export type TriageIssue = {
    /**
     * Issue Type
     */
    issue_type: string;
    /**
     * Subject
     */
    subject: string;
    /**
     * Key
     */
    key: string;
    /**
     * Category
     */
    category: string;
    /**
     * Severity
     */
    severity: string;
    /**
     * Title
     */
    title: string;
    /**
     * Detail
     */
    detail: string;
    /**
     * Suggestion
     */
    suggestion?: string | null;
    /**
     * Occurrences
     */
    occurrences?: Array<TriageIssueOccurrence>;
    /**
     * Fingerprint
     */
    fingerprint: string;
    /**
     * Status
     */
    status?: string;
    /**
     * Dismissed By Name
     */
    dismissed_by_name?: string | null;
    /**
     * Dismissed At
     */
    dismissed_at?: Date | null;
    /**
     * Lanes
     */
    lanes?: Array<TriageLaneRef>;
    /**
     * Survivor Name
     */
    survivor_name?: string | null;
    application?: DerivedEvidenceRef | null;
    role?: DerivedEvidenceRef | null;
    party?: DerivedEvidenceRef | null;
    /**
     * Resolution Plan
     */
    resolution_plan?: Array<ResolutionStep>;
};

/**
 * TriageIssueDecision
 *
 * API schema for one triage-issue decision record (a dismissal).
 */
export type TriageIssueDecision = {
    /**
     * Issue Key
     */
    issue_key: string;
    /**
     * Issue Type
     */
    issue_type: string;
    /**
     * Subject
     */
    subject: string;
    /**
     * Action
     */
    action?: string;
    /**
     * Reason
     */
    reason?: string | null;
    /**
     * Decided By Email
     */
    decided_by_email?: string;
    /**
     * Decided By Name
     */
    decided_by_name?: string;
    /**
     * Decided At
     */
    decided_at: Date;
    /**
     * Status
     */
    status?: string;
};

/**
 * TriageIssueList
 *
 * API schema for the stek's derived triage issues.
 */
export type TriageIssueList = {
    /**
     * Issues
     */
    issues?: Array<TriageIssue>;
};

/**
 * TriageIssueOccurrence
 *
 * API schema for one concrete place a derived triage issue was observed.
 */
export type TriageIssueOccurrence = {
    process?: DerivedEvidenceRef | null;
    /**
     * Label
     */
    label: string;
    /**
     * Bpmn Id
     */
    bpmn_id?: string | null;
};

/**
 * TriageLaneRef
 *
 * API schema for one lane a lane-scoped triage issue is about.
 */
export type TriageLaneRef = {
    process: DerivedEvidenceRef;
    /**
     * Lane Bpmn Id
     */
    lane_bpmn_id: string;
    /**
     * Lane Name
     */
    lane_name: string;
    role?: DerivedEvidenceRef | null;
    application?: DerivedEvidenceRef | null;
};

/**
 * TriageLaneTarget
 *
 * API request schema addressing one lane inside one process definition.
 */
export type TriageLaneTarget = {
    /**
     * Process Id
     */
    process_id: string;
    /**
     * Lane Bpmn Id
     */
    lane_bpmn_id: string;
};

/**
 * UntypedParty
 *
 * API schema for an unresolved external pool: no typed ExternalParty
 * claims the name. ``processes`` lists every process the pool appears in.
 */
export type UntypedParty = {
    /**
     * Name
     */
    name: string;
    /**
     * Flow Count
     */
    flow_count: number;
    /**
     * Processes
     */
    processes?: Array<DerivedEvidenceRef>;
};

/**
 * UpdateAgentRequest
 */
export type UpdateAgentRequest = {
    /**
     * Agent Id
     */
    agent_id: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * UpdatePreferences
 *
 * Patch payload for updating user preferences.
 */
export type UpdatePreferences = {
    /**
     * Hints Enabled
     */
    hints_enabled?: boolean | null;
    /**
     * Seen Hints
     */
    seen_hints?: Array<string> | null;
    /**
     * Setup Checklist
     */
    setup_checklist?: {
        [key: string]: SetupChecklistEntry | null;
    } | null;
};

/**
 * UpdateUser
 *
 * Update a user.
 */
export type UpdateUser = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Profile Picture
     */
    profile_picture?: string | null;
};

/**
 * UpdateUserAuthorization
 *
 * Request body for updating the full list of roles for a user in an organization.
 */
export type UpdateUserAuthorization = {
    /**
     * Cluster Roles
     */
    cluster_roles: Array<ClusterRole>;
};

/**
 * UpdateWhatsNewEntry
 *
 * Request body for updating a What's New entry.
 */
export type UpdateWhatsNewEntry = {
    /**
     * Title
     */
    title: string;
    /**
     * Body
     */
    body: string;
    /**
     * Image Url
     */
    image_url?: string | null;
    /**
     * Video Url
     */
    video_url?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Created At
     */
    created_at?: Date | null;
};

/**
 * UploadResponse
 *
 * The public URL of an uploaded asset.
 */
export type UploadResponse = {
    /**
     * Url
     */
    url: string;
};

/**
 * UserActivityResponse
 *
 * User activity response.
 */
export type UserActivityResponse = {
    /**
     * User Id
     */
    user_id: string;
    /**
     * Email
     */
    email: string;
    /**
     * Name
     */
    name: string;
    /**
     * Last Auth At
     */
    last_auth_at: Date | null;
    /**
     * Last Api Key Usage At
     */
    last_api_key_usage_at: Date | null;
    /**
     * Last Activity At
     */
    last_activity_at: Date | null;
    /**
     * Auth Count In Period
     */
    auth_count_in_period: number;
};

/**
 * UserChangeSchema
 *
 * One entity a *user* (not the agent) edited directly on the thread branch.
 *
 * Surfaced in the resolve dialog so a reviewer sees the non-agent footprint they
 * are about to accept/reject. ``diff_status`` is ``added`` | ``modified`` |
 * ``removed``.
 */
export type UserChangeSchema = {
    /**
     * Entity Type
     */
    entity_type: string;
    /**
     * Entity Id
     */
    entity_id: string;
    /**
     * Name
     */
    name?: string;
    /**
     * Diff Status
     */
    diff_status: string;
};

/**
 * UserPermissions
 *
 * Role-derived permissions of the user (what this user may do via their roles).
 */
export type UserPermissions = {
    /**
     * Can Create Stek
     */
    can_create_stek: boolean;
    /**
     * Can Delete Stek
     */
    can_delete_stek: boolean;
    /**
     * Can Manage Stek Settings
     */
    can_manage_stek_settings: boolean;
    /**
     * Can Manage Users
     */
    can_manage_users: boolean;
    /**
     * Can Manage Steks
     */
    can_manage_steks: boolean;
    /**
     * Can Manage Billing
     */
    can_manage_billing: boolean;
    /**
     * Can View Activity Metrics
     */
    can_view_activity_metrics: boolean;
};

/**
 * ValidateInvitationRequest
 *
 * Request body for validating an invitation token.
 */
export type ValidateInvitationRequest = {
    /**
     * Token
     */
    token: string;
};

/**
 * ValidationError
 */
export type ValidationError = {
    /**
     * Location
     */
    loc: Array<string | number>;
    /**
     * Message
     */
    msg: string;
    /**
     * Error Type
     */
    type: string;
    /**
     * Input
     */
    input?: unknown;
    /**
     * Context
     */
    ctx?: {
        [key: string]: unknown;
    };
};

/**
 * Watcher
 *
 * Response body for a Watcher.
 */
export type Watcher = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Title
     */
    title: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Watcher Type
     */
    watcher_type: string;
    /**
     * Interval
     */
    interval: string;
    /**
     * Enabled
     */
    enabled?: boolean;
    /**
     * Created By
     */
    created_by?: string | null;
    /**
     * Created At
     */
    created_at?: Date | null;
};

/**
 * WhatsNewEntryResponse
 *
 * Response schema for a What's New entry.
 */
export type WhatsNewEntryResponse = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Title
     */
    title: string;
    /**
     * Body
     */
    body: string;
    /**
     * Image Url
     */
    image_url?: string | null;
    /**
     * Video Url
     */
    video_url?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * Updated At
     */
    updated_at: Date;
};

/**
 * WhoAmI
 */
export type WhoAmI = {
    organization: WhoAmIRef;
    stek: WhoAmIRef;
    identity: WhoAmIIdentity;
    /**
     * Roles
     */
    roles: Array<ClusterRole>;
    /**
     * Scopes
     */
    scopes: Array<string>;
    /**
     * Expires At
     */
    expires_at: Date | null;
    /**
     * Credential Kind
     */
    credential_kind: string;
    /**
     * Credential Id
     */
    credential_id: string | null;
    /**
     * Server Time
     */
    server_time: Date;
};

/**
 * WhoAmIIdentity
 */
export type WhoAmIIdentity = {
    /**
     * User Id
     */
    user_id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Email
     */
    email: string;
    /**
     * Kind
     */
    kind: string;
};

/**
 * WhoAmIRef
 */
export type WhoAmIRef = {
    /**
     * Identity
     */
    identity: string;
    /**
     * Name
     */
    name: string;
};

/**
 * WipeReceiptSchema
 *
 * What the erasure actually removed, and whether it finished.
 *
 * `complete` is false when an ephemeral (Valkey) store could not be reached
 * even on retry — the durable half is still gone and the rest expires on its
 * own TTL, but the user is told the truth rather than a reassuring lie.
 */
export type WipeReceiptSchema = {
    /**
     * Chat Entries
     */
    chat_entries: number;
    /**
     * Digests
     */
    digests: number;
    /**
     * Memories
     */
    memories: number;
    /**
     * Complete
     */
    complete: boolean;
    /**
     * Not Erased
     */
    not_erased: string;
};

/**
 * Worktree
 *
 * A worktree represents the hierarchy of a system, described in terms of
 * domains, products and processes. It can be used to render a tree view of
 * the system.
 *
 * Note, the schema does not expose the branch that is used across all
 * entities (stek and its domains), unlike the domain entity.
 */
export type Worktree = {
    /**
     * Stek Id
     */
    stek_id: string;
    /**
     * Domains
     */
    domains: Array<DomainInTree>;
    strategy_diff?: StrategyDiff;
};

/**
 * HistoryDecision
 *
 * The decision a commit embodies when it is a thread accept-squash.
 *
 * ``what`` is the change (commit subject); ``why`` is the rationale (a ``Why:``
 * trailer), ``None`` for accepts that predate the what/why protocol. ``None``
 * on a HistoryEntry means the commit is a direct edit, not a decision.
 */
export type ApiRoutersBizSchemaHistoryDecision = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * What
     */
    what: string;
    /**
     * Why
     */
    why?: string | null;
};

/**
 * HistoryEntry
 *
 * A value object which represents a point in time of the artefact.
 */
export type ApiRoutersBizSchemaHistoryEntry = {
    /**
     * Id
     */
    id: string;
    /**
     * Subject
     */
    subject: string;
    /**
     * Body
     */
    body: string;
    author: Contributor;
    committer: Contributor;
    decision?: ApiRoutersBizSchemaHistoryDecision | null;
};

/**
 * HistoryDecision
 *
 * The decision record a history entry represents (869: history-by-decision).
 *
 * Entity mutations land on main as one squash commit per accepted thread,
 * following a what/why protocol so decisions read cleanly over time:
 *
 * thread <id> accepted: <what>
 *
 * Why: <why>
 *
 * ``what`` (the commit subject) is the change; ``why`` (a ``Why:`` body
 * trailer) is the rationale, and is ``None`` for older accepts that predate
 * the protocol. Absent (the whole HistoryDecision is ``None``) for a direct
 * edit that did not go through a thread.
 */
export type DomainBizEntitiesHistoryDecision = {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * What
     */
    what: string;
    /**
     * Why
     */
    why?: string | null;
};

/**
 * HistoryEntry
 *
 * A value object which represents a point in time of the artefact.
 */
export type DomainBizEntitiesHistoryEntry = {
    /**
     * Id
     */
    id: string;
    /**
     * Subject
     */
    subject: string;
    /**
     * Body
     */
    body: string;
    author: Contributor;
    committer: Contributor;
    decision?: DomainBizEntitiesHistoryDecision | null;
};

export type GetOauthMetadataWellKnownOauthAuthorizationServerGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/.well-known/oauth-authorization-server';
};

export type GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses = {
    /**
     * Successful Response
     */
    200: OAuthMetadata;
};

export type GetOauthMetadataWellKnownOauthAuthorizationServerGetResponse = GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses[keyof GetOauthMetadataWellKnownOauthAuthorizationServerGetResponses];

export type GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/.well-known/oauth-protected-resource';
};

export type GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses = {
    /**
     * Successful Response
     */
    200: OAuthProtectedResourceMetadata;
};

export type GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponse = GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses[keyof GetOauthProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponses];

export type StartProductProductMgtMoveProductStartPostData = {
    body: BodyStartProductProductMgtMoveProductStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/move_product/start';
};

export type StartProductProductMgtMoveProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtMoveProductStartPostError = StartProductProductMgtMoveProductStartPostErrors[keyof StartProductProductMgtMoveProductStartPostErrors];

export type StartProductProductMgtMoveProductStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProductProductMgtGetProductStartPostData = {
    body: BodyStartProductProductMgtGetProductStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/get_product/start';
};

export type StartProductProductMgtGetProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtGetProductStartPostError = StartProductProductMgtGetProductStartPostErrors[keyof StartProductProductMgtGetProductStartPostErrors];

export type StartProductProductMgtGetProductStartPostResponses = {
    /**
     * Successful Response
     */
    200: Product;
};

export type StartProductProductMgtGetProductStartPostResponse = StartProductProductMgtGetProductStartPostResponses[keyof StartProductProductMgtGetProductStartPostResponses];

export type StartProductProductMgtGetProductsByDomainStartPostData = {
    body: BodyStartProductProductMgtGetProductsByDomainStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/get_products_by_domain/start';
};

export type StartProductProductMgtGetProductsByDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtGetProductsByDomainStartPostError = StartProductProductMgtGetProductsByDomainStartPostErrors[keyof StartProductProductMgtGetProductsByDomainStartPostErrors];

export type StartProductProductMgtGetProductsByDomainStartPostResponses = {
    /**
     * Response Start Product Product Mgt Get Products By Domain Start Post
     *
     * Successful Response
     */
    200: Array<Product>;
};

export type StartProductProductMgtGetProductsByDomainStartPostResponse = StartProductProductMgtGetProductsByDomainStartPostResponses[keyof StartProductProductMgtGetProductsByDomainStartPostResponses];

export type StartProductProductMgtDeleteProductStartPostData = {
    body: BodyStartProductProductMgtDeleteProductStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/delete_product/start';
};

export type StartProductProductMgtDeleteProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtDeleteProductStartPostError = StartProductProductMgtDeleteProductStartPostErrors[keyof StartProductProductMgtDeleteProductStartPostErrors];

export type StartProductProductMgtDeleteProductStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProductProductMgtUpdateProductOrdersStartPostData = {
    body: BodyStartProductProductMgtUpdateProductOrdersStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/update_product_orders/start';
};

export type StartProductProductMgtUpdateProductOrdersStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtUpdateProductOrdersStartPostError = StartProductProductMgtUpdateProductOrdersStartPostErrors[keyof StartProductProductMgtUpdateProductOrdersStartPostErrors];

export type StartProductProductMgtUpdateProductOrdersStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProductProductMgtCreateProductStartPostData = {
    body: BodyStartProductProductMgtCreateProductStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/create_product/start';
};

export type StartProductProductMgtCreateProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtCreateProductStartPostError = StartProductProductMgtCreateProductStartPostErrors[keyof StartProductProductMgtCreateProductStartPostErrors];

export type StartProductProductMgtCreateProductStartPostResponses = {
    /**
     * Successful Response
     */
    200: Product;
};

export type StartProductProductMgtCreateProductStartPostResponse = StartProductProductMgtCreateProductStartPostResponses[keyof StartProductProductMgtCreateProductStartPostResponses];

export type StartProductProductMgtUpdateProductStartPostData = {
    body: BodyStartProductProductMgtUpdateProductStartPost;
    path?: never;
    query?: never;
    url: '/product/product_mgt/update_product/start';
};

export type StartProductProductMgtUpdateProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProductProductMgtUpdateProductStartPostError = StartProductProductMgtUpdateProductStartPostErrors[keyof StartProductProductMgtUpdateProductStartPostErrors];

export type StartProductProductMgtUpdateProductStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStrategyStrategyMgtGetProposedCompetitorsStartPostData = {
    body: BodyStartStrategyStrategyMgtGetProposedCompetitorsStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/get_proposed_competitors/start';
};

export type StartStrategyStrategyMgtGetProposedCompetitorsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtGetProposedCompetitorsStartPostError = StartStrategyStrategyMgtGetProposedCompetitorsStartPostErrors[keyof StartStrategyStrategyMgtGetProposedCompetitorsStartPostErrors];

export type StartStrategyStrategyMgtGetProposedCompetitorsStartPostResponses = {
    /**
     * Response Start Strategy Strategy Mgt Get Proposed Competitors Start Post
     *
     * Successful Response
     */
    200: Array<ProposedCompetitor>;
};

export type StartStrategyStrategyMgtGetProposedCompetitorsStartPostResponse = StartStrategyStrategyMgtGetProposedCompetitorsStartPostResponses[keyof StartStrategyStrategyMgtGetProposedCompetitorsStartPostResponses];

export type StartStrategyStrategyMgtGetMarketStartPostData = {
    body: BodyStartStrategyStrategyMgtGetMarketStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/get_market/start';
};

export type StartStrategyStrategyMgtGetMarketStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtGetMarketStartPostError = StartStrategyStrategyMgtGetMarketStartPostErrors[keyof StartStrategyStrategyMgtGetMarketStartPostErrors];

export type StartStrategyStrategyMgtGetMarketStartPostResponses = {
    /**
     * Successful Response
     */
    200: Market;
};

export type StartStrategyStrategyMgtGetMarketStartPostResponse = StartStrategyStrategyMgtGetMarketStartPostResponses[keyof StartStrategyStrategyMgtGetMarketStartPostResponses];

export type StartStrategyStrategyMgtUpdateObjectiveStartPostData = {
    body: BodyStartStrategyStrategyMgtUpdateObjectiveStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/update_objective/start';
};

export type StartStrategyStrategyMgtUpdateObjectiveStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtUpdateObjectiveStartPostError = StartStrategyStrategyMgtUpdateObjectiveStartPostErrors[keyof StartStrategyStrategyMgtUpdateObjectiveStartPostErrors];

export type StartStrategyStrategyMgtUpdateObjectiveStartPostResponses = {
    /**
     * Successful Response
     */
    200: Objective;
};

export type StartStrategyStrategyMgtUpdateObjectiveStartPostResponse = StartStrategyStrategyMgtUpdateObjectiveStartPostResponses[keyof StartStrategyStrategyMgtUpdateObjectiveStartPostResponses];

export type StartStrategyStrategyMgtCreateObjectiveStartPostData = {
    body: BodyStartStrategyStrategyMgtCreateObjectiveStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/create_objective/start';
};

export type StartStrategyStrategyMgtCreateObjectiveStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtCreateObjectiveStartPostError = StartStrategyStrategyMgtCreateObjectiveStartPostErrors[keyof StartStrategyStrategyMgtCreateObjectiveStartPostErrors];

export type StartStrategyStrategyMgtCreateObjectiveStartPostResponses = {
    /**
     * Successful Response
     */
    200: Objective;
};

export type StartStrategyStrategyMgtCreateObjectiveStartPostResponse = StartStrategyStrategyMgtCreateObjectiveStartPostResponses[keyof StartStrategyStrategyMgtCreateObjectiveStartPostResponses];

export type StartStrategyStrategyMgtGetCompetitorHistoryStartPostData = {
    body: BodyStartStrategyStrategyMgtGetCompetitorHistoryStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/get_competitor_history/start';
};

export type StartStrategyStrategyMgtGetCompetitorHistoryStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtGetCompetitorHistoryStartPostError = StartStrategyStrategyMgtGetCompetitorHistoryStartPostErrors[keyof StartStrategyStrategyMgtGetCompetitorHistoryStartPostErrors];

export type StartStrategyStrategyMgtGetCompetitorHistoryStartPostResponses = {
    /**
     * Response Start Strategy Strategy Mgt Get Competitor History Start Post
     *
     * Successful Response
     */
    200: Array<CompetitorChange>;
};

export type StartStrategyStrategyMgtGetCompetitorHistoryStartPostResponse = StartStrategyStrategyMgtGetCompetitorHistoryStartPostResponses[keyof StartStrategyStrategyMgtGetCompetitorHistoryStartPostResponses];

export type StartStrategyStrategyMgtGetObjectivesStartPostData = {
    body: BodyStartStrategyStrategyMgtGetObjectivesStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/get_objectives/start';
};

export type StartStrategyStrategyMgtGetObjectivesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtGetObjectivesStartPostError = StartStrategyStrategyMgtGetObjectivesStartPostErrors[keyof StartStrategyStrategyMgtGetObjectivesStartPostErrors];

export type StartStrategyStrategyMgtGetObjectivesStartPostResponses = {
    /**
     * Response Start Strategy Strategy Mgt Get Objectives Start Post
     *
     * Successful Response
     */
    200: Array<Objective>;
};

export type StartStrategyStrategyMgtGetObjectivesStartPostResponse = StartStrategyStrategyMgtGetObjectivesStartPostResponses[keyof StartStrategyStrategyMgtGetObjectivesStartPostResponses];

export type StartStrategyStrategyMgtUpdateTrendStartPostData = {
    body: BodyStartStrategyStrategyMgtUpdateTrendStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/update_trend/start';
};

export type StartStrategyStrategyMgtUpdateTrendStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtUpdateTrendStartPostError = StartStrategyStrategyMgtUpdateTrendStartPostErrors[keyof StartStrategyStrategyMgtUpdateTrendStartPostErrors];

export type StartStrategyStrategyMgtUpdateTrendStartPostResponses = {
    /**
     * Successful Response
     */
    200: Trend;
};

export type StartStrategyStrategyMgtUpdateTrendStartPostResponse = StartStrategyStrategyMgtUpdateTrendStartPostResponses[keyof StartStrategyStrategyMgtUpdateTrendStartPostResponses];

export type StartStrategyStrategyMgtUpdateCompetitorStartPostData = {
    body: BodyStartStrategyStrategyMgtUpdateCompetitorStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/update_competitor/start';
};

export type StartStrategyStrategyMgtUpdateCompetitorStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtUpdateCompetitorStartPostError = StartStrategyStrategyMgtUpdateCompetitorStartPostErrors[keyof StartStrategyStrategyMgtUpdateCompetitorStartPostErrors];

export type StartStrategyStrategyMgtUpdateCompetitorStartPostResponses = {
    /**
     * Successful Response
     */
    200: Competitor;
};

export type StartStrategyStrategyMgtUpdateCompetitorStartPostResponse = StartStrategyStrategyMgtUpdateCompetitorStartPostResponses[keyof StartStrategyStrategyMgtUpdateCompetitorStartPostResponses];

export type StartStrategyStrategyMgtGetWatchersStartPostData = {
    body: BodyStartStrategyStrategyMgtGetWatchersStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/get_watchers/start';
};

export type StartStrategyStrategyMgtGetWatchersStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtGetWatchersStartPostError = StartStrategyStrategyMgtGetWatchersStartPostErrors[keyof StartStrategyStrategyMgtGetWatchersStartPostErrors];

export type StartStrategyStrategyMgtGetWatchersStartPostResponses = {
    /**
     * Response Start Strategy Strategy Mgt Get Watchers Start Post
     *
     * Successful Response
     */
    200: Array<Watcher>;
};

export type StartStrategyStrategyMgtGetWatchersStartPostResponse = StartStrategyStrategyMgtGetWatchersStartPostResponses[keyof StartStrategyStrategyMgtGetWatchersStartPostResponses];

export type StartStrategyStrategyMgtCreateCompetitorStartPostData = {
    body: BodyStartStrategyStrategyMgtCreateCompetitorStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/create_competitor/start';
};

export type StartStrategyStrategyMgtCreateCompetitorStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtCreateCompetitorStartPostError = StartStrategyStrategyMgtCreateCompetitorStartPostErrors[keyof StartStrategyStrategyMgtCreateCompetitorStartPostErrors];

export type StartStrategyStrategyMgtCreateCompetitorStartPostResponses = {
    /**
     * Successful Response
     */
    200: Competitor;
};

export type StartStrategyStrategyMgtCreateCompetitorStartPostResponse = StartStrategyStrategyMgtCreateCompetitorStartPostResponses[keyof StartStrategyStrategyMgtCreateCompetitorStartPostResponses];

export type StartStrategyStrategyMgtCreateTrendStartPostData = {
    body: BodyStartStrategyStrategyMgtCreateTrendStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/create_trend/start';
};

export type StartStrategyStrategyMgtCreateTrendStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtCreateTrendStartPostError = StartStrategyStrategyMgtCreateTrendStartPostErrors[keyof StartStrategyStrategyMgtCreateTrendStartPostErrors];

export type StartStrategyStrategyMgtCreateTrendStartPostResponses = {
    /**
     * Successful Response
     */
    200: Trend;
};

export type StartStrategyStrategyMgtCreateTrendStartPostResponse = StartStrategyStrategyMgtCreateTrendStartPostResponses[keyof StartStrategyStrategyMgtCreateTrendStartPostResponses];

export type StartStrategyStrategyMgtGetHorizonsStartPostData = {
    body: BodyStartStrategyStrategyMgtGetHorizonsStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/get_horizons/start';
};

export type StartStrategyStrategyMgtGetHorizonsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtGetHorizonsStartPostError = StartStrategyStrategyMgtGetHorizonsStartPostErrors[keyof StartStrategyStrategyMgtGetHorizonsStartPostErrors];

export type StartStrategyStrategyMgtGetHorizonsStartPostResponses = {
    /**
     * Response Start Strategy Strategy Mgt Get Horizons Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type StartStrategyStrategyMgtGetHorizonsStartPostResponse = StartStrategyStrategyMgtGetHorizonsStartPostResponses[keyof StartStrategyStrategyMgtGetHorizonsStartPostResponses];

export type StartStrategyStrategyMgtDeleteWatcherStartPostData = {
    body: BodyStartStrategyStrategyMgtDeleteWatcherStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/delete_watcher/start';
};

export type StartStrategyStrategyMgtDeleteWatcherStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtDeleteWatcherStartPostError = StartStrategyStrategyMgtDeleteWatcherStartPostErrors[keyof StartStrategyStrategyMgtDeleteWatcherStartPostErrors];

export type StartStrategyStrategyMgtDeleteWatcherStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStrategyStrategyMgtAcceptProposedCompetitorStartPostData = {
    body: BodyStartStrategyStrategyMgtAcceptProposedCompetitorStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/accept_proposed_competitor/start';
};

export type StartStrategyStrategyMgtAcceptProposedCompetitorStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtAcceptProposedCompetitorStartPostError = StartStrategyStrategyMgtAcceptProposedCompetitorStartPostErrors[keyof StartStrategyStrategyMgtAcceptProposedCompetitorStartPostErrors];

export type StartStrategyStrategyMgtAcceptProposedCompetitorStartPostResponses = {
    /**
     * Response Start Strategy Strategy Mgt Accept Proposed Competitor Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type StartStrategyStrategyMgtAcceptProposedCompetitorStartPostResponse = StartStrategyStrategyMgtAcceptProposedCompetitorStartPostResponses[keyof StartStrategyStrategyMgtAcceptProposedCompetitorStartPostResponses];

export type StartStrategyStrategyMgtUpdateWatcherStartPostData = {
    body: BodyStartStrategyStrategyMgtUpdateWatcherStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/update_watcher/start';
};

export type StartStrategyStrategyMgtUpdateWatcherStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtUpdateWatcherStartPostError = StartStrategyStrategyMgtUpdateWatcherStartPostErrors[keyof StartStrategyStrategyMgtUpdateWatcherStartPostErrors];

export type StartStrategyStrategyMgtUpdateWatcherStartPostResponses = {
    /**
     * Successful Response
     */
    200: Watcher;
};

export type StartStrategyStrategyMgtUpdateWatcherStartPostResponse = StartStrategyStrategyMgtUpdateWatcherStartPostResponses[keyof StartStrategyStrategyMgtUpdateWatcherStartPostResponses];

export type StartStrategyStrategyMgtUpdateHorizonsStartPostData = {
    body: BodyStartStrategyStrategyMgtUpdateHorizonsStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/update_horizons/start';
};

export type StartStrategyStrategyMgtUpdateHorizonsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtUpdateHorizonsStartPostError = StartStrategyStrategyMgtUpdateHorizonsStartPostErrors[keyof StartStrategyStrategyMgtUpdateHorizonsStartPostErrors];

export type StartStrategyStrategyMgtUpdateHorizonsStartPostResponses = {
    /**
     * Response Start Strategy Strategy Mgt Update Horizons Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type StartStrategyStrategyMgtUpdateHorizonsStartPostResponse = StartStrategyStrategyMgtUpdateHorizonsStartPostResponses[keyof StartStrategyStrategyMgtUpdateHorizonsStartPostResponses];

export type StartStrategyStrategyMgtDeleteCompetitorStartPostData = {
    body: BodyStartStrategyStrategyMgtDeleteCompetitorStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/delete_competitor/start';
};

export type StartStrategyStrategyMgtDeleteCompetitorStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtDeleteCompetitorStartPostError = StartStrategyStrategyMgtDeleteCompetitorStartPostErrors[keyof StartStrategyStrategyMgtDeleteCompetitorStartPostErrors];

export type StartStrategyStrategyMgtDeleteCompetitorStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStrategyStrategyMgtCreateWatcherStartPostData = {
    body: BodyStartStrategyStrategyMgtCreateWatcherStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/create_watcher/start';
};

export type StartStrategyStrategyMgtCreateWatcherStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtCreateWatcherStartPostError = StartStrategyStrategyMgtCreateWatcherStartPostErrors[keyof StartStrategyStrategyMgtCreateWatcherStartPostErrors];

export type StartStrategyStrategyMgtCreateWatcherStartPostResponses = {
    /**
     * Successful Response
     */
    200: Watcher;
};

export type StartStrategyStrategyMgtCreateWatcherStartPostResponse = StartStrategyStrategyMgtCreateWatcherStartPostResponses[keyof StartStrategyStrategyMgtCreateWatcherStartPostResponses];

export type StartStrategyStrategyMgtDeleteObjectiveStartPostData = {
    body: BodyStartStrategyStrategyMgtDeleteObjectiveStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/delete_objective/start';
};

export type StartStrategyStrategyMgtDeleteObjectiveStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtDeleteObjectiveStartPostError = StartStrategyStrategyMgtDeleteObjectiveStartPostErrors[keyof StartStrategyStrategyMgtDeleteObjectiveStartPostErrors];

export type StartStrategyStrategyMgtDeleteObjectiveStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStrategyStrategyMgtDeleteTrendStartPostData = {
    body: BodyStartStrategyStrategyMgtDeleteTrendStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/delete_trend/start';
};

export type StartStrategyStrategyMgtDeleteTrendStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtDeleteTrendStartPostError = StartStrategyStrategyMgtDeleteTrendStartPostErrors[keyof StartStrategyStrategyMgtDeleteTrendStartPostErrors];

export type StartStrategyStrategyMgtDeleteTrendStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStrategyStrategyMgtDeclineProposedCompetitorStartPostData = {
    body: BodyStartStrategyStrategyMgtDeclineProposedCompetitorStartPost;
    path?: never;
    query?: never;
    url: '/strategy/strategy_mgt/decline_proposed_competitor/start';
};

export type StartStrategyStrategyMgtDeclineProposedCompetitorStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStrategyStrategyMgtDeclineProposedCompetitorStartPostError = StartStrategyStrategyMgtDeclineProposedCompetitorStartPostErrors[keyof StartStrategyStrategyMgtDeclineProposedCompetitorStartPostErrors];

export type StartStrategyStrategyMgtDeclineProposedCompetitorStartPostResponses = {
    /**
     * Response Start Strategy Strategy Mgt Decline Proposed Competitor Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type StartStrategyStrategyMgtDeclineProposedCompetitorStartPostResponse = StartStrategyStrategyMgtDeclineProposedCompetitorStartPostResponses[keyof StartStrategyStrategyMgtDeclineProposedCompetitorStartPostResponses];

export type AskEventsAskEventsGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/ask/events';
};

export type AskEventsAskEventsGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartAskAskMgtAnswerQuestionStartPostData = {
    body: BodyStartAskAskMgtAnswerQuestionStartPost;
    path?: never;
    query?: never;
    url: '/ask/ask_mgt/answer_question/start';
};

export type StartAskAskMgtAnswerQuestionStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartAskAskMgtAnswerQuestionStartPostError = StartAskAskMgtAnswerQuestionStartPostErrors[keyof StartAskAskMgtAnswerQuestionStartPostErrors];

export type StartAskAskMgtAnswerQuestionStartPostResponses = {
    /**
     * Successful Response
     */
    200: AskRun;
};

export type StartAskAskMgtAnswerQuestionStartPostResponse = StartAskAskMgtAnswerQuestionStartPostResponses[keyof StartAskAskMgtAnswerQuestionStartPostResponses];

export type CurrentAskAskMgtAnswerQuestionCurrentGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/ask/ask_mgt/answer_question/current';
};

export type CurrentAskAskMgtAnswerQuestionCurrentGetResponses = {
    /**
     * Response Current Ask Ask Mgt Answer Question Current Get
     *
     * Successful Response
     */
    200: AskRun | null;
};

export type CurrentAskAskMgtAnswerQuestionCurrentGetResponse = CurrentAskAskMgtAnswerQuestionCurrentGetResponses[keyof CurrentAskAskMgtAnswerQuestionCurrentGetResponses];

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostData = {
    body: BodyStartBizArtefactManagementRestoreHistoricalArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/restore_historical_artefact/start';
};

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostError = StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors[keyof StartBizArtefactManagementRestoreHistoricalArtefactStartPostErrors];

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementRemoveArtefactStartPostData = {
    body: BodyStartBizArtefactManagementRemoveArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/remove_artefact/start';
};

export type StartBizArtefactManagementRemoveArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementRemoveArtefactStartPostError = StartBizArtefactManagementRemoveArtefactStartPostErrors[keyof StartBizArtefactManagementRemoveArtefactStartPostErrors];

export type StartBizArtefactManagementRemoveArtefactStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementUpdateArtefactStartPostData = {
    body: BodyStartBizArtefactManagementUpdateArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/update_artefact/start';
};

export type StartBizArtefactManagementUpdateArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementUpdateArtefactStartPostError = StartBizArtefactManagementUpdateArtefactStartPostErrors[keyof StartBizArtefactManagementUpdateArtefactStartPostErrors];

export type StartBizArtefactManagementUpdateArtefactStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementGetArtefactsTreeStartPostData = {
    body: BodyStartBizArtefactManagementGetArtefactsTreeStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/get_artefacts_tree/start';
};

export type StartBizArtefactManagementGetArtefactsTreeStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementGetArtefactsTreeStartPostError = StartBizArtefactManagementGetArtefactsTreeStartPostErrors[keyof StartBizArtefactManagementGetArtefactsTreeStartPostErrors];

export type StartBizArtefactManagementGetArtefactsTreeStartPostResponses = {
    /**
     * Response Start Biz Artefact Management Get Artefacts Tree Start Post
     *
     * Successful Response
     */
    200: Array<Artefact | ArtefactGroupWithArtefacts>;
};

export type StartBizArtefactManagementGetArtefactsTreeStartPostResponse = StartBizArtefactManagementGetArtefactsTreeStartPostResponses[keyof StartBizArtefactManagementGetArtefactsTreeStartPostResponses];

export type StartBizArtefactManagementUpdateArtefactContentStartPostData = {
    body: BodyStartBizArtefactManagementUpdateArtefactContentStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/update_artefact_content/start';
};

export type StartBizArtefactManagementUpdateArtefactContentStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementUpdateArtefactContentStartPostError = StartBizArtefactManagementUpdateArtefactContentStartPostErrors[keyof StartBizArtefactManagementUpdateArtefactContentStartPostErrors];

export type StartBizArtefactManagementUpdateArtefactContentStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementAddArtefactGroupStartPostData = {
    body: BodyStartBizArtefactManagementAddArtefactGroupStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/add_artefact_group/start';
};

export type StartBizArtefactManagementAddArtefactGroupStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementAddArtefactGroupStartPostError = StartBizArtefactManagementAddArtefactGroupStartPostErrors[keyof StartBizArtefactManagementAddArtefactGroupStartPostErrors];

export type StartBizArtefactManagementAddArtefactGroupStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementGetArtefactStartPostData = {
    body: BodyStartBizArtefactManagementGetArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/get_artefact/start';
};

export type StartBizArtefactManagementGetArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementGetArtefactStartPostError = StartBizArtefactManagementGetArtefactStartPostErrors[keyof StartBizArtefactManagementGetArtefactStartPostErrors];

export type StartBizArtefactManagementGetArtefactStartPostResponses = {
    /**
     * File stream, can have any content-type.
     */
    200: unknown;
};

export type StartBizArtefactManagementRenameArtefactGroupStartPostData = {
    body: BodyStartBizArtefactManagementRenameArtefactGroupStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/rename_artefact_group/start';
};

export type StartBizArtefactManagementRenameArtefactGroupStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementRenameArtefactGroupStartPostError = StartBizArtefactManagementRenameArtefactGroupStartPostErrors[keyof StartBizArtefactManagementRenameArtefactGroupStartPostErrors];

export type StartBizArtefactManagementRenameArtefactGroupStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementGetHistoryStartPostData = {
    body: BodyStartBizArtefactManagementGetHistoryStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/get_history/start';
};

export type StartBizArtefactManagementGetHistoryStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementGetHistoryStartPostError = StartBizArtefactManagementGetHistoryStartPostErrors[keyof StartBizArtefactManagementGetHistoryStartPostErrors];

export type StartBizArtefactManagementGetHistoryStartPostResponses = {
    /**
     * Response Start Biz Artefact Management Get History Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<DomainBizEntitiesHistoryEntry>;
    };
};

export type StartBizArtefactManagementGetHistoryStartPostResponse = StartBizArtefactManagementGetHistoryStartPostResponses[keyof StartBizArtefactManagementGetHistoryStartPostResponses];

export type StartBizArtefactManagementAddArtefactStartPostData = {
    body: BodyStartBizArtefactManagementAddArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/add_artefact/start';
};

export type StartBizArtefactManagementAddArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementAddArtefactStartPostError = StartBizArtefactManagementAddArtefactStartPostErrors[keyof StartBizArtefactManagementAddArtefactStartPostErrors];

export type StartBizArtefactManagementAddArtefactStartPostResponses = {
    /**
     * Successful Response
     */
    200: Artefact;
};

export type StartBizArtefactManagementAddArtefactStartPostResponse = StartBizArtefactManagementAddArtefactStartPostResponses[keyof StartBizArtefactManagementAddArtefactStartPostResponses];

export type StartBizArtefactManagementRenameArtefactStartPostData = {
    body: BodyStartBizArtefactManagementRenameArtefactStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/rename_artefact/start';
};

export type StartBizArtefactManagementRenameArtefactStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementRenameArtefactStartPostError = StartBizArtefactManagementRenameArtefactStartPostErrors[keyof StartBizArtefactManagementRenameArtefactStartPostErrors];

export type StartBizArtefactManagementRenameArtefactStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizArtefactManagementRemoveArtefactGroupStartPostData = {
    body: BodyStartBizArtefactManagementRemoveArtefactGroupStartPost;
    path?: never;
    query?: never;
    url: '/biz/artefact_management/remove_artefact_group/start';
};

export type StartBizArtefactManagementRemoveArtefactGroupStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizArtefactManagementRemoveArtefactGroupStartPostError = StartBizArtefactManagementRemoveArtefactGroupStartPostErrors[keyof StartBizArtefactManagementRemoveArtefactGroupStartPostErrors];

export type StartBizArtefactManagementRemoveArtefactGroupStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizEntitiesEntityTypeEntityIdInfoGetData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
    };
    query?: never;
    url: '/biz/entities/{entity_type}/{entity_id}/info';
};

export type StartBizEntitiesEntityTypeEntityIdInfoGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdInfoGetError = StartBizEntitiesEntityTypeEntityIdInfoGetErrors[keyof StartBizEntitiesEntityTypeEntityIdInfoGetErrors];

export type StartBizEntitiesEntityTypeEntityIdInfoGetResponses = {
    /**
     * Successful Response
     */
    200: EntityInfo;
};

export type StartBizEntitiesEntityTypeEntityIdInfoGetResponse = StartBizEntitiesEntityTypeEntityIdInfoGetResponses[keyof StartBizEntitiesEntityTypeEntityIdInfoGetResponses];

export type StartBizEntitiesEntityTypeEntityIdHistoryGetData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
    };
    query?: {
        /**
         * Limit
         */
        limit?: number;
        /**
         * Offset
         */
        offset?: number;
    };
    url: '/biz/entities/{entity_type}/{entity_id}/history';
};

export type StartBizEntitiesEntityTypeEntityIdHistoryGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdHistoryGetError = StartBizEntitiesEntityTypeEntityIdHistoryGetErrors[keyof StartBizEntitiesEntityTypeEntityIdHistoryGetErrors];

export type StartBizEntitiesEntityTypeEntityIdHistoryGetResponses = {
    /**
     * Response Start Biz Entities  Entity Type   Entity Id  History Get
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<ApiRoutersBizSchemaHistoryEntry>;
    };
};

export type StartBizEntitiesEntityTypeEntityIdHistoryGetResponse = StartBizEntitiesEntityTypeEntityIdHistoryGetResponses[keyof StartBizEntitiesEntityTypeEntityIdHistoryGetResponses];

export type StartBizEntitiesEntityTypeEntityIdSnapshotGetData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
    };
    query: {
        /**
         * Revision
         *
         * Git revision (commit SHA) to snapshot at.
         */
        revision: string;
    };
    url: '/biz/entities/{entity_type}/{entity_id}/snapshot';
};

export type StartBizEntitiesEntityTypeEntityIdSnapshotGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdSnapshotGetError = StartBizEntitiesEntityTypeEntityIdSnapshotGetErrors[keyof StartBizEntitiesEntityTypeEntityIdSnapshotGetErrors];

export type StartBizEntitiesEntityTypeEntityIdSnapshotGetResponses = {
    /**
     * Successful Response
     */
    200: EntitySnapshotResponse;
};

export type StartBizEntitiesEntityTypeEntityIdSnapshotGetResponse = StartBizEntitiesEntityTypeEntityIdSnapshotGetResponses[keyof StartBizEntitiesEntityTypeEntityIdSnapshotGetResponses];

export type StartBizEntitiesEntityTypeEntityIdAttributeGetData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
        /**
         * Attribute
         */
        attribute: string;
    };
    query?: {
        /**
         * Revision
         */
        revision?: string | null;
    };
    url: '/biz/entities/{entity_type}/{entity_id}/{attribute}';
};

export type StartBizEntitiesEntityTypeEntityIdAttributeGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdAttributeGetError = StartBizEntitiesEntityTypeEntityIdAttributeGetErrors[keyof StartBizEntitiesEntityTypeEntityIdAttributeGetErrors];

export type StartBizEntitiesEntityTypeEntityIdAttributeGetResponses = {
    /**
     * File stream, can have any content-type.
     */
    200: unknown;
};

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
        /**
         * Attribute
         */
        attribute: string;
    };
    query?: {
        /**
         * Limit
         */
        limit?: number;
        /**
         * Offset
         */
        offset?: number;
    };
    url: '/biz/entities/{entity_type}/{entity_id}/{attribute}/history';
};

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetError = StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors[keyof StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetErrors];

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses = {
    /**
     * Response Start Biz Entities  Entity Type   Entity Id   Attribute  History Get
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<ApiRoutersBizSchemaHistoryEntry>;
    };
};

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponse = StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses[keyof StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponses];

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData = {
    body: BodyStartBizEntitiesEntityTypeEntityIdAttributeRestorePost;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
        /**
         * Attribute
         */
        attribute: string;
    };
    query?: never;
    url: '/biz/entities/{entity_type}/{entity_id}/{attribute}/restore';
};

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostError = StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors[keyof StartBizEntitiesEntityTypeEntityIdAttributeRestorePostErrors];

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData = {
    body?: never;
    path: {
        entity_type: EntityType;
        /**
         * Entity Id
         */
        entity_id: string;
    };
    query?: never;
    url: '/biz/entities/{entity_type}/{entity_id}/generate_description';
};

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostError = StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostErrors[keyof StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostErrors];

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses = {
    /**
     *
     * Limited stream of SSE messages. Sends `event: open` and `event: close` when opening/closing the stream.
     * Sends a JSON object with chunks of the content.
     *
     */
    200: string;
};

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponse = StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses[keyof StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponses];

export type StartComplianceComplianceMgtRefreshComplianceStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/compliance/compliance_mgt/refresh_compliance/start';
};

export type StartComplianceComplianceMgtRefreshComplianceStartPostResponses = {
    /**
     * Successful Response
     */
    200: RefreshStatus;
};

export type StartComplianceComplianceMgtRefreshComplianceStartPostResponse = StartComplianceComplianceMgtRefreshComplianceStartPostResponses[keyof StartComplianceComplianceMgtRefreshComplianceStartPostResponses];

export type StartComplianceComplianceMgtGetTopicDetailStartPostData = {
    body: TopicDetailRequest;
    path?: never;
    query?: never;
    url: '/compliance/compliance_mgt/get_topic_detail/start';
};

export type StartComplianceComplianceMgtGetTopicDetailStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartComplianceComplianceMgtGetTopicDetailStartPostError = StartComplianceComplianceMgtGetTopicDetailStartPostErrors[keyof StartComplianceComplianceMgtGetTopicDetailStartPostErrors];

export type StartComplianceComplianceMgtGetTopicDetailStartPostResponses = {
    /**
     * Successful Response
     */
    200: TopicDetail;
};

export type StartComplianceComplianceMgtGetTopicDetailStartPostResponse = StartComplianceComplianceMgtGetTopicDetailStartPostResponses[keyof StartComplianceComplianceMgtGetTopicDetailStartPostResponses];

export type StartComplianceComplianceMgtGetComplianceStartPostData = {
    body?: ScopeRequest;
    path?: never;
    query?: never;
    url: '/compliance/compliance_mgt/get_compliance/start';
};

export type StartComplianceComplianceMgtGetComplianceStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartComplianceComplianceMgtGetComplianceStartPostError = StartComplianceComplianceMgtGetComplianceStartPostErrors[keyof StartComplianceComplianceMgtGetComplianceStartPostErrors];

export type StartComplianceComplianceMgtGetComplianceStartPostResponses = {
    /**
     * Successful Response
     */
    200: ComplianceOverview;
};

export type StartComplianceComplianceMgtGetComplianceStartPostResponse = StartComplianceComplianceMgtGetComplianceStartPostResponses[keyof StartComplianceComplianceMgtGetComplianceStartPostResponses];

export type StartComplianceRequirementMgtSetRequirementStartPostData = {
    body: SetRequirementRequest;
    path?: never;
    query?: never;
    url: '/compliance/requirement_mgt/set_requirement/start';
};

export type StartComplianceRequirementMgtSetRequirementStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartComplianceRequirementMgtSetRequirementStartPostError = StartComplianceRequirementMgtSetRequirementStartPostErrors[keyof StartComplianceRequirementMgtSetRequirementStartPostErrors];

export type StartComplianceRequirementMgtSetRequirementStartPostResponses = {
    /**
     * Successful Response
     */
    200: Requirement;
};

export type StartComplianceRequirementMgtSetRequirementStartPostResponse = StartComplianceRequirementMgtSetRequirementStartPostResponses[keyof StartComplianceRequirementMgtSetRequirementStartPostResponses];

export type StartComplianceRequirementMgtSetRequirementExceptionStartPostData = {
    body: SetRequirementExceptionRequest;
    path?: never;
    query?: never;
    url: '/compliance/requirement_mgt/set_requirement_exception/start';
};

export type StartComplianceRequirementMgtSetRequirementExceptionStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartComplianceRequirementMgtSetRequirementExceptionStartPostError = StartComplianceRequirementMgtSetRequirementExceptionStartPostErrors[keyof StartComplianceRequirementMgtSetRequirementExceptionStartPostErrors];

export type StartComplianceRequirementMgtSetRequirementExceptionStartPostResponses = {
    /**
     * Successful Response
     */
    200: Requirement;
};

export type StartComplianceRequirementMgtSetRequirementExceptionStartPostResponse = StartComplianceRequirementMgtSetRequirementExceptionStartPostResponses[keyof StartComplianceRequirementMgtSetRequirementExceptionStartPostResponses];

export type StartComplianceRequirementMgtExtractRequirementsStartPostData = {
    body: ExtractRequirementsRequest;
    path?: never;
    query?: never;
    url: '/compliance/requirement_mgt/extract_requirements/start';
};

export type StartComplianceRequirementMgtExtractRequirementsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartComplianceRequirementMgtExtractRequirementsStartPostError = StartComplianceRequirementMgtExtractRequirementsStartPostErrors[keyof StartComplianceRequirementMgtExtractRequirementsStartPostErrors];

export type StartComplianceRequirementMgtExtractRequirementsStartPostResponses = {
    /**
     * Response Start Compliance Requirement Mgt Extract Requirements Start Post
     *
     * Successful Response
     */
    200: Array<Requirement>;
};

export type StartComplianceRequirementMgtExtractRequirementsStartPostResponse = StartComplianceRequirementMgtExtractRequirementsStartPostResponses[keyof StartComplianceRequirementMgtExtractRequirementsStartPostResponses];

export type StartComplianceRequirementMgtDeleteRequirementStartPostData = {
    body: DeleteRequirementRequest;
    path?: never;
    query?: never;
    url: '/compliance/requirement_mgt/delete_requirement/start';
};

export type StartComplianceRequirementMgtDeleteRequirementStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartComplianceRequirementMgtDeleteRequirementStartPostError = StartComplianceRequirementMgtDeleteRequirementStartPostErrors[keyof StartComplianceRequirementMgtDeleteRequirementStartPostErrors];

export type StartComplianceRequirementMgtDeleteRequirementStartPostResponses = {
    /**
     * Successful Response
     */
    200: Requirement;
};

export type StartComplianceRequirementMgtDeleteRequirementStartPostResponse = StartComplianceRequirementMgtDeleteRequirementStartPostResponses[keyof StartComplianceRequirementMgtDeleteRequirementStartPostResponses];

export type StartComplianceTopicMgtSetCustomTopicStartPostData = {
    body: SetCustomTopicRequest;
    path?: never;
    query?: never;
    url: '/compliance/topic_mgt/set_custom_topic/start';
};

export type StartComplianceTopicMgtSetCustomTopicStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartComplianceTopicMgtSetCustomTopicStartPostError = StartComplianceTopicMgtSetCustomTopicStartPostErrors[keyof StartComplianceTopicMgtSetCustomTopicStartPostErrors];

export type StartComplianceTopicMgtSetCustomTopicStartPostResponses = {
    /**
     * Successful Response
     */
    200: TopicDefinition;
};

export type StartComplianceTopicMgtSetCustomTopicStartPostResponse = StartComplianceTopicMgtSetCustomTopicStartPostResponses[keyof StartComplianceTopicMgtSetCustomTopicStartPostResponses];

export type StartComplianceTopicMgtReviewCustomTopicStartPostData = {
    body: ReviewCustomTopicRequest;
    path?: never;
    query?: never;
    url: '/compliance/topic_mgt/review_custom_topic/start';
};

export type StartComplianceTopicMgtReviewCustomTopicStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartComplianceTopicMgtReviewCustomTopicStartPostError = StartComplianceTopicMgtReviewCustomTopicStartPostErrors[keyof StartComplianceTopicMgtReviewCustomTopicStartPostErrors];

export type StartComplianceTopicMgtReviewCustomTopicStartPostResponses = {
    /**
     * Successful Response
     */
    200: TopicDefinition;
};

export type StartComplianceTopicMgtReviewCustomTopicStartPostResponse = StartComplianceTopicMgtReviewCustomTopicStartPostResponses[keyof StartComplianceTopicMgtReviewCustomTopicStartPostResponses];

export type StartComplianceGapMgtGetPersonalGapsStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/compliance/gap_mgt/get_personal_gaps/start';
};

export type StartComplianceGapMgtGetPersonalGapsStartPostResponses = {
    /**
     * Response Start Compliance Gap Mgt Get Personal Gaps Start Post
     *
     * Successful Response
     */
    200: Array<InformationGap>;
};

export type StartComplianceGapMgtGetPersonalGapsStartPostResponse = StartComplianceGapMgtGetPersonalGapsStartPostResponses[keyof StartComplianceGapMgtGetPersonalGapsStartPostResponses];

export type StartComplianceGapMgtAnswerGapStartPostData = {
    body: AnswerGapRequest;
    path?: never;
    query?: never;
    url: '/compliance/gap_mgt/answer_gap/start';
};

export type StartComplianceGapMgtAnswerGapStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartComplianceGapMgtAnswerGapStartPostError = StartComplianceGapMgtAnswerGapStartPostErrors[keyof StartComplianceGapMgtAnswerGapStartPostErrors];

export type StartComplianceGapMgtAnswerGapStartPostResponses = {
    /**
     * Response Start Compliance Gap Mgt Answer Gap Start Post
     *
     * Successful Response
     */
    200: Array<EvidenceClaim>;
};

export type StartComplianceGapMgtAnswerGapStartPostResponse = StartComplianceGapMgtAnswerGapStartPostResponses[keyof StartComplianceGapMgtAnswerGapStartPostResponses];

export type StartComplianceGapMgtRecordGapFollowUpStartPostData = {
    body: GapFollowUpRequest;
    path?: never;
    query?: never;
    url: '/compliance/gap_mgt/record_gap_follow_up/start';
};

export type StartComplianceGapMgtRecordGapFollowUpStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartComplianceGapMgtRecordGapFollowUpStartPostError = StartComplianceGapMgtRecordGapFollowUpStartPostErrors[keyof StartComplianceGapMgtRecordGapFollowUpStartPostErrors];

export type StartComplianceGapMgtRecordGapFollowUpStartPostResponses = {
    /**
     * Successful Response
     */
    200: PersonalFollowUpState;
};

export type StartComplianceGapMgtRecordGapFollowUpStartPostResponse = StartComplianceGapMgtRecordGapFollowUpStartPostResponses[keyof StartComplianceGapMgtRecordGapFollowUpStartPostResponses];

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostData = {
    body: BodyStartWorkspaceWorktreeMgtGetWorktreeStartPost;
    path?: never;
    query?: never;
    url: '/workspace/worktree_mgt/get_worktree/start';
};

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostError = StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors[keyof StartWorkspaceWorktreeMgtGetWorktreeStartPostErrors];

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses = {
    /**
     * Successful Response
     */
    200: Worktree;
};

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostResponse = StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses[keyof StartWorkspaceWorktreeMgtGetWorktreeStartPostResponses];

export type ListFeatureFlagsAdminFeatureFlagsGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/admin/feature-flags';
};

export type ListFeatureFlagsAdminFeatureFlagsGetResponses = {
    /**
     * Response List Feature Flags Admin Feature Flags Get
     *
     * Successful Response
     */
    200: Array<AdminFeatureFlagResponse>;
};

export type ListFeatureFlagsAdminFeatureFlagsGetResponse = ListFeatureFlagsAdminFeatureFlagsGetResponses[keyof ListFeatureFlagsAdminFeatureFlagsGetResponses];

export type UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutData = {
    body: AdminFeatureFlagUpdate;
    path: {
        /**
         * Feature Key
         */
        feature_key: string;
    };
    query?: never;
    url: '/admin/feature-flags/{feature_key}';
};

export type UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutError = UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutErrors[keyof UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutErrors];

export type UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutResponses = {
    /**
     * Successful Response
     */
    200: AdminFeatureFlagResponse;
};

export type UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutResponse = UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutResponses[keyof UpdateFeatureFlagAdminFeatureFlagsFeatureKeyPutResponses];

export type CancelSubscriptionSubscriptionFeatureKeyCancelPostData = {
    body?: never;
    path: {
        /**
         * Feature Key
         */
        feature_key: string;
    };
    query?: never;
    url: '/subscription/{feature_key}/cancel';
};

export type CancelSubscriptionSubscriptionFeatureKeyCancelPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CancelSubscriptionSubscriptionFeatureKeyCancelPostError = CancelSubscriptionSubscriptionFeatureKeyCancelPostErrors[keyof CancelSubscriptionSubscriptionFeatureKeyCancelPostErrors];

export type CancelSubscriptionSubscriptionFeatureKeyCancelPostResponses = {
    /**
     * Successful Response
     */
    200: CancelSubscriptionResponse;
};

export type CancelSubscriptionSubscriptionFeatureKeyCancelPostResponse = CancelSubscriptionSubscriptionFeatureKeyCancelPostResponses[keyof CancelSubscriptionSubscriptionFeatureKeyCancelPostResponses];

export type GetEntitlementsSubscriptionEntitlementsGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/subscription/entitlements';
};

export type GetEntitlementsSubscriptionEntitlementsGetResponses = {
    /**
     * Response Get Entitlements Subscription Entitlements Get
     *
     * Successful Response
     */
    200: {
        [key: string]: EntitlementResponse;
    };
};

export type GetEntitlementsSubscriptionEntitlementsGetResponse = GetEntitlementsSubscriptionEntitlementsGetResponses[keyof GetEntitlementsSubscriptionEntitlementsGetResponses];

export type ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetData = {
    body?: never;
    path: {
        /**
         * Org Id
         */
        org_id: string;
    };
    query?: never;
    url: '/admin/organizations/{org_id}/subscription-audit';
};

export type ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetError = ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetErrors[keyof ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetErrors];

export type ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetResponses = {
    /**
     * Response List Subscription Audit Admin Organizations  Org Id  Subscription Audit Get
     *
     * Successful Response
     */
    200: Array<PlanOverrideAuditRow>;
};

export type ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetResponse = ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetResponses[keyof ListSubscriptionAuditAdminOrganizationsOrgIdSubscriptionAuditGetResponses];

export type ListOrgSubscriptionsAdminOrganizationsGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/admin/organizations';
};

export type ListOrgSubscriptionsAdminOrganizationsGetResponses = {
    /**
     * Response List Org Subscriptions Admin Organizations Get
     *
     * Successful Response
     */
    200: Array<OrgAdminRow>;
};

export type ListOrgSubscriptionsAdminOrganizationsGetResponse = ListOrgSubscriptionsAdminOrganizationsGetResponses[keyof ListOrgSubscriptionsAdminOrganizationsGetResponses];

export type ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchData = {
    body: ChangeOrgFeatureSubscriptionRequest;
    path: {
        /**
         * Org Id
         */
        org_id: string;
        /**
         * Feature
         */
        feature: string;
    };
    query?: never;
    url: '/admin/organizations/{org_id}/features/{feature}/subscription';
};

export type ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchError = ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchErrors[keyof ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchErrors];

export type ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchResponses = {
    /**
     * Successful Response
     */
    200: ChangeOrgFeatureSubscriptionResponse;
};

export type ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchResponse = ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchResponses[keyof ChangeOrgFeatureSubscriptionAdminOrganizationsOrgIdFeaturesFeatureSubscriptionPatchResponses];

export type ListFeaturesSubscriptionFeaturesGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/subscription/features';
};

export type ListFeaturesSubscriptionFeaturesGetResponses = {
    /**
     * Response List Features Subscription Features Get
     *
     * Successful Response
     */
    200: {
        [key: string]: unknown;
    };
};

export type ListFeaturesSubscriptionFeaturesGetResponse = ListFeaturesSubscriptionFeaturesGetResponses[keyof ListFeaturesSubscriptionFeaturesGetResponses];

export type ListSubscriptionsAdminSubscriptionsGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Status
         *
         * Filter by status
         */
        status?: string | null;
        /**
         * Feature
         *
         * Filter by feature key
         */
        feature?: string | null;
        /**
         * Page
         */
        page?: number;
        /**
         * Page Size
         */
        page_size?: number;
    };
    url: '/admin/subscriptions';
};

export type ListSubscriptionsAdminSubscriptionsGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListSubscriptionsAdminSubscriptionsGetError = ListSubscriptionsAdminSubscriptionsGetErrors[keyof ListSubscriptionsAdminSubscriptionsGetErrors];

export type ListSubscriptionsAdminSubscriptionsGetResponses = {
    /**
     * Response List Subscriptions Admin Subscriptions Get
     *
     * Successful Response
     */
    200: Array<SubscriptionAdminRow>;
};

export type ListSubscriptionsAdminSubscriptionsGetResponse = ListSubscriptionsAdminSubscriptionsGetResponses[keyof ListSubscriptionsAdminSubscriptionsGetResponses];

export type CreateCheckoutSessionStripeCheckoutSessionPostData = {
    body: CheckoutSessionRequest;
    path?: never;
    query?: never;
    url: '/stripe/checkout-session';
};

export type CreateCheckoutSessionStripeCheckoutSessionPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateCheckoutSessionStripeCheckoutSessionPostError = CreateCheckoutSessionStripeCheckoutSessionPostErrors[keyof CreateCheckoutSessionStripeCheckoutSessionPostErrors];

export type CreateCheckoutSessionStripeCheckoutSessionPostResponses = {
    /**
     * Successful Response
     */
    200: CheckoutSessionResponse;
};

export type CreateCheckoutSessionStripeCheckoutSessionPostResponse = CreateCheckoutSessionStripeCheckoutSessionPostResponses[keyof CreateCheckoutSessionStripeCheckoutSessionPostResponses];

export type CreatePortalSessionStripePortalSessionPostData = {
    body?: PortalSessionRequest;
    path?: never;
    query?: never;
    url: '/stripe/portal-session';
};

export type CreatePortalSessionStripePortalSessionPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreatePortalSessionStripePortalSessionPostError = CreatePortalSessionStripePortalSessionPostErrors[keyof CreatePortalSessionStripePortalSessionPostErrors];

export type CreatePortalSessionStripePortalSessionPostResponses = {
    /**
     * Successful Response
     */
    200: PortalSessionResponse;
};

export type CreatePortalSessionStripePortalSessionPostResponse = CreatePortalSessionStripePortalSessionPostResponses[keyof CreatePortalSessionStripePortalSessionPostResponses];

export type StripeWebhookStripeWebhookPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stripe/webhook';
};

export type StripeWebhookStripeWebhookPostResponses = {
    /**
     * Response Stripe Webhook Stripe Webhook Post
     *
     * Successful Response
     */
    200: {
        [key: string]: unknown;
    };
};

export type StripeWebhookStripeWebhookPostResponse = StripeWebhookStripeWebhookPostResponses[keyof StripeWebhookStripeWebhookPostResponses];

export type StartDevTriageMgtReopenTriageIssueStartPostData = {
    body: BodyStartDevTriageMgtReopenTriageIssueStartPost;
    path?: never;
    query?: never;
    url: '/dev/triage_mgt/reopen_triage_issue/start';
};

export type StartDevTriageMgtReopenTriageIssueStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevTriageMgtReopenTriageIssueStartPostError = StartDevTriageMgtReopenTriageIssueStartPostErrors[keyof StartDevTriageMgtReopenTriageIssueStartPostErrors];

export type StartDevTriageMgtReopenTriageIssueStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDevTriageMgtGetTriageIssuesStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dev/triage_mgt/get_triage_issues/start';
};

export type StartDevTriageMgtGetTriageIssuesStartPostResponses = {
    /**
     * Successful Response
     */
    200: TriageIssueList;
};

export type StartDevTriageMgtGetTriageIssuesStartPostResponse = StartDevTriageMgtGetTriageIssuesStartPostResponses[keyof StartDevTriageMgtGetTriageIssuesStartPostResponses];

export type StartDevTriageMgtConvertPoolToLaneStartPostData = {
    body: BodyStartDevTriageMgtConvertPoolToLaneStartPost;
    path?: never;
    query?: never;
    url: '/dev/triage_mgt/convert_pool_to_lane/start';
};

export type StartDevTriageMgtConvertPoolToLaneStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevTriageMgtConvertPoolToLaneStartPostError = StartDevTriageMgtConvertPoolToLaneStartPostErrors[keyof StartDevTriageMgtConvertPoolToLaneStartPostErrors];

export type StartDevTriageMgtConvertPoolToLaneStartPostResponses = {
    /**
     * Response Start Dev Triage Mgt Convert Pool To Lane Start Post
     *
     * Successful Response
     */
    200: Array<DerivedEvidenceRef>;
};

export type StartDevTriageMgtConvertPoolToLaneStartPostResponse = StartDevTriageMgtConvertPoolToLaneStartPostResponses[keyof StartDevTriageMgtConvertPoolToLaneStartPostResponses];

export type StartDevTriageMgtConvertLaneToPoolStartPostData = {
    body: BodyStartDevTriageMgtConvertLaneToPoolStartPost;
    path?: never;
    query?: never;
    url: '/dev/triage_mgt/convert_lane_to_pool/start';
};

export type StartDevTriageMgtConvertLaneToPoolStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevTriageMgtConvertLaneToPoolStartPostError = StartDevTriageMgtConvertLaneToPoolStartPostErrors[keyof StartDevTriageMgtConvertLaneToPoolStartPostErrors];

export type StartDevTriageMgtConvertLaneToPoolStartPostResponses = {
    /**
     * Response Start Dev Triage Mgt Convert Lane To Pool Start Post
     *
     * Successful Response
     */
    200: Array<DerivedEvidenceRef>;
};

export type StartDevTriageMgtConvertLaneToPoolStartPostResponse = StartDevTriageMgtConvertLaneToPoolStartPostResponses[keyof StartDevTriageMgtConvertLaneToPoolStartPostResponses];

export type StartDevTriageMgtDismissTriageIssueStartPostData = {
    body: BodyStartDevTriageMgtDismissTriageIssueStartPost;
    path?: never;
    query?: never;
    url: '/dev/triage_mgt/dismiss_triage_issue/start';
};

export type StartDevTriageMgtDismissTriageIssueStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevTriageMgtDismissTriageIssueStartPostError = StartDevTriageMgtDismissTriageIssueStartPostErrors[keyof StartDevTriageMgtDismissTriageIssueStartPostErrors];

export type StartDevTriageMgtDismissTriageIssueStartPostResponses = {
    /**
     * Successful Response
     */
    200: TriageIssueDecision;
};

export type StartDevTriageMgtDismissTriageIssueStartPostResponse = StartDevTriageMgtDismissTriageIssueStartPostResponses[keyof StartDevTriageMgtDismissTriageIssueStartPostResponses];

export type StartDevTriageMgtUnifyLanesStartPostData = {
    body: BodyStartDevTriageMgtUnifyLanesStartPost;
    path?: never;
    query?: never;
    url: '/dev/triage_mgt/unify_lanes/start';
};

export type StartDevTriageMgtUnifyLanesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevTriageMgtUnifyLanesStartPostError = StartDevTriageMgtUnifyLanesStartPostErrors[keyof StartDevTriageMgtUnifyLanesStartPostErrors];

export type StartDevTriageMgtUnifyLanesStartPostResponses = {
    /**
     * Response Start Dev Triage Mgt Unify Lanes Start Post
     *
     * Successful Response
     */
    200: Array<DerivedEvidenceRef>;
};

export type StartDevTriageMgtUnifyLanesStartPostResponse = StartDevTriageMgtUnifyLanesStartPostResponses[keyof StartDevTriageMgtUnifyLanesStartPostResponses];

export type StartDevTriageMgtAddExternalPoolStartPostData = {
    body: BodyStartDevTriageMgtAddExternalPoolStartPost;
    path?: never;
    query?: never;
    url: '/dev/triage_mgt/add_external_pool/start';
};

export type StartDevTriageMgtAddExternalPoolStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevTriageMgtAddExternalPoolStartPostError = StartDevTriageMgtAddExternalPoolStartPostErrors[keyof StartDevTriageMgtAddExternalPoolStartPostErrors];

export type StartDevTriageMgtAddExternalPoolStartPostResponses = {
    /**
     * Successful Response
     */
    200: PoolTriageDecision;
};

export type StartDevTriageMgtAddExternalPoolStartPostResponse = StartDevTriageMgtAddExternalPoolStartPostResponses[keyof StartDevTriageMgtAddExternalPoolStartPostResponses];

export type StartDevTriageMgtLinkLanesToApplicationStartPostData = {
    body: BodyStartDevTriageMgtLinkLanesToApplicationStartPost;
    path?: never;
    query?: never;
    url: '/dev/triage_mgt/link_lanes_to_application/start';
};

export type StartDevTriageMgtLinkLanesToApplicationStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevTriageMgtLinkLanesToApplicationStartPostError = StartDevTriageMgtLinkLanesToApplicationStartPostErrors[keyof StartDevTriageMgtLinkLanesToApplicationStartPostErrors];

export type StartDevTriageMgtLinkLanesToApplicationStartPostResponses = {
    /**
     * Response Start Dev Triage Mgt Link Lanes To Application Start Post
     *
     * Successful Response
     */
    200: Array<DerivedEvidenceRef>;
};

export type StartDevTriageMgtLinkLanesToApplicationStartPostResponse = StartDevTriageMgtLinkLanesToApplicationStartPostResponses[keyof StartDevTriageMgtLinkLanesToApplicationStartPostResponses];

export type StartDevTriageMgtResolveNamedRecipientStartPostData = {
    body: BodyStartDevTriageMgtResolveNamedRecipientStartPost;
    path?: never;
    query?: never;
    url: '/dev/triage_mgt/resolve_named_recipient/start';
};

export type StartDevTriageMgtResolveNamedRecipientStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevTriageMgtResolveNamedRecipientStartPostError = StartDevTriageMgtResolveNamedRecipientStartPostErrors[keyof StartDevTriageMgtResolveNamedRecipientStartPostErrors];

export type StartDevTriageMgtResolveNamedRecipientStartPostResponses = {
    /**
     * Successful Response
     */
    200: PoolTriageDecision;
};

export type StartDevTriageMgtResolveNamedRecipientStartPostResponse = StartDevTriageMgtResolveNamedRecipientStartPostResponses[keyof StartDevTriageMgtResolveNamedRecipientStartPostResponses];

export type StartDevTriageMgtProposeRestructureStartPostData = {
    body: BodyStartDevTriageMgtProposeRestructureStartPost;
    path?: never;
    query?: never;
    url: '/dev/triage_mgt/propose_restructure/start';
};

export type StartDevTriageMgtProposeRestructureStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevTriageMgtProposeRestructureStartPostError = StartDevTriageMgtProposeRestructureStartPostErrors[keyof StartDevTriageMgtProposeRestructureStartPostErrors];

export type StartDevTriageMgtProposeRestructureStartPostResponses = {
    /**
     * Successful Response
     */
    200: RestructureProposal;
};

export type StartDevTriageMgtProposeRestructureStartPostResponse = StartDevTriageMgtProposeRestructureStartPostResponses[keyof StartDevTriageMgtProposeRestructureStartPostResponses];

export type StartDevBuildMgtSetBuildTicketBuiltStartPostData = {
    body: BodyStartDevBuildMgtSetBuildTicketBuiltStartPost;
    path?: never;
    query?: never;
    url: '/dev/build_mgt/set_build_ticket_built/start';
};

export type StartDevBuildMgtSetBuildTicketBuiltStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevBuildMgtSetBuildTicketBuiltStartPostError = StartDevBuildMgtSetBuildTicketBuiltStartPostErrors[keyof StartDevBuildMgtSetBuildTicketBuiltStartPostErrors];

export type StartDevBuildMgtSetBuildTicketBuiltStartPostResponses = {
    /**
     * Successful Response
     */
    200: BuildTicket;
};

export type StartDevBuildMgtSetBuildTicketBuiltStartPostResponse = StartDevBuildMgtSetBuildTicketBuiltStartPostResponses[keyof StartDevBuildMgtSetBuildTicketBuiltStartPostResponses];

export type StartDevBuildMgtMarkAllBuiltStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dev/build_mgt/mark_all_built/start';
};

export type StartDevBuildMgtMarkAllBuiltStartPostResponses = {
    /**
     * Successful Response
     */
    200: DriftLedger;
};

export type StartDevBuildMgtMarkAllBuiltStartPostResponse = StartDevBuildMgtMarkAllBuiltStartPostResponses[keyof StartDevBuildMgtMarkAllBuiltStartPostResponses];

export type StartDevBuildMgtUpdateBuildTicketStartPostData = {
    body: BodyStartDevBuildMgtUpdateBuildTicketStartPost;
    path?: never;
    query?: never;
    url: '/dev/build_mgt/update_build_ticket/start';
};

export type StartDevBuildMgtUpdateBuildTicketStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevBuildMgtUpdateBuildTicketStartPostError = StartDevBuildMgtUpdateBuildTicketStartPostErrors[keyof StartDevBuildMgtUpdateBuildTicketStartPostErrors];

export type StartDevBuildMgtUpdateBuildTicketStartPostResponses = {
    /**
     * Successful Response
     */
    200: BuildTicket;
};

export type StartDevBuildMgtUpdateBuildTicketStartPostResponse = StartDevBuildMgtUpdateBuildTicketStartPostResponses[keyof StartDevBuildMgtUpdateBuildTicketStartPostResponses];

export type StartDevBuildMgtGetChangeDetailStartPostData = {
    body: BodyStartDevBuildMgtGetChangeDetailStartPost;
    path?: never;
    query?: never;
    url: '/dev/build_mgt/get_change_detail/start';
};

export type StartDevBuildMgtGetChangeDetailStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevBuildMgtGetChangeDetailStartPostError = StartDevBuildMgtGetChangeDetailStartPostErrors[keyof StartDevBuildMgtGetChangeDetailStartPostErrors];

export type StartDevBuildMgtGetChangeDetailStartPostResponses = {
    /**
     * Successful Response
     */
    200: DriftChangeDetail;
};

export type StartDevBuildMgtGetChangeDetailStartPostResponse = StartDevBuildMgtGetChangeDetailStartPostResponses[keyof StartDevBuildMgtGetChangeDetailStartPostResponses];

export type StartDevBuildMgtCreateBuildTicketStartPostData = {
    body: BodyStartDevBuildMgtCreateBuildTicketStartPost;
    path?: never;
    query?: never;
    url: '/dev/build_mgt/create_build_ticket/start';
};

export type StartDevBuildMgtCreateBuildTicketStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevBuildMgtCreateBuildTicketStartPostError = StartDevBuildMgtCreateBuildTicketStartPostErrors[keyof StartDevBuildMgtCreateBuildTicketStartPostErrors];

export type StartDevBuildMgtCreateBuildTicketStartPostResponses = {
    /**
     * Successful Response
     */
    200: BuildTicket;
};

export type StartDevBuildMgtCreateBuildTicketStartPostResponse = StartDevBuildMgtCreateBuildTicketStartPostResponses[keyof StartDevBuildMgtCreateBuildTicketStartPostResponses];

export type StartDevBuildMgtGetDriftStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dev/build_mgt/get_drift/start';
};

export type StartDevBuildMgtGetDriftStartPostResponses = {
    /**
     * Successful Response
     */
    200: StekDrift;
};

export type StartDevBuildMgtGetDriftStartPostResponse = StartDevBuildMgtGetDriftStartPostResponses[keyof StartDevBuildMgtGetDriftStartPostResponses];

export type StartDevBuildMgtDeleteBuildTicketStartPostData = {
    body: BodyStartDevBuildMgtDeleteBuildTicketStartPost;
    path?: never;
    query?: never;
    url: '/dev/build_mgt/delete_build_ticket/start';
};

export type StartDevBuildMgtDeleteBuildTicketStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevBuildMgtDeleteBuildTicketStartPostError = StartDevBuildMgtDeleteBuildTicketStartPostErrors[keyof StartDevBuildMgtDeleteBuildTicketStartPostErrors];

export type StartDevBuildMgtDeleteBuildTicketStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDevApplicationEntityMgtGetApplicationEntitiesStartPostData = {
    body: BodyStartDevApplicationEntityMgtGetApplicationEntitiesStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_entity_mgt/get_application_entities/start';
};

export type StartDevApplicationEntityMgtGetApplicationEntitiesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationEntityMgtGetApplicationEntitiesStartPostError = StartDevApplicationEntityMgtGetApplicationEntitiesStartPostErrors[keyof StartDevApplicationEntityMgtGetApplicationEntitiesStartPostErrors];

export type StartDevApplicationEntityMgtGetApplicationEntitiesStartPostResponses = {
    /**
     * Successful Response
     */
    200: ApplicationEntitiesView;
};

export type StartDevApplicationEntityMgtGetApplicationEntitiesStartPostResponse = StartDevApplicationEntityMgtGetApplicationEntitiesStartPostResponses[keyof StartDevApplicationEntityMgtGetApplicationEntitiesStartPostResponses];

export type StartDevApplicationEntityMgtUpdateApplicationEntityStartPostData = {
    body: BodyStartDevApplicationEntityMgtUpdateApplicationEntityStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_entity_mgt/update_application_entity/start';
};

export type StartDevApplicationEntityMgtUpdateApplicationEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationEntityMgtUpdateApplicationEntityStartPostError = StartDevApplicationEntityMgtUpdateApplicationEntityStartPostErrors[keyof StartDevApplicationEntityMgtUpdateApplicationEntityStartPostErrors];

export type StartDevApplicationEntityMgtUpdateApplicationEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDevApplicationEntityMgtCreateApplicationEntityStartPostData = {
    body: BodyStartDevApplicationEntityMgtCreateApplicationEntityStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_entity_mgt/create_application_entity/start';
};

export type StartDevApplicationEntityMgtCreateApplicationEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationEntityMgtCreateApplicationEntityStartPostError = StartDevApplicationEntityMgtCreateApplicationEntityStartPostErrors[keyof StartDevApplicationEntityMgtCreateApplicationEntityStartPostErrors];

export type StartDevApplicationEntityMgtCreateApplicationEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: ApplicationEntity;
};

export type StartDevApplicationEntityMgtCreateApplicationEntityStartPostResponse = StartDevApplicationEntityMgtCreateApplicationEntityStartPostResponses[keyof StartDevApplicationEntityMgtCreateApplicationEntityStartPostResponses];

export type StartDevApplicationEntityMgtDeleteApplicationEntityStartPostData = {
    body: BodyStartDevApplicationEntityMgtDeleteApplicationEntityStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_entity_mgt/delete_application_entity/start';
};

export type StartDevApplicationEntityMgtDeleteApplicationEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationEntityMgtDeleteApplicationEntityStartPostError = StartDevApplicationEntityMgtDeleteApplicationEntityStartPostErrors[keyof StartDevApplicationEntityMgtDeleteApplicationEntityStartPostErrors];

export type StartDevApplicationEntityMgtDeleteApplicationEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostData = {
    body: BodyStartDevApplicationEntityMgtUnlinkBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_entity_mgt/unlink_business_entity/start';
};

export type StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostError = StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostErrors[keyof StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostErrors];

export type StartDevApplicationEntityMgtUnlinkBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDevApplicationEntityMgtLinkBusinessEntityStartPostData = {
    body: BodyStartDevApplicationEntityMgtLinkBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_entity_mgt/link_business_entity/start';
};

export type StartDevApplicationEntityMgtLinkBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationEntityMgtLinkBusinessEntityStartPostError = StartDevApplicationEntityMgtLinkBusinessEntityStartPostErrors[keyof StartDevApplicationEntityMgtLinkBusinessEntityStartPostErrors];

export type StartDevApplicationEntityMgtLinkBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDevExternalPartyMgtDeleteExternalPartyStartPostData = {
    body: BodyStartDevExternalPartyMgtDeleteExternalPartyStartPost;
    path?: never;
    query?: never;
    url: '/dev/external_party_mgt/delete_external_party/start';
};

export type StartDevExternalPartyMgtDeleteExternalPartyStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevExternalPartyMgtDeleteExternalPartyStartPostError = StartDevExternalPartyMgtDeleteExternalPartyStartPostErrors[keyof StartDevExternalPartyMgtDeleteExternalPartyStartPostErrors];

export type StartDevExternalPartyMgtDeleteExternalPartyStartPostResponses = {
    /**
     * Successful Response
     */
    200: ExternalParty;
};

export type StartDevExternalPartyMgtDeleteExternalPartyStartPostResponse = StartDevExternalPartyMgtDeleteExternalPartyStartPostResponses[keyof StartDevExternalPartyMgtDeleteExternalPartyStartPostResponses];

export type StartDevExternalPartyMgtUpdateExternalPartyStartPostData = {
    body: BodyStartDevExternalPartyMgtUpdateExternalPartyStartPost;
    path?: never;
    query?: never;
    url: '/dev/external_party_mgt/update_external_party/start';
};

export type StartDevExternalPartyMgtUpdateExternalPartyStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevExternalPartyMgtUpdateExternalPartyStartPostError = StartDevExternalPartyMgtUpdateExternalPartyStartPostErrors[keyof StartDevExternalPartyMgtUpdateExternalPartyStartPostErrors];

export type StartDevExternalPartyMgtUpdateExternalPartyStartPostResponses = {
    /**
     * Successful Response
     */
    200: ExternalParty;
};

export type StartDevExternalPartyMgtUpdateExternalPartyStartPostResponse = StartDevExternalPartyMgtUpdateExternalPartyStartPostResponses[keyof StartDevExternalPartyMgtUpdateExternalPartyStartPostResponses];

export type StartDevExternalPartyMgtCreateExternalPartyStartPostData = {
    body: BodyStartDevExternalPartyMgtCreateExternalPartyStartPost;
    path?: never;
    query?: never;
    url: '/dev/external_party_mgt/create_external_party/start';
};

export type StartDevExternalPartyMgtCreateExternalPartyStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevExternalPartyMgtCreateExternalPartyStartPostError = StartDevExternalPartyMgtCreateExternalPartyStartPostErrors[keyof StartDevExternalPartyMgtCreateExternalPartyStartPostErrors];

export type StartDevExternalPartyMgtCreateExternalPartyStartPostResponses = {
    /**
     * Successful Response
     */
    200: ExternalParty;
};

export type StartDevExternalPartyMgtCreateExternalPartyStartPostResponse = StartDevExternalPartyMgtCreateExternalPartyStartPostResponses[keyof StartDevExternalPartyMgtCreateExternalPartyStartPostResponses];

export type StartDevExternalPartyMgtGetExternalPartiesStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dev/external_party_mgt/get_external_parties/start';
};

export type StartDevExternalPartyMgtGetExternalPartiesStartPostResponses = {
    /**
     * Response Start Dev External Party Mgt Get External Parties Start Post
     *
     * Successful Response
     */
    200: Array<ExternalParty>;
};

export type StartDevExternalPartyMgtGetExternalPartiesStartPostResponse = StartDevExternalPartyMgtGetExternalPartiesStartPostResponses[keyof StartDevExternalPartyMgtGetExternalPartiesStartPostResponses];

export type StartDevApplicationMgtCreateApplicationStartPostData = {
    body: BodyStartDevApplicationMgtCreateApplicationStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/create_application/start';
};

export type StartDevApplicationMgtCreateApplicationStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtCreateApplicationStartPostError = StartDevApplicationMgtCreateApplicationStartPostErrors[keyof StartDevApplicationMgtCreateApplicationStartPostErrors];

export type StartDevApplicationMgtCreateApplicationStartPostResponses = {
    /**
     * Successful Response
     */
    200: Application;
};

export type StartDevApplicationMgtCreateApplicationStartPostResponse = StartDevApplicationMgtCreateApplicationStartPostResponses[keyof StartDevApplicationMgtCreateApplicationStartPostResponses];

export type StartDevApplicationMgtGetStekRolesStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_stek_roles/start';
};

export type StartDevApplicationMgtGetStekRolesStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Stek Roles Start Post
     *
     * Successful Response
     */
    200: Array<StekRole>;
};

export type StartDevApplicationMgtGetStekRolesStartPostResponse = StartDevApplicationMgtGetStekRolesStartPostResponses[keyof StartDevApplicationMgtGetStekRolesStartPostResponses];

export type StartDevApplicationMgtPromotePoolToRoleStartPostData = {
    body: BodyStartDevApplicationMgtPromotePoolToRoleStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/promote_pool_to_role/start';
};

export type StartDevApplicationMgtPromotePoolToRoleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtPromotePoolToRoleStartPostError = StartDevApplicationMgtPromotePoolToRoleStartPostErrors[keyof StartDevApplicationMgtPromotePoolToRoleStartPostErrors];

export type StartDevApplicationMgtPromotePoolToRoleStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Promote Pool To Role Start Post
     *
     * Successful Response
     */
    200: Array<PoolRolePromotion>;
};

export type StartDevApplicationMgtPromotePoolToRoleStartPostResponse = StartDevApplicationMgtPromotePoolToRoleStartPostResponses[keyof StartDevApplicationMgtPromotePoolToRoleStartPostResponses];

export type StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostData = {
    body: BodyStartDevApplicationMgtGetApplicationsGroupedByProcessStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_applications_grouped_by_process/start';
};

export type StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostError = StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostErrors[keyof StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostErrors];

export type StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Applications Grouped By Process Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<Application>;
    };
};

export type StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostResponse = StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostResponses[keyof StartDevApplicationMgtGetApplicationsGroupedByProcessStartPostResponses];

export type StartDevApplicationMgtResolvePoolAsPartyStartPostData = {
    body: BodyStartDevApplicationMgtResolvePoolAsPartyStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/resolve_pool_as_party/start';
};

export type StartDevApplicationMgtResolvePoolAsPartyStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtResolvePoolAsPartyStartPostError = StartDevApplicationMgtResolvePoolAsPartyStartPostErrors[keyof StartDevApplicationMgtResolvePoolAsPartyStartPostErrors];

export type StartDevApplicationMgtResolvePoolAsPartyStartPostResponses = {
    /**
     * Successful Response
     */
    200: PoolTriageDecision;
};

export type StartDevApplicationMgtResolvePoolAsPartyStartPostResponse = StartDevApplicationMgtResolvePoolAsPartyStartPostResponses[keyof StartDevApplicationMgtResolvePoolAsPartyStartPostResponses];

export type StartDevApplicationMgtDeleteApplicationStartPostData = {
    body: BodyStartDevApplicationMgtDeleteApplicationStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/delete_application/start';
};

export type StartDevApplicationMgtDeleteApplicationStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtDeleteApplicationStartPostError = StartDevApplicationMgtDeleteApplicationStartPostErrors[keyof StartDevApplicationMgtDeleteApplicationStartPostErrors];

export type StartDevApplicationMgtDeleteApplicationStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDevApplicationMgtUnresolvePoolStartPostData = {
    body: BodyStartDevApplicationMgtUnresolvePoolStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/unresolve_pool/start';
};

export type StartDevApplicationMgtUnresolvePoolStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtUnresolvePoolStartPostError = StartDevApplicationMgtUnresolvePoolStartPostErrors[keyof StartDevApplicationMgtUnresolvePoolStartPostErrors];

export type StartDevApplicationMgtUnresolvePoolStartPostResponses = {
    /**
     * Successful Response
     */
    200: PoolTriageDecision;
};

export type StartDevApplicationMgtUnresolvePoolStartPostResponse = StartDevApplicationMgtUnresolvePoolStartPostResponses[keyof StartDevApplicationMgtUnresolvePoolStartPostResponses];

export type StartDevApplicationMgtGetApplicationsByStekWithEntitiesStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_applications_by_stek_with_entities/start';
};

export type StartDevApplicationMgtGetApplicationsByStekWithEntitiesStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Applications By Stek With Entities Start Post
     *
     * Successful Response
     */
    200: Array<ApplicationWithEntities>;
};

export type StartDevApplicationMgtGetApplicationsByStekWithEntitiesStartPostResponse = StartDevApplicationMgtGetApplicationsByStekWithEntitiesStartPostResponses[keyof StartDevApplicationMgtGetApplicationsByStekWithEntitiesStartPostResponses];

export type StartDevApplicationMgtProposePoolResolutionStartPostData = {
    body: BodyStartDevApplicationMgtProposePoolResolutionStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/propose_pool_resolution/start';
};

export type StartDevApplicationMgtProposePoolResolutionStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtProposePoolResolutionStartPostError = StartDevApplicationMgtProposePoolResolutionStartPostErrors[keyof StartDevApplicationMgtProposePoolResolutionStartPostErrors];

export type StartDevApplicationMgtProposePoolResolutionStartPostResponses = {
    /**
     * Successful Response
     */
    200: PoolResolutionPreview;
};

export type StartDevApplicationMgtProposePoolResolutionStartPostResponse = StartDevApplicationMgtProposePoolResolutionStartPostResponses[keyof StartDevApplicationMgtProposePoolResolutionStartPostResponses];

export type StartDevApplicationMgtGetExternalCommunicationMapStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_external_communication_map/start';
};

export type StartDevApplicationMgtGetExternalCommunicationMapStartPostResponses = {
    /**
     * Successful Response
     */
    200: ExternalCommunicationMap;
};

export type StartDevApplicationMgtGetExternalCommunicationMapStartPostResponse = StartDevApplicationMgtGetExternalCommunicationMapStartPostResponses[keyof StartDevApplicationMgtGetExternalCommunicationMapStartPostResponses];

export type StartDevApplicationMgtGetPoolTriageSuggestionsStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_pool_triage_suggestions/start';
};

export type StartDevApplicationMgtGetPoolTriageSuggestionsStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Pool Triage Suggestions Start Post
     *
     * Successful Response
     */
    200: Array<PoolTriageSuggestion>;
};

export type StartDevApplicationMgtGetPoolTriageSuggestionsStartPostResponse = StartDevApplicationMgtGetPoolTriageSuggestionsStartPostResponses[keyof StartDevApplicationMgtGetPoolTriageSuggestionsStartPostResponses];

export type StartDevApplicationMgtUpdateApplicationStartPostData = {
    body: BodyStartDevApplicationMgtUpdateApplicationStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/update_application/start';
};

export type StartDevApplicationMgtUpdateApplicationStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtUpdateApplicationStartPostError = StartDevApplicationMgtUpdateApplicationStartPostErrors[keyof StartDevApplicationMgtUpdateApplicationStartPostErrors];

export type StartDevApplicationMgtUpdateApplicationStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDevApplicationMgtGetApplicationsGroupedByProductStartPostData = {
    body: BodyStartDevApplicationMgtGetApplicationsGroupedByProductStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_applications_grouped_by_product/start';
};

export type StartDevApplicationMgtGetApplicationsGroupedByProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtGetApplicationsGroupedByProductStartPostError = StartDevApplicationMgtGetApplicationsGroupedByProductStartPostErrors[keyof StartDevApplicationMgtGetApplicationsGroupedByProductStartPostErrors];

export type StartDevApplicationMgtGetApplicationsGroupedByProductStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Applications Grouped By Product Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<Application>;
    };
};

export type StartDevApplicationMgtGetApplicationsGroupedByProductStartPostResponse = StartDevApplicationMgtGetApplicationsGroupedByProductStartPostResponses[keyof StartDevApplicationMgtGetApplicationsGroupedByProductStartPostResponses];

export type StartDevApplicationMgtGetApplicationsByStekStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_applications_by_stek/start';
};

export type StartDevApplicationMgtGetApplicationsByStekStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Applications By Stek Start Post
     *
     * Successful Response
     */
    200: Array<Application>;
};

export type StartDevApplicationMgtGetApplicationsByStekStartPostResponse = StartDevApplicationMgtGetApplicationsByStekStartPostResponses[keyof StartDevApplicationMgtGetApplicationsByStekStartPostResponses];

export type StartDevApplicationMgtGetPoolTriageDecisionsStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_pool_triage_decisions/start';
};

export type StartDevApplicationMgtGetPoolTriageDecisionsStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Pool Triage Decisions Start Post
     *
     * Successful Response
     */
    200: Array<PoolTriageDecision>;
};

export type StartDevApplicationMgtGetPoolTriageDecisionsStartPostResponse = StartDevApplicationMgtGetPoolTriageDecisionsStartPostResponses[keyof StartDevApplicationMgtGetPoolTriageDecisionsStartPostResponses];

export type StartDevApplicationMgtGetApplicationsByDomainStartPostData = {
    body: BodyStartDevApplicationMgtGetApplicationsByDomainStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_applications_by_domain/start';
};

export type StartDevApplicationMgtGetApplicationsByDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtGetApplicationsByDomainStartPostError = StartDevApplicationMgtGetApplicationsByDomainStartPostErrors[keyof StartDevApplicationMgtGetApplicationsByDomainStartPostErrors];

export type StartDevApplicationMgtGetApplicationsByDomainStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Applications By Domain Start Post
     *
     * Successful Response
     */
    200: Array<Application>;
};

export type StartDevApplicationMgtGetApplicationsByDomainStartPostResponse = StartDevApplicationMgtGetApplicationsByDomainStartPostResponses[keyof StartDevApplicationMgtGetApplicationsByDomainStartPostResponses];

export type StartDevApplicationMgtResolvePoolAsReferenceStartPostData = {
    body: BodyStartDevApplicationMgtResolvePoolAsReferenceStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/resolve_pool_as_reference/start';
};

export type StartDevApplicationMgtResolvePoolAsReferenceStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtResolvePoolAsReferenceStartPostError = StartDevApplicationMgtResolvePoolAsReferenceStartPostErrors[keyof StartDevApplicationMgtResolvePoolAsReferenceStartPostErrors];

export type StartDevApplicationMgtResolvePoolAsReferenceStartPostResponses = {
    /**
     * Successful Response
     */
    200: PoolTriageDecision;
};

export type StartDevApplicationMgtResolvePoolAsReferenceStartPostResponse = StartDevApplicationMgtResolvePoolAsReferenceStartPostResponses[keyof StartDevApplicationMgtResolvePoolAsReferenceStartPostResponses];

export type StartDevApplicationMgtGetApplicationsByProductStartPostData = {
    body: BodyStartDevApplicationMgtGetApplicationsByProductStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_applications_by_product/start';
};

export type StartDevApplicationMgtGetApplicationsByProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtGetApplicationsByProductStartPostError = StartDevApplicationMgtGetApplicationsByProductStartPostErrors[keyof StartDevApplicationMgtGetApplicationsByProductStartPostErrors];

export type StartDevApplicationMgtGetApplicationsByProductStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Applications By Product Start Post
     *
     * Successful Response
     */
    200: Array<Application>;
};

export type StartDevApplicationMgtGetApplicationsByProductStartPostResponse = StartDevApplicationMgtGetApplicationsByProductStartPostResponses[keyof StartDevApplicationMgtGetApplicationsByProductStartPostResponses];

export type StartDevApplicationMgtLinkProcessTaskToApplicationStartPostData = {
    body: BodyStartDevApplicationMgtLinkProcessTaskToApplicationStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/link_process_task_to_application/start';
};

export type StartDevApplicationMgtLinkProcessTaskToApplicationStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtLinkProcessTaskToApplicationStartPostError = StartDevApplicationMgtLinkProcessTaskToApplicationStartPostErrors[keyof StartDevApplicationMgtLinkProcessTaskToApplicationStartPostErrors];

export type StartDevApplicationMgtLinkProcessTaskToApplicationStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostData = {
    body: BodyStartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/unlink_process_task_from_application/start';
};

export type StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostError = StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostErrors[keyof StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostErrors];

export type StartDevApplicationMgtUnlinkProcessTaskFromApplicationStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDevApplicationMgtGetApplicationStartPostData = {
    body: BodyStartDevApplicationMgtGetApplicationStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_application/start';
};

export type StartDevApplicationMgtGetApplicationStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtGetApplicationStartPostError = StartDevApplicationMgtGetApplicationStartPostErrors[keyof StartDevApplicationMgtGetApplicationStartPostErrors];

export type StartDevApplicationMgtGetApplicationStartPostResponses = {
    /**
     * Successful Response
     */
    200: Application;
};

export type StartDevApplicationMgtGetApplicationStartPostResponse = StartDevApplicationMgtGetApplicationStartPostResponses[keyof StartDevApplicationMgtGetApplicationStartPostResponses];

export type StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostData = {
    body: BodyStartDevApplicationMgtGetApplicationsGroupedByDomainStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_applications_grouped_by_domain/start';
};

export type StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostError = StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostErrors[keyof StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostErrors];

export type StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Applications Grouped By Domain Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<Application>;
    };
};

export type StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostResponse = StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostResponses[keyof StartDevApplicationMgtGetApplicationsGroupedByDomainStartPostResponses];

export type StartDevApplicationMgtResolvePoolAsApplicationStartPostData = {
    body: BodyStartDevApplicationMgtResolvePoolAsApplicationStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/resolve_pool_as_application/start';
};

export type StartDevApplicationMgtResolvePoolAsApplicationStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtResolvePoolAsApplicationStartPostError = StartDevApplicationMgtResolvePoolAsApplicationStartPostErrors[keyof StartDevApplicationMgtResolvePoolAsApplicationStartPostErrors];

export type StartDevApplicationMgtResolvePoolAsApplicationStartPostResponses = {
    /**
     * Successful Response
     */
    200: PoolTriageDecision;
};

export type StartDevApplicationMgtResolvePoolAsApplicationStartPostResponse = StartDevApplicationMgtResolvePoolAsApplicationStartPostResponses[keyof StartDevApplicationMgtResolvePoolAsApplicationStartPostResponses];

export type StartDevApplicationMgtGetApplicationsByProcessStartPostData = {
    body: BodyStartDevApplicationMgtGetApplicationsByProcessStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/get_applications_by_process/start';
};

export type StartDevApplicationMgtGetApplicationsByProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtGetApplicationsByProcessStartPostError = StartDevApplicationMgtGetApplicationsByProcessStartPostErrors[keyof StartDevApplicationMgtGetApplicationsByProcessStartPostErrors];

export type StartDevApplicationMgtGetApplicationsByProcessStartPostResponses = {
    /**
     * Response Start Dev Application Mgt Get Applications By Process Start Post
     *
     * Successful Response
     */
    200: Array<Application>;
};

export type StartDevApplicationMgtGetApplicationsByProcessStartPostResponse = StartDevApplicationMgtGetApplicationsByProcessStartPostResponses[keyof StartDevApplicationMgtGetApplicationsByProcessStartPostResponses];

export type StartDevApplicationMgtSetPoolAppScopeStartPostData = {
    body: BodyStartDevApplicationMgtSetPoolAppScopeStartPost;
    path?: never;
    query?: never;
    url: '/dev/application_mgt/set_pool_app_scope/start';
};

export type StartDevApplicationMgtSetPoolAppScopeStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDevApplicationMgtSetPoolAppScopeStartPostError = StartDevApplicationMgtSetPoolAppScopeStartPostErrors[keyof StartDevApplicationMgtSetPoolAppScopeStartPostErrors];

export type StartDevApplicationMgtSetPoolAppScopeStartPostResponses = {
    /**
     * Successful Response
     */
    200: PoolTriageDecision;
};

export type StartDevApplicationMgtSetPoolAppScopeStartPostResponse = StartDevApplicationMgtSetPoolAppScopeStartPostResponses[keyof StartDevApplicationMgtSetPoolAppScopeStartPostResponses];

export type StartProcessProcessMgtGetProcessStartPostData = {
    body: BodyStartProcessProcessMgtGetProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/get_process/start';
};

export type StartProcessProcessMgtGetProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtGetProcessStartPostError = StartProcessProcessMgtGetProcessStartPostErrors[keyof StartProcessProcessMgtGetProcessStartPostErrors];

export type StartProcessProcessMgtGetProcessStartPostResponses = {
    /**
     * Successful Response
     */
    200: Process;
};

export type StartProcessProcessMgtGetProcessStartPostResponse = StartProcessProcessMgtGetProcessStartPostResponses[keyof StartProcessProcessMgtGetProcessStartPostResponses];

export type StartProcessProcessMgtGetProcessThumbnailsByProductStartPostData = {
    body: BodyStartProcessProcessMgtGetProcessThumbnailsByProductStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/get_process_thumbnails_by_product/start';
};

export type StartProcessProcessMgtGetProcessThumbnailsByProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtGetProcessThumbnailsByProductStartPostError = StartProcessProcessMgtGetProcessThumbnailsByProductStartPostErrors[keyof StartProcessProcessMgtGetProcessThumbnailsByProductStartPostErrors];

export type StartProcessProcessMgtGetProcessThumbnailsByProductStartPostResponses = {
    /**
     * Response Start Process Process Mgt Get Process Thumbnails By Product Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: string | null;
    };
};

export type StartProcessProcessMgtGetProcessThumbnailsByProductStartPostResponse = StartProcessProcessMgtGetProcessThumbnailsByProductStartPostResponses[keyof StartProcessProcessMgtGetProcessThumbnailsByProductStartPostResponses];

export type StartProcessProcessMgtGetProcessDiagramStartPostData = {
    body: BodyStartProcessProcessMgtGetProcessDiagramStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/get_process_diagram/start';
};

export type StartProcessProcessMgtGetProcessDiagramStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtGetProcessDiagramStartPostError = StartProcessProcessMgtGetProcessDiagramStartPostErrors[keyof StartProcessProcessMgtGetProcessDiagramStartPostErrors];

export type StartProcessProcessMgtGetProcessDiagramStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessMgtMoveProcessStartPostData = {
    body: BodyStartProcessProcessMgtMoveProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/move_process/start';
};

export type StartProcessProcessMgtMoveProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtMoveProcessStartPostError = StartProcessProcessMgtMoveProcessStartPostErrors[keyof StartProcessProcessMgtMoveProcessStartPostErrors];

export type StartProcessProcessMgtMoveProcessStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessMgtGetProcessesByProductStartPostData = {
    body: BodyStartProcessProcessMgtGetProcessesByProductStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/get_processes_by_product/start';
};

export type StartProcessProcessMgtGetProcessesByProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtGetProcessesByProductStartPostError = StartProcessProcessMgtGetProcessesByProductStartPostErrors[keyof StartProcessProcessMgtGetProcessesByProductStartPostErrors];

export type StartProcessProcessMgtGetProcessesByProductStartPostResponses = {
    /**
     * Response Start Process Process Mgt Get Processes By Product Start Post
     *
     * Successful Response
     */
    200: Array<Process>;
};

export type StartProcessProcessMgtGetProcessesByProductStartPostResponse = StartProcessProcessMgtGetProcessesByProductStartPostResponses[keyof StartProcessProcessMgtGetProcessesByProductStartPostResponses];

export type StartProcessProcessMgtUpdateProcessOrdersStartPostData = {
    body: BodyStartProcessProcessMgtUpdateProcessOrdersStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/update_process_orders/start';
};

export type StartProcessProcessMgtUpdateProcessOrdersStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtUpdateProcessOrdersStartPostError = StartProcessProcessMgtUpdateProcessOrdersStartPostErrors[keyof StartProcessProcessMgtUpdateProcessOrdersStartPostErrors];

export type StartProcessProcessMgtUpdateProcessOrdersStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessMgtDeleteProcessStartPostData = {
    body: BodyStartProcessProcessMgtDeleteProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/delete_process/start';
};

export type StartProcessProcessMgtDeleteProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtDeleteProcessStartPostError = StartProcessProcessMgtDeleteProcessStartPostErrors[keyof StartProcessProcessMgtDeleteProcessStartPostErrors];

export type StartProcessProcessMgtDeleteProcessStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessMgtDeployProcessStartPostData = {
    body: BodyStartProcessProcessMgtDeployProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/deploy_process/start';
};

export type StartProcessProcessMgtDeployProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtDeployProcessStartPostError = StartProcessProcessMgtDeployProcessStartPostErrors[keyof StartProcessProcessMgtDeployProcessStartPostErrors];

export type StartProcessProcessMgtDeployProcessStartPostResponses = {
    /**
     * Response Start Process Process Mgt Deploy Process Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: unknown;
    };
};

export type StartProcessProcessMgtDeployProcessStartPostResponse = StartProcessProcessMgtDeployProcessStartPostResponses[keyof StartProcessProcessMgtDeployProcessStartPostResponses];

export type StartProcessProcessMgtUpdateProcessStartPostData = {
    body: BodyStartProcessProcessMgtUpdateProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/update_process/start';
};

export type StartProcessProcessMgtUpdateProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtUpdateProcessStartPostError = StartProcessProcessMgtUpdateProcessStartPostErrors[keyof StartProcessProcessMgtUpdateProcessStartPostErrors];

export type StartProcessProcessMgtUpdateProcessStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessMgtCreateProcessStartPostData = {
    body: BodyStartProcessProcessMgtCreateProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_mgt/create_process/start';
};

export type StartProcessProcessMgtCreateProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessMgtCreateProcessStartPostError = StartProcessProcessMgtCreateProcessStartPostErrors[keyof StartProcessProcessMgtCreateProcessStartPostErrors];

export type StartProcessProcessMgtCreateProcessStartPostResponses = {
    /**
     * Successful Response
     */
    200: Process;
};

export type StartProcessProcessMgtCreateProcessStartPostResponse = StartProcessProcessMgtCreateProcessStartPostResponses[keyof StartProcessProcessMgtCreateProcessStartPostResponses];

export type StartProcessProcessElementMgtDeleteGatewayStartPostData = {
    body: BodyStartProcessProcessElementMgtDeleteGatewayStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/delete_gateway/start';
};

export type StartProcessProcessElementMgtDeleteGatewayStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtDeleteGatewayStartPostError = StartProcessProcessElementMgtDeleteGatewayStartPostErrors[keyof StartProcessProcessElementMgtDeleteGatewayStartPostErrors];

export type StartProcessProcessElementMgtDeleteGatewayStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetFlowStartPostData = {
    body: BodyStartProcessProcessElementMgtGetFlowStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_flow/start';
};

export type StartProcessProcessElementMgtGetFlowStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetFlowStartPostError = StartProcessProcessElementMgtGetFlowStartPostErrors[keyof StartProcessProcessElementMgtGetFlowStartPostErrors];

export type StartProcessProcessElementMgtGetFlowStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessFlow;
};

export type StartProcessProcessElementMgtGetFlowStartPostResponse = StartProcessProcessElementMgtGetFlowStartPostResponses[keyof StartProcessProcessElementMgtGetFlowStartPostResponses];

export type StartProcessProcessElementMgtUpdateEventStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateEventStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_event/start';
};

export type StartProcessProcessElementMgtUpdateEventStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateEventStartPostError = StartProcessProcessElementMgtUpdateEventStartPostErrors[keyof StartProcessProcessElementMgtUpdateEventStartPostErrors];

export type StartProcessProcessElementMgtUpdateEventStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtUpdateTaskEvidenceStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateTaskEvidenceStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_task_evidence/start';
};

export type StartProcessProcessElementMgtUpdateTaskEvidenceStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateTaskEvidenceStartPostError = StartProcessProcessElementMgtUpdateTaskEvidenceStartPostErrors[keyof StartProcessProcessElementMgtUpdateTaskEvidenceStartPostErrors];

export type StartProcessProcessElementMgtUpdateTaskEvidenceStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetEventStartPostData = {
    body: BodyStartProcessProcessElementMgtGetEventStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_event/start';
};

export type StartProcessProcessElementMgtGetEventStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetEventStartPostError = StartProcessProcessElementMgtGetEventStartPostErrors[keyof StartProcessProcessElementMgtGetEventStartPostErrors];

export type StartProcessProcessElementMgtGetEventStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessEvent;
};

export type StartProcessProcessElementMgtGetEventStartPostResponse = StartProcessProcessElementMgtGetEventStartPostResponses[keyof StartProcessProcessElementMgtGetEventStartPostResponses];

export type StartProcessProcessElementMgtGenerateUserInterfaceStartPostData = {
    body: BodyStartProcessProcessElementMgtGenerateUserInterfaceStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/generate_user_interface/start';
};

export type StartProcessProcessElementMgtGenerateUserInterfaceStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGenerateUserInterfaceStartPostError = StartProcessProcessElementMgtGenerateUserInterfaceStartPostErrors[keyof StartProcessProcessElementMgtGenerateUserInterfaceStartPostErrors];

export type StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses = {
    /**
     *
     * Limited stream of SSE messages. Sends `event: open` and `event: close` when opening/closing the stream.
     * Sends a JSON object with chunks of the content.
     *
     */
    200: string;
};

export type StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponse = StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses[keyof StartProcessProcessElementMgtGenerateUserInterfaceStartPostResponses];

export type StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_process_element_entity_refs/start';
};

export type StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostError = StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostErrors[keyof StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostErrors];

export type StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessElement;
};

export type StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponse = StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponses[keyof StartProcessProcessElementMgtUpdateProcessElementEntityRefsStartPostResponses];

export type StartProcessProcessElementMgtUpdateGatewayStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateGatewayStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_gateway/start';
};

export type StartProcessProcessElementMgtUpdateGatewayStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateGatewayStartPostError = StartProcessProcessElementMgtUpdateGatewayStartPostErrors[keyof StartProcessProcessElementMgtUpdateGatewayStartPostErrors];

export type StartProcessProcessElementMgtUpdateGatewayStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetTaskStartPostData = {
    body: BodyStartProcessProcessElementMgtGetTaskStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_task/start';
};

export type StartProcessProcessElementMgtGetTaskStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetTaskStartPostError = StartProcessProcessElementMgtGetTaskStartPostErrors[keyof StartProcessProcessElementMgtGetTaskStartPostErrors];

export type StartProcessProcessElementMgtGetTaskStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessTask;
};

export type StartProcessProcessElementMgtGetTaskStartPostResponse = StartProcessProcessElementMgtGetTaskStartPostResponses[keyof StartProcessProcessElementMgtGetTaskStartPostResponses];

export type StartProcessProcessElementMgtGetProcessElementsByEntityStartPostData = {
    body: BodyStartProcessProcessElementMgtGetProcessElementsByEntityStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_process_elements_by_entity/start';
};

export type StartProcessProcessElementMgtGetProcessElementsByEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetProcessElementsByEntityStartPostError = StartProcessProcessElementMgtGetProcessElementsByEntityStartPostErrors[keyof StartProcessProcessElementMgtGetProcessElementsByEntityStartPostErrors];

export type StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponses = {
    /**
     * Response Start Process Process Element Mgt Get Process Elements By Entity Start Post
     *
     * Successful Response
     */
    200: Array<EntityTaskRef>;
};

export type StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponse = StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponses[keyof StartProcessProcessElementMgtGetProcessElementsByEntityStartPostResponses];

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData = {
    body: BodyStartProcessProcessElementMgtGetProcessElementByBpmnIdStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_process_element_by_bpmn_id/start';
};

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostError = StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors[keyof StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostErrors];

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessElement;
};

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponse = StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses[keyof StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponses];

export type StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostData = {
    body: BodyStartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_process_elements_grouped_by_process/start';
};

export type StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostError = StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostErrors[keyof StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostErrors];

export type StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostResponses = {
    /**
     * Response Start Process Process Element Mgt Get Process Elements Grouped By Process Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<ProcessTask | ProcessGateway | ProcessEvent | ProcessFlow>;
    };
};

export type StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostResponse = StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostResponses[keyof StartProcessProcessElementMgtGetProcessElementsGroupedByProcessStartPostResponses];

export type StartProcessProcessElementMgtDeleteFlowStartPostData = {
    body: BodyStartProcessProcessElementMgtDeleteFlowStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/delete_flow/start';
};

export type StartProcessProcessElementMgtDeleteFlowStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtDeleteFlowStartPostError = StartProcessProcessElementMgtDeleteFlowStartPostErrors[keyof StartProcessProcessElementMgtDeleteFlowStartPostErrors];

export type StartProcessProcessElementMgtDeleteFlowStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtUpdateFlowStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateFlowStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_flow/start';
};

export type StartProcessProcessElementMgtUpdateFlowStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateFlowStartPostError = StartProcessProcessElementMgtUpdateFlowStartPostErrors[keyof StartProcessProcessElementMgtUpdateFlowStartPostErrors];

export type StartProcessProcessElementMgtUpdateFlowStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData = {
    body: BodyStartProcessProcessElementMgtGetProcessElementsByProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_process_elements_by_process/start';
};

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostError = StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors[keyof StartProcessProcessElementMgtGetProcessElementsByProcessStartPostErrors];

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses = {
    /**
     * Response Start Process Process Element Mgt Get Process Elements By Process Start Post
     *
     * Successful Response
     */
    200: Array<ProcessTask | ProcessGateway | ProcessEvent | ProcessFlow>;
};

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponse = StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses[keyof StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponses];

export type StartProcessProcessElementMgtArchiveProcessElementStartPostData = {
    body: BodyStartProcessProcessElementMgtArchiveProcessElementStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/archive_process_element/start';
};

export type StartProcessProcessElementMgtArchiveProcessElementStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtArchiveProcessElementStartPostError = StartProcessProcessElementMgtArchiveProcessElementStartPostErrors[keyof StartProcessProcessElementMgtArchiveProcessElementStartPostErrors];

export type StartProcessProcessElementMgtArchiveProcessElementStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostData = {
    body: BodyStartProcessProcessElementMgtUnarchiveProcessElementStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/unarchive_process_element/start';
};

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostError = StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors[keyof StartProcessProcessElementMgtUnarchiveProcessElementStartPostErrors];

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetGatewayStartPostData = {
    body: BodyStartProcessProcessElementMgtGetGatewayStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_gateway/start';
};

export type StartProcessProcessElementMgtGetGatewayStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetGatewayStartPostError = StartProcessProcessElementMgtGetGatewayStartPostErrors[keyof StartProcessProcessElementMgtGetGatewayStartPostErrors];

export type StartProcessProcessElementMgtGetGatewayStartPostResponses = {
    /**
     * Successful Response
     */
    200: ProcessGateway;
};

export type StartProcessProcessElementMgtGetGatewayStartPostResponse = StartProcessProcessElementMgtGetGatewayStartPostResponses[keyof StartProcessProcessElementMgtGetGatewayStartPostResponses];

export type StartProcessProcessElementMgtDeleteEventStartPostData = {
    body: BodyStartProcessProcessElementMgtDeleteEventStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/delete_event/start';
};

export type StartProcessProcessElementMgtDeleteEventStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtDeleteEventStartPostError = StartProcessProcessElementMgtDeleteEventStartPostErrors[keyof StartProcessProcessElementMgtDeleteEventStartPostErrors];

export type StartProcessProcessElementMgtDeleteEventStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtDeleteTaskStartPostData = {
    body: BodyStartProcessProcessElementMgtDeleteTaskStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/delete_task/start';
};

export type StartProcessProcessElementMgtDeleteTaskStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtDeleteTaskStartPostError = StartProcessProcessElementMgtDeleteTaskStartPostErrors[keyof StartProcessProcessElementMgtDeleteTaskStartPostErrors];

export type StartProcessProcessElementMgtDeleteTaskStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtUpdateTaskStartPostData = {
    body: BodyStartProcessProcessElementMgtUpdateTaskStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/update_task/start';
};

export type StartProcessProcessElementMgtUpdateTaskStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtUpdateTaskStartPostError = StartProcessProcessElementMgtUpdateTaskStartPostErrors[keyof StartProcessProcessElementMgtUpdateTaskStartPostErrors];

export type StartProcessProcessElementMgtUpdateTaskStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartProcessProcessElementMgtGetProcessTasksByStekStartPostData = {
    body?: BodyStartProcessProcessElementMgtGetProcessTasksByStekStartPost;
    path?: never;
    query?: never;
    url: '/process/process_element_mgt/get_process_tasks_by_stek/start';
};

export type StartProcessProcessElementMgtGetProcessTasksByStekStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessProcessElementMgtGetProcessTasksByStekStartPostError = StartProcessProcessElementMgtGetProcessTasksByStekStartPostErrors[keyof StartProcessProcessElementMgtGetProcessTasksByStekStartPostErrors];

export type StartProcessProcessElementMgtGetProcessTasksByStekStartPostResponses = {
    /**
     * Response Start Process Process Element Mgt Get Process Tasks By Stek Start Post
     *
     * Successful Response
     */
    200: Array<ProcessTask>;
};

export type StartProcessProcessElementMgtGetProcessTasksByStekStartPostResponse = StartProcessProcessElementMgtGetProcessTasksByStekStartPostResponses[keyof StartProcessProcessElementMgtGetProcessTasksByStekStartPostResponses];

export type StartProcessLaneMgtGetLaneByRoleIdStartPostData = {
    body: BodyStartProcessLaneMgtGetLaneByRoleIdStartPost;
    path?: never;
    query?: never;
    url: '/process/lane_mgt/get_lane_by_role_id/start';
};

export type StartProcessLaneMgtGetLaneByRoleIdStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessLaneMgtGetLaneByRoleIdStartPostError = StartProcessLaneMgtGetLaneByRoleIdStartPostErrors[keyof StartProcessLaneMgtGetLaneByRoleIdStartPostErrors];

export type StartProcessLaneMgtGetLaneByRoleIdStartPostResponses = {
    /**
     * Successful Response
     */
    200: Lane;
};

export type StartProcessLaneMgtGetLaneByRoleIdStartPostResponse = StartProcessLaneMgtGetLaneByRoleIdStartPostResponses[keyof StartProcessLaneMgtGetLaneByRoleIdStartPostResponses];

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostData = {
    body: BodyStartProcessLaneMgtGetLaneByBpmnIdStartPost;
    path?: never;
    query?: never;
    url: '/process/lane_mgt/get_lane_by_bpmn_id/start';
};

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostError = StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors[keyof StartProcessLaneMgtGetLaneByBpmnIdStartPostErrors];

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses = {
    /**
     * Successful Response
     */
    200: Lane;
};

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostResponse = StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses[keyof StartProcessLaneMgtGetLaneByBpmnIdStartPostResponses];

export type StartProcessLaneMgtGetLaneStartPostData = {
    body: BodyStartProcessLaneMgtGetLaneStartPost;
    path?: never;
    query?: never;
    url: '/process/lane_mgt/get_lane/start';
};

export type StartProcessLaneMgtGetLaneStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessLaneMgtGetLaneStartPostError = StartProcessLaneMgtGetLaneStartPostErrors[keyof StartProcessLaneMgtGetLaneStartPostErrors];

export type StartProcessLaneMgtGetLaneStartPostResponses = {
    /**
     * Successful Response
     */
    200: Lane;
};

export type StartProcessLaneMgtGetLaneStartPostResponse = StartProcessLaneMgtGetLaneStartPostResponses[keyof StartProcessLaneMgtGetLaneStartPostResponses];

export type StartProcessLaneMgtGetLanesByProcessStartPostData = {
    body: BodyStartProcessLaneMgtGetLanesByProcessStartPost;
    path?: never;
    query?: never;
    url: '/process/lane_mgt/get_lanes_by_process/start';
};

export type StartProcessLaneMgtGetLanesByProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartProcessLaneMgtGetLanesByProcessStartPostError = StartProcessLaneMgtGetLanesByProcessStartPostErrors[keyof StartProcessLaneMgtGetLanesByProcessStartPostErrors];

export type StartProcessLaneMgtGetLanesByProcessStartPostResponses = {
    /**
     * Response Start Process Lane Mgt Get Lanes By Process Start Post
     *
     * Successful Response
     */
    200: Array<Lane>;
};

export type StartProcessLaneMgtGetLanesByProcessStartPostResponse = StartProcessLaneMgtGetLanesByProcessStartPostResponses[keyof StartProcessLaneMgtGetLanesByProcessStartPostResponses];

export type StartThreadThreadMgtRespondToProposalStartPostData = {
    body: BodyStartThreadThreadMgtRespondToProposalStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/respond_to_proposal/start';
};

export type StartThreadThreadMgtRespondToProposalStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtRespondToProposalStartPostError = StartThreadThreadMgtRespondToProposalStartPostErrors[keyof StartThreadThreadMgtRespondToProposalStartPostErrors];

export type StartThreadThreadMgtRespondToProposalStartPostResponses = {
    /**
     * Response Start Thread Thread Mgt Respond To Proposal Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type StartThreadThreadMgtRespondToProposalStartPostResponse = StartThreadThreadMgtRespondToProposalStartPostResponses[keyof StartThreadThreadMgtRespondToProposalStartPostResponses];

export type StartThreadThreadMgtReadEntityVersionsStartPostData = {
    body: BodyStartThreadThreadMgtReadEntityVersionsStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/read_entity_versions/start';
};

export type StartThreadThreadMgtReadEntityVersionsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtReadEntityVersionsStartPostError = StartThreadThreadMgtReadEntityVersionsStartPostErrors[keyof StartThreadThreadMgtReadEntityVersionsStartPostErrors];

export type StartThreadThreadMgtReadEntityVersionsStartPostResponses = {
    /**
     * Successful Response
     */
    200: EntityVersionsSchema;
};

export type StartThreadThreadMgtReadEntityVersionsStartPostResponse = StartThreadThreadMgtReadEntityVersionsStartPostResponses[keyof StartThreadThreadMgtReadEntityVersionsStartPostResponses];

export type StartThreadThreadMgtListThreadsStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/list_threads/start';
};

export type StartThreadThreadMgtListThreadsStartPostResponses = {
    /**
     * Successful Response
     */
    200: ThreadListSchema;
};

export type StartThreadThreadMgtListThreadsStartPostResponse = StartThreadThreadMgtListThreadsStartPostResponses[keyof StartThreadThreadMgtListThreadsStartPostResponses];

export type StartThreadThreadMgtSetAutoApplyStartPostData = {
    body: BodyStartThreadThreadMgtSetAutoApplyStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/set_auto_apply/start';
};

export type StartThreadThreadMgtSetAutoApplyStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtSetAutoApplyStartPostError = StartThreadThreadMgtSetAutoApplyStartPostErrors[keyof StartThreadThreadMgtSetAutoApplyStartPostErrors];

export type StartThreadThreadMgtSetAutoApplyStartPostResponses = {
    /**
     * Successful Response
     */
    200: ThreadSchema;
};

export type StartThreadThreadMgtSetAutoApplyStartPostResponse = StartThreadThreadMgtSetAutoApplyStartPostResponses[keyof StartThreadThreadMgtSetAutoApplyStartPostResponses];

export type StartThreadThreadMgtUnresolveConflictStartPostData = {
    body: BodyStartThreadThreadMgtUnresolveConflictStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/unresolve_conflict/start';
};

export type StartThreadThreadMgtUnresolveConflictStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtUnresolveConflictStartPostError = StartThreadThreadMgtUnresolveConflictStartPostErrors[keyof StartThreadThreadMgtUnresolveConflictStartPostErrors];

export type StartThreadThreadMgtUnresolveConflictStartPostResponses = {
    /**
     * Successful Response
     */
    200: ConflictRecordSchema;
};

export type StartThreadThreadMgtUnresolveConflictStartPostResponse = StartThreadThreadMgtUnresolveConflictStartPostResponses[keyof StartThreadThreadMgtUnresolveConflictStartPostResponses];

export type StartThreadThreadMgtGetThreadFileStartPostData = {
    body: BodyStartThreadThreadMgtGetThreadFileStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/get_thread_file/start';
};

export type StartThreadThreadMgtGetThreadFileStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtGetThreadFileStartPostError = StartThreadThreadMgtGetThreadFileStartPostErrors[keyof StartThreadThreadMgtGetThreadFileStartPostErrors];

export type StartThreadThreadMgtGetThreadFileStartPostResponses = {
    /**
     * File stream.
     */
    200: unknown;
};

export type StartThreadThreadMgtResolveConflictStartPostData = {
    body: BodyStartThreadThreadMgtResolveConflictStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/resolve_conflict/start';
};

export type StartThreadThreadMgtResolveConflictStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtResolveConflictStartPostError = StartThreadThreadMgtResolveConflictStartPostErrors[keyof StartThreadThreadMgtResolveConflictStartPostErrors];

export type StartThreadThreadMgtResolveConflictStartPostResponses = {
    /**
     * Successful Response
     */
    200: ConflictRecordSchema;
};

export type StartThreadThreadMgtResolveConflictStartPostResponse = StartThreadThreadMgtResolveConflictStartPostResponses[keyof StartThreadThreadMgtResolveConflictStartPostResponses];

export type StartThreadThreadMgtGetThreadStartPostData = {
    body: BodyStartThreadThreadMgtGetThreadStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/get_thread/start';
};

export type StartThreadThreadMgtGetThreadStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtGetThreadStartPostError = StartThreadThreadMgtGetThreadStartPostErrors[keyof StartThreadThreadMgtGetThreadStartPostErrors];

export type StartThreadThreadMgtGetThreadStartPostResponses = {
    /**
     * Successful Response
     */
    200: ThreadWithEntriesSchema;
};

export type StartThreadThreadMgtGetThreadStartPostResponse = StartThreadThreadMgtGetThreadStartPostResponses[keyof StartThreadThreadMgtGetThreadStartPostResponses];

export type StartThreadThreadMgtCreateThreadStartPostData = {
    body: BodyStartThreadThreadMgtCreateThreadStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/create_thread/start';
};

export type StartThreadThreadMgtCreateThreadStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtCreateThreadStartPostError = StartThreadThreadMgtCreateThreadStartPostErrors[keyof StartThreadThreadMgtCreateThreadStartPostErrors];

export type StartThreadThreadMgtCreateThreadStartPostResponses = {
    /**
     * Successful Response
     */
    200: ThreadSchema;
};

export type StartThreadThreadMgtCreateThreadStartPostResponse = StartThreadThreadMgtCreateThreadStartPostResponses[keyof StartThreadThreadMgtCreateThreadStartPostResponses];

export type StartThreadThreadMgtResolveThreadStartPostData = {
    body: BodyStartThreadThreadMgtResolveThreadStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/resolve_thread/start';
};

export type StartThreadThreadMgtResolveThreadStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtResolveThreadStartPostError = StartThreadThreadMgtResolveThreadStartPostErrors[keyof StartThreadThreadMgtResolveThreadStartPostErrors];

export type StartThreadThreadMgtResolveThreadStartPostResponses = {
    /**
     * Successful Response
     */
    200: ThreadSchema;
};

export type StartThreadThreadMgtResolveThreadStartPostResponse = StartThreadThreadMgtResolveThreadStartPostResponses[keyof StartThreadThreadMgtResolveThreadStartPostResponses];

export type StartThreadThreadMgtContributeToThreadStartPostData = {
    body: BodyStartThreadThreadMgtContributeToThreadStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/contribute_to_thread/start';
};

export type StartThreadThreadMgtContributeToThreadStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtContributeToThreadStartPostError = StartThreadThreadMgtContributeToThreadStartPostErrors[keyof StartThreadThreadMgtContributeToThreadStartPostErrors];

export type StartThreadThreadMgtContributeToThreadStartPostResponses = {
    /**
     * Successful Response
     */
    200: ThreadEntrySchema;
};

export type StartThreadThreadMgtContributeToThreadStartPostResponse = StartThreadThreadMgtContributeToThreadStartPostResponses[keyof StartThreadThreadMgtContributeToThreadStartPostResponses];

export type StartThreadThreadMgtListThreadUserChangesStartPostData = {
    body: BodyStartThreadThreadMgtListThreadUserChangesStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/list_thread_user_changes/start';
};

export type StartThreadThreadMgtListThreadUserChangesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtListThreadUserChangesStartPostError = StartThreadThreadMgtListThreadUserChangesStartPostErrors[keyof StartThreadThreadMgtListThreadUserChangesStartPostErrors];

export type StartThreadThreadMgtListThreadUserChangesStartPostResponses = {
    /**
     * Response Start Thread Thread Mgt List Thread User Changes Start Post
     *
     * Successful Response
     */
    200: Array<UserChangeSchema>;
};

export type StartThreadThreadMgtListThreadUserChangesStartPostResponse = StartThreadThreadMgtListThreadUserChangesStartPostResponses[keyof StartThreadThreadMgtListThreadUserChangesStartPostResponses];

export type StartThreadThreadMgtDeleteThreadFileStartPostData = {
    body: BodyStartThreadThreadMgtDeleteThreadFileStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/delete_thread_file/start';
};

export type StartThreadThreadMgtDeleteThreadFileStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtDeleteThreadFileStartPostError = StartThreadThreadMgtDeleteThreadFileStartPostErrors[keyof StartThreadThreadMgtDeleteThreadFileStartPostErrors];

export type StartThreadThreadMgtDeleteThreadFileStartPostResponses = {
    /**
     * Response Start Thread Thread Mgt Delete Thread File Start Post
     *
     * Successful Response
     */
    200: string;
};

export type StartThreadThreadMgtDeleteThreadFileStartPostResponse = StartThreadThreadMgtDeleteThreadFileStartPostResponses[keyof StartThreadThreadMgtDeleteThreadFileStartPostResponses];

export type StartThreadThreadMgtCatchUpStartPostData = {
    body: BodyStartThreadThreadMgtCatchUpStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/catch_up/start';
};

export type StartThreadThreadMgtCatchUpStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtCatchUpStartPostError = StartThreadThreadMgtCatchUpStartPostErrors[keyof StartThreadThreadMgtCatchUpStartPostErrors];

export type StartThreadThreadMgtCatchUpStartPostResponses = {
    /**
     * Successful Response
     */
    200: CatchUpResultSchema;
};

export type StartThreadThreadMgtCatchUpStartPostResponse = StartThreadThreadMgtCatchUpStartPostResponses[keyof StartThreadThreadMgtCatchUpStartPostResponses];

export type StartThreadThreadMgtGenerateAcceptMessageStartPostData = {
    body: BodyStartThreadThreadMgtGenerateAcceptMessageStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/generate_accept_message/start';
};

export type StartThreadThreadMgtGenerateAcceptMessageStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtGenerateAcceptMessageStartPostError = StartThreadThreadMgtGenerateAcceptMessageStartPostErrors[keyof StartThreadThreadMgtGenerateAcceptMessageStartPostErrors];

export type StartThreadThreadMgtGenerateAcceptMessageStartPostResponses = {
    /**
     * Successful Response
     */
    200: GeneratedAcceptMessageSchema;
};

export type StartThreadThreadMgtGenerateAcceptMessageStartPostResponse = StartThreadThreadMgtGenerateAcceptMessageStartPostResponses[keyof StartThreadThreadMgtGenerateAcceptMessageStartPostResponses];

export type StartThreadThreadMgtUploadThreadFileStartPostData = {
    body: BodyStartThreadThreadMgtUploadThreadFileStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/upload_thread_file/start';
};

export type StartThreadThreadMgtUploadThreadFileStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtUploadThreadFileStartPostError = StartThreadThreadMgtUploadThreadFileStartPostErrors[keyof StartThreadThreadMgtUploadThreadFileStartPostErrors];

export type StartThreadThreadMgtUploadThreadFileStartPostResponses = {
    /**
     * Successful Response
     */
    200: ThreadContextItem;
};

export type StartThreadThreadMgtUploadThreadFileStartPostResponse = StartThreadThreadMgtUploadThreadFileStartPostResponses[keyof StartThreadThreadMgtUploadThreadFileStartPostResponses];

export type StartThreadThreadMgtResolveSafeConflictsStartPostData = {
    body: BodyStartThreadThreadMgtResolveSafeConflictsStartPost;
    path?: never;
    query?: never;
    url: '/thread/thread_mgt/resolve_safe_conflicts/start';
};

export type StartThreadThreadMgtResolveSafeConflictsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartThreadThreadMgtResolveSafeConflictsStartPostError = StartThreadThreadMgtResolveSafeConflictsStartPostErrors[keyof StartThreadThreadMgtResolveSafeConflictsStartPostErrors];

export type StartThreadThreadMgtResolveSafeConflictsStartPostResponses = {
    /**
     * Response Start Thread Thread Mgt Resolve Safe Conflicts Start Post
     *
     * Successful Response
     */
    200: Array<ConflictRecordSchema>;
};

export type StartThreadThreadMgtResolveSafeConflictsStartPostResponse = StartThreadThreadMgtResolveSafeConflictsStartPostResponses[keyof StartThreadThreadMgtResolveSafeConflictsStartPostResponses];

export type NotifyTypingThreadTypingThreadIdPostData = {
    body?: never;
    path: {
        /**
         * Thread Id
         */
        thread_id: string;
    };
    query?: never;
    url: '/thread/typing/{thread_id}';
};

export type NotifyTypingThreadTypingThreadIdPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type NotifyTypingThreadTypingThreadIdPostError = NotifyTypingThreadTypingThreadIdPostErrors[keyof NotifyTypingThreadTypingThreadIdPostErrors];

export type NotifyTypingThreadTypingThreadIdPostResponses = {
    /**
     * Response Notify Typing Thread Typing  Thread Id  Post
     *
     * Successful Response
     */
    200: {
        [key: string]: string;
    };
};

export type NotifyTypingThreadTypingThreadIdPostResponse = NotifyTypingThreadTypingThreadIdPostResponses[keyof NotifyTypingThreadTypingThreadIdPostResponses];

export type ThreadEventsThreadEventsThreadIdGetData = {
    body?: never;
    path: {
        /**
         * Thread Id
         */
        thread_id: string;
    };
    query?: never;
    url: '/thread/events/{thread_id}';
};

export type ThreadEventsThreadEventsThreadIdGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ThreadEventsThreadEventsThreadIdGetError = ThreadEventsThreadEventsThreadIdGetErrors[keyof ThreadEventsThreadEventsThreadIdGetErrors];

export type ThreadEventsThreadEventsThreadIdGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartOrganizationActivityMetricsGetOrganizationActivityStartGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Since Days
         *
         * Lookback period in days
         */
        since_days?: number;
        /**
         * Include User Details
         *
         * Include per-user breakdown
         */
        include_user_details?: boolean;
    };
    url: '/organization/activity_metrics/get_organization_activity/start';
};

export type StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationActivityMetricsGetOrganizationActivityStartGetError = StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors[keyof StartOrganizationActivityMetricsGetOrganizationActivityStartGetErrors];

export type StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses = {
    /**
     * Successful Response
     */
    200: OrganizationActivityReportResponse;
};

export type StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponse = StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses[keyof StartOrganizationActivityMetricsGetOrganizationActivityStartGetResponses];

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Name
         */
        name: string;
    };
    url: '/organization/organization_mgt/get_organization_by_name/start';
};

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostError = StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors[keyof StartOrganizationOrganizationMgtGetOrganizationByNameStartPostErrors];

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses = {
    /**
     * Successful Response
     */
    200: Organization;
};

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponse = StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses[keyof StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponses];

export type StartOrganizationOrganizationMgtGetOrganizationsStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/organization/organization_mgt/get_organizations/start';
};

export type StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses = {
    /**
     * Response Start Organization Organization Mgt Get Organizations Start Post
     *
     * Successful Response
     */
    200: Array<Organization>;
};

export type StartOrganizationOrganizationMgtGetOrganizationsStartPostResponse = StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses[keyof StartOrganizationOrganizationMgtGetOrganizationsStartPostResponses];

export type StartOrganizationAgentMgtListMcpConsumersStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/organization/agent_mgt/list_mcp_consumers/start';
};

export type StartOrganizationAgentMgtListMcpConsumersStartPostResponses = {
    /**
     * Response Start Organization Agent Mgt List Mcp Consumers Start Post
     *
     * Successful Response
     */
    200: Array<McpConsumer>;
};

export type StartOrganizationAgentMgtListMcpConsumersStartPostResponse = StartOrganizationAgentMgtListMcpConsumersStartPostResponses[keyof StartOrganizationAgentMgtListMcpConsumersStartPostResponses];

export type StartOrganizationAgentMgtCreateAgentStartPostData = {
    body: CreateAgentRequest;
    path?: never;
    query?: never;
    url: '/organization/agent_mgt/create_agent/start';
};

export type StartOrganizationAgentMgtCreateAgentStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationAgentMgtCreateAgentStartPostError = StartOrganizationAgentMgtCreateAgentStartPostErrors[keyof StartOrganizationAgentMgtCreateAgentStartPostErrors];

export type StartOrganizationAgentMgtCreateAgentStartPostResponses = {
    /**
     * Successful Response
     */
    200: Agent;
};

export type StartOrganizationAgentMgtCreateAgentStartPostResponse = StartOrganizationAgentMgtCreateAgentStartPostResponses[keyof StartOrganizationAgentMgtCreateAgentStartPostResponses];

export type StartOrganizationAgentMgtDeleteAgentStartPostData = {
    body: AgentRef;
    path?: never;
    query?: never;
    url: '/organization/agent_mgt/delete_agent/start';
};

export type StartOrganizationAgentMgtDeleteAgentStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationAgentMgtDeleteAgentStartPostError = StartOrganizationAgentMgtDeleteAgentStartPostErrors[keyof StartOrganizationAgentMgtDeleteAgentStartPostErrors];

export type StartOrganizationAgentMgtDeleteAgentStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartOrganizationAgentMgtCreateAgentTokenStartPostData = {
    body: CreateAgentTokenRequest;
    path?: never;
    query?: never;
    url: '/organization/agent_mgt/create_agent_token/start';
};

export type StartOrganizationAgentMgtCreateAgentTokenStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationAgentMgtCreateAgentTokenStartPostError = StartOrganizationAgentMgtCreateAgentTokenStartPostErrors[keyof StartOrganizationAgentMgtCreateAgentTokenStartPostErrors];

export type StartOrganizationAgentMgtCreateAgentTokenStartPostResponses = {
    /**
     * Successful Response
     */
    200: AgentTokenCreated;
};

export type StartOrganizationAgentMgtCreateAgentTokenStartPostResponse = StartOrganizationAgentMgtCreateAgentTokenStartPostResponses[keyof StartOrganizationAgentMgtCreateAgentTokenStartPostResponses];

export type StartOrganizationAgentMgtListAgentTokensStartPostData = {
    body: ListAgentTokensRequest;
    path?: never;
    query?: never;
    url: '/organization/agent_mgt/list_agent_tokens/start';
};

export type StartOrganizationAgentMgtListAgentTokensStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationAgentMgtListAgentTokensStartPostError = StartOrganizationAgentMgtListAgentTokensStartPostErrors[keyof StartOrganizationAgentMgtListAgentTokensStartPostErrors];

export type StartOrganizationAgentMgtListAgentTokensStartPostResponses = {
    /**
     * Response Start Organization Agent Mgt List Agent Tokens Start Post
     *
     * Successful Response
     */
    200: Array<AgentToken>;
};

export type StartOrganizationAgentMgtListAgentTokensStartPostResponse = StartOrganizationAgentMgtListAgentTokensStartPostResponses[keyof StartOrganizationAgentMgtListAgentTokensStartPostResponses];

export type StartOrganizationAgentMgtRevokeMcpConsumerStartPostData = {
    body: ConsumerRef;
    path?: never;
    query?: never;
    url: '/organization/agent_mgt/revoke_mcp_consumer/start';
};

export type StartOrganizationAgentMgtRevokeMcpConsumerStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationAgentMgtRevokeMcpConsumerStartPostError = StartOrganizationAgentMgtRevokeMcpConsumerStartPostErrors[keyof StartOrganizationAgentMgtRevokeMcpConsumerStartPostErrors];

export type StartOrganizationAgentMgtRevokeMcpConsumerStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartOrganizationAgentMgtRegrantAgentTokenStartPostData = {
    body: RegrantAgentTokenRequest;
    path?: never;
    query?: never;
    url: '/organization/agent_mgt/regrant_agent_token/start';
};

export type StartOrganizationAgentMgtRegrantAgentTokenStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationAgentMgtRegrantAgentTokenStartPostError = StartOrganizationAgentMgtRegrantAgentTokenStartPostErrors[keyof StartOrganizationAgentMgtRegrantAgentTokenStartPostErrors];

export type StartOrganizationAgentMgtRegrantAgentTokenStartPostResponses = {
    /**
     * Successful Response
     */
    200: AgentTokenCreated;
};

export type StartOrganizationAgentMgtRegrantAgentTokenStartPostResponse = StartOrganizationAgentMgtRegrantAgentTokenStartPostResponses[keyof StartOrganizationAgentMgtRegrantAgentTokenStartPostResponses];

export type StartOrganizationAgentMgtListAgentsStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/organization/agent_mgt/list_agents/start';
};

export type StartOrganizationAgentMgtListAgentsStartPostResponses = {
    /**
     * Response Start Organization Agent Mgt List Agents Start Post
     *
     * Successful Response
     */
    200: Array<Agent>;
};

export type StartOrganizationAgentMgtListAgentsStartPostResponse = StartOrganizationAgentMgtListAgentsStartPostResponses[keyof StartOrganizationAgentMgtListAgentsStartPostResponses];

export type StartOrganizationAgentMgtUpdateAgentStartPostData = {
    body: UpdateAgentRequest;
    path?: never;
    query?: never;
    url: '/organization/agent_mgt/update_agent/start';
};

export type StartOrganizationAgentMgtUpdateAgentStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationAgentMgtUpdateAgentStartPostError = StartOrganizationAgentMgtUpdateAgentStartPostErrors[keyof StartOrganizationAgentMgtUpdateAgentStartPostErrors];

export type StartOrganizationAgentMgtUpdateAgentStartPostResponses = {
    /**
     * Successful Response
     */
    200: Agent;
};

export type StartOrganizationAgentMgtUpdateAgentStartPostResponse = StartOrganizationAgentMgtUpdateAgentStartPostResponses[keyof StartOrganizationAgentMgtUpdateAgentStartPostResponses];

export type StartOrganizationAgentMgtRevokeAgentTokenStartPostData = {
    body: TokenRef;
    path?: never;
    query?: never;
    url: '/organization/agent_mgt/revoke_agent_token/start';
};

export type StartOrganizationAgentMgtRevokeAgentTokenStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartOrganizationAgentMgtRevokeAgentTokenStartPostError = StartOrganizationAgentMgtRevokeAgentTokenStartPostErrors[keyof StartOrganizationAgentMgtRevokeAgentTokenStartPostErrors];

export type StartOrganizationAgentMgtRevokeAgentTokenStartPostResponses = {
    /**
     * Successful Response
     */
    200: AgentToken;
};

export type StartOrganizationAgentMgtRevokeAgentTokenStartPostResponse = StartOrganizationAgentMgtRevokeAgentTokenStartPostResponses[keyof StartOrganizationAgentMgtRevokeAgentTokenStartPostResponses];

export type DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteData = {
    body?: never;
    path: {
        integration_type: IntegrationType;
    };
    query?: never;
    url: '/stek/integration_mgt/integration/settings/{integration_type}';
};

export type DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteError = DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors[keyof DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteErrors];

export type DeleteIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeDeleteResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetData = {
    body?: never;
    path: {
        integration_type: IntegrationType;
    };
    query?: never;
    url: '/stek/integration_mgt/integration/settings/{integration_type}';
};

export type GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetError = GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors[keyof GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetErrors];

export type GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses = {
    /**
     * Successful Response
     */
    200: Integration;
};

export type GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponse = GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses[keyof GetIntegrationSettingsStekIntegrationMgtIntegrationSettingsIntegrationTypeGetResponses];

export type CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostData = {
    body: BodyCreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePost;
    path: {
        integration_type: IntegrationType;
    };
    query?: never;
    url: '/stek/integration_mgt/integration/settings/{integration_type}';
};

export type CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostError = CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors[keyof CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostErrors];

export type CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses = {
    /**
     * Successful Response
     */
    200: Integration;
};

export type CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponse = CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses[keyof CreateApiIntegrationStekIntegrationMgtIntegrationSettingsIntegrationTypePostResponses];

export type TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostData = {
    body: BodyTestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePost;
    path: {
        integration_type: IntegrationType;
    };
    query?: never;
    url: '/stek/integration_mgt/integration/test/{integration_type}';
};

export type TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostError = TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors[keyof TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostErrors];

export type TestIntegrationConnectionStekIntegrationMgtIntegrationTestIntegrationTypePostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekReleaseMgtGetReleaseDiffStartPostData = {
    body: GetReleaseDiffRequest;
    path?: never;
    query?: never;
    url: '/stek/stek_release_mgt/get_release_diff/start';
};

export type StartStekStekReleaseMgtGetReleaseDiffStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekReleaseMgtGetReleaseDiffStartPostError = StartStekStekReleaseMgtGetReleaseDiffStartPostErrors[keyof StartStekStekReleaseMgtGetReleaseDiffStartPostErrors];

export type StartStekStekReleaseMgtGetReleaseDiffStartPostResponses = {
    /**
     * Successful Response
     */
    200: ReleaseDiffResponse;
};

export type StartStekStekReleaseMgtGetReleaseDiffStartPostResponse = StartStekStekReleaseMgtGetReleaseDiffStartPostResponses[keyof StartStekStekReleaseMgtGetReleaseDiffStartPostResponses];

export type StartStekStekReleaseMgtGetReleaseStartPostData = {
    body: BodyStartStekStekReleaseMgtGetReleaseStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_release_mgt/get_release/start';
};

export type StartStekStekReleaseMgtGetReleaseStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekReleaseMgtGetReleaseStartPostError = StartStekStekReleaseMgtGetReleaseStartPostErrors[keyof StartStekStekReleaseMgtGetReleaseStartPostErrors];

export type StartStekStekReleaseMgtGetReleaseStartPostResponses = {
    /**
     * Successful Response
     */
    200: StekReleaseResponse;
};

export type StartStekStekReleaseMgtGetReleaseStartPostResponse = StartStekStekReleaseMgtGetReleaseStartPostResponses[keyof StartStekStekReleaseMgtGetReleaseStartPostResponses];

export type StartStekStekReleaseMgtListReleasesStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_release_mgt/list_releases/start';
};

export type StartStekStekReleaseMgtListReleasesStartPostResponses = {
    /**
     * Response Start Stek Stek Release Mgt List Releases Start Post
     *
     * Successful Response
     */
    200: Array<StekReleaseResponse>;
};

export type StartStekStekReleaseMgtListReleasesStartPostResponse = StartStekStekReleaseMgtListReleasesStartPostResponses[keyof StartStekStekReleaseMgtListReleasesStartPostResponses];

export type StartStekStekReleaseMgtCreateReleaseStartPostData = {
    body: CreateReleaseRequest;
    path?: never;
    query?: never;
    url: '/stek/stek_release_mgt/create_release/start';
};

export type StartStekStekReleaseMgtCreateReleaseStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekReleaseMgtCreateReleaseStartPostError = StartStekStekReleaseMgtCreateReleaseStartPostErrors[keyof StartStekStekReleaseMgtCreateReleaseStartPostErrors];

export type StartStekStekReleaseMgtCreateReleaseStartPostResponses = {
    /**
     * Successful Response
     */
    200: StekReleaseResponse;
};

export type StartStekStekReleaseMgtCreateReleaseStartPostResponse = StartStekStekReleaseMgtCreateReleaseStartPostResponses[keyof StartStekStekReleaseMgtCreateReleaseStartPostResponses];

export type StartStekLiveMgtGetReleasesStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/get_releases/start';
};

export type StartStekLiveMgtGetReleasesStartPostResponses = {
    /**
     * Response Start Stek Live Mgt Get Releases Start Post
     *
     * Successful Response
     */
    200: Array<string>;
};

export type StartStekLiveMgtGetReleasesStartPostResponse = StartStekLiveMgtGetReleasesStartPostResponses[keyof StartStekLiveMgtGetReleasesStartPostResponses];

export type StartStekLiveMgtGetProcessInstancesStartPostData = {
    body: BodyStartStekLiveMgtGetProcessInstancesStartPost;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/get_process_instances/start';
};

export type StartStekLiveMgtGetProcessInstancesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtGetProcessInstancesStartPostError = StartStekLiveMgtGetProcessInstancesStartPostErrors[keyof StartStekLiveMgtGetProcessInstancesStartPostErrors];

export type StartStekLiveMgtGetProcessInstancesStartPostResponses = {
    /**
     * Successful Response
     */
    200: PageProcessInstanceMetrics;
};

export type StartStekLiveMgtGetProcessInstancesStartPostResponse = StartStekLiveMgtGetProcessInstancesStartPostResponses[keyof StartStekLiveMgtGetProcessInstancesStartPostResponses];

export type StartStekLiveMgtIngestEventStartPostData = {
    body: BodyStartStekLiveMgtIngestEventStartPost;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/ingest_event/start';
};

export type StartStekLiveMgtIngestEventStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtIngestEventStartPostError = StartStekLiveMgtIngestEventStartPostErrors[keyof StartStekLiveMgtIngestEventStartPostErrors];

export type StartStekLiveMgtIngestEventStartPostResponses = {
    /**
     * Successful Response
     */
    200: StekEvent;
};

export type StartStekLiveMgtIngestEventStartPostResponse = StartStekLiveMgtIngestEventStartPostResponses[keyof StartStekLiveMgtIngestEventStartPostResponses];

export type StartStekLiveMgtGetElementMetricsStartPostData = {
    body: BodyStartStekLiveMgtGetElementMetricsStartPost;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/get_element_metrics/start';
};

export type StartStekLiveMgtGetElementMetricsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtGetElementMetricsStartPostError = StartStekLiveMgtGetElementMetricsStartPostErrors[keyof StartStekLiveMgtGetElementMetricsStartPostErrors];

export type StartStekLiveMgtGetElementMetricsStartPostResponses = {
    /**
     * Response Start Stek Live Mgt Get Element Metrics Start Post
     *
     * Successful Response
     */
    200: Array<ProcessElementMetrics>;
};

export type StartStekLiveMgtGetElementMetricsStartPostResponse = StartStekLiveMgtGetElementMetricsStartPostResponses[keyof StartStekLiveMgtGetElementMetricsStartPostResponses];

export type StartStekLiveMgtGetMetricsStartPostData = {
    body?: BodyStartStekLiveMgtGetMetricsStartPost;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/get_metrics/start';
};

export type StartStekLiveMgtGetMetricsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtGetMetricsStartPostError = StartStekLiveMgtGetMetricsStartPostErrors[keyof StartStekLiveMgtGetMetricsStartPostErrors];

export type StartStekLiveMgtGetMetricsStartPostResponses = {
    /**
     * Successful Response
     */
    200: LiveMetrics;
};

export type StartStekLiveMgtGetMetricsStartPostResponse = StartStekLiveMgtGetMetricsStartPostResponses[keyof StartStekLiveMgtGetMetricsStartPostResponses];

export type StartStekLiveMgtGetComplianceEvidenceStartPostData = {
    body: BodyStartStekLiveMgtGetComplianceEvidenceStartPost;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/get_compliance_evidence/start';
};

export type StartStekLiveMgtGetComplianceEvidenceStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtGetComplianceEvidenceStartPostError = StartStekLiveMgtGetComplianceEvidenceStartPostErrors[keyof StartStekLiveMgtGetComplianceEvidenceStartPostErrors];

export type StartStekLiveMgtGetComplianceEvidenceStartPostResponses = {
    /**
     * Response Start Stek Live Mgt Get Compliance Evidence Start Post
     *
     * Successful Response
     */
    200: Array<ComplianceEvidenceView>;
};

export type StartStekLiveMgtGetComplianceEvidenceStartPostResponse = StartStekLiveMgtGetComplianceEvidenceStartPostResponses[keyof StartStekLiveMgtGetComplianceEvidenceStartPostResponses];

export type StartStekLiveMgtStreamActivityStartGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Stek Id
         */
        stek_id?: string | null;
        /**
         * Domain Id
         */
        domain_id?: string | null;
        /**
         * Product Id
         */
        product_id?: string | null;
        /**
         * Process Id
         */
        process_id?: string | null;
        /**
         * Process Instance Id
         */
        process_instance_id?: string | null;
        /**
         * Stek Release
         */
        stek_release?: string | null;
    };
    url: '/stek/live_mgt/stream_activity/start';
};

export type StartStekLiveMgtStreamActivityStartGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtStreamActivityStartGetError = StartStekLiveMgtStreamActivityStartGetErrors[keyof StartStekLiveMgtStreamActivityStartGetErrors];

export type StartStekLiveMgtStreamActivityStartGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekLiveMgtGetRecentActivityStartPostData = {
    body?: BodyStartStekLiveMgtGetRecentActivityStartPost;
    path?: never;
    query?: never;
    url: '/stek/live_mgt/get_recent_activity/start';
};

export type StartStekLiveMgtGetRecentActivityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekLiveMgtGetRecentActivityStartPostError = StartStekLiveMgtGetRecentActivityStartPostErrors[keyof StartStekLiveMgtGetRecentActivityStartPostErrors];

export type StartStekLiveMgtGetRecentActivityStartPostResponses = {
    /**
     * Successful Response
     */
    200: PageStekEvent;
};

export type StartStekLiveMgtGetRecentActivityStartPostResponse = StartStekLiveMgtGetRecentActivityStartPostResponses[keyof StartStekLiveMgtGetRecentActivityStartPostResponses];

export type StartStekStekMgtManageStekStartPostData = {
    body: BodyStartStekStekMgtManageStekStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/manage_stek/start';
};

export type StartStekStekMgtManageStekStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtManageStekStartPostError = StartStekStekMgtManageStekStartPostErrors[keyof StartStekStekMgtManageStekStartPostErrors];

export type StartStekStekMgtManageStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtGetStekStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/get_stek/start';
};

export type StartStekStekMgtGetStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: Stek;
};

export type StartStekStekMgtGetStekStartPostResponse = StartStekStekMgtGetStekStartPostResponses[keyof StartStekStekMgtGetStekStartPostResponses];

export type StartStekStekMgtGetSetupStatusStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/get_setup_status/start';
};

export type StartStekStekMgtGetSetupStatusStartPostResponses = {
    /**
     * Successful Response
     */
    200: SetupStatus;
};

export type StartStekStekMgtGetSetupStatusStartPostResponse = StartStekStekMgtGetSetupStatusStartPostResponses[keyof StartStekStekMgtGetSetupStatusStartPostResponses];

export type StartStekStekMgtTreeStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/tree/start';
};

export type StartStekStekMgtTreeStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtExportStekStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/export_stek/start';
};

export type StartStekStekMgtExportStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtUpdateStrategyStartPostData = {
    body: BodyStartStekStekMgtUpdateStrategyStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/update_strategy/start';
};

export type StartStekStekMgtUpdateStrategyStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtUpdateStrategyStartPostError = StartStekStekMgtUpdateStrategyStartPostErrors[keyof StartStekStekMgtUpdateStrategyStartPostErrors];

export type StartStekStekMgtUpdateStrategyStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtImportStekStartPostData = {
    body: BodyStartStekStekMgtImportStekStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/import_stek/start';
};

export type StartStekStekMgtImportStekStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtImportStekStartPostError = StartStekStekMgtImportStekStartPostErrors[keyof StartStekStekMgtImportStekStartPostErrors];

export type StartStekStekMgtImportStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtGenerateStekDetailsStartPostData = {
    body: BodyStartStekStekMgtGenerateStekDetailsStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/generate_stek_details/start';
};

export type StartStekStekMgtGenerateStekDetailsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtGenerateStekDetailsStartPostError = StartStekStekMgtGenerateStekDetailsStartPostErrors[keyof StartStekStekMgtGenerateStekDetailsStartPostErrors];

export type StartStekStekMgtGenerateStekDetailsStartPostResponses = {
    /**
     * Successful Response
     */
    200: StekGeneratedDetails;
};

export type StartStekStekMgtGenerateStekDetailsStartPostResponse = StartStekStekMgtGenerateStekDetailsStartPostResponses[keyof StartStekStekMgtGenerateStekDetailsStartPostResponses];

export type StartStekStekMgtGetSteksByOrganizationStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/get_steks_by_organization/start';
};

export type StartStekStekMgtGetSteksByOrganizationStartPostResponses = {
    /**
     * Response Start Stek Stek Mgt Get Steks By Organization Start Post
     *
     * Successful Response
     */
    200: Array<Stek>;
};

export type StartStekStekMgtGetSteksByOrganizationStartPostResponse = StartStekStekMgtGetSteksByOrganizationStartPostResponses[keyof StartStekStekMgtGetSteksByOrganizationStartPostResponses];

export type StartStekStekMgtCreateStekStartPostData = {
    body: BodyStartStekStekMgtCreateStekStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/create_stek/start';
};

export type StartStekStekMgtCreateStekStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtCreateStekStartPostError = StartStekStekMgtCreateStekStartPostErrors[keyof StartStekStekMgtCreateStekStartPostErrors];

export type StartStekStekMgtCreateStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtUpdateStekStartPostData = {
    body: BodyStartStekStekMgtUpdateStekStartPost;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/update_stek/start';
};

export type StartStekStekMgtUpdateStekStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartStekStekMgtUpdateStekStartPostError = StartStekStekMgtUpdateStekStartPostErrors[keyof StartStekStekMgtUpdateStekStartPostErrors];

export type StartStekStekMgtUpdateStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartStekStekMgtDeleteStekStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stek/stek_mgt/delete_stek/start';
};

export type StartStekStekMgtDeleteStekStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartHomeHomeMgtGetPersonalHomeStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/home/home_mgt/get_personal_home/start';
};

export type StartHomeHomeMgtGetPersonalHomeStartPostResponses = {
    /**
     * Successful Response
     */
    200: PersonalHome;
};

export type StartHomeHomeMgtGetPersonalHomeStartPostResponse = StartHomeHomeMgtGetPersonalHomeStartPostResponses[keyof StartHomeHomeMgtGetPersonalHomeStartPostResponses];

export type StartDomainBusinessEntityMgtListBusinessRulesStartPostData = {
    body: BodyStartDomainBusinessEntityMgtListBusinessRulesStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/list_business_rules/start';
};

export type StartDomainBusinessEntityMgtListBusinessRulesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtListBusinessRulesStartPostError = StartDomainBusinessEntityMgtListBusinessRulesStartPostErrors[keyof StartDomainBusinessEntityMgtListBusinessRulesStartPostErrors];

export type StartDomainBusinessEntityMgtListBusinessRulesStartPostResponses = {
    /**
     * Response Start Domain Business Entity Mgt List Business Rules Start Post
     *
     * Successful Response
     */
    200: Array<BusinessRule>;
};

export type StartDomainBusinessEntityMgtListBusinessRulesStartPostResponse = StartDomainBusinessEntityMgtListBusinessRulesStartPostResponses[keyof StartDomainBusinessEntityMgtListBusinessRulesStartPostResponses];

export type StartDomainBusinessEntityMgtCreateBusinessRuleStartPostData = {
    body: BodyStartDomainBusinessEntityMgtCreateBusinessRuleStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/create_business_rule/start';
};

export type StartDomainBusinessEntityMgtCreateBusinessRuleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtCreateBusinessRuleStartPostError = StartDomainBusinessEntityMgtCreateBusinessRuleStartPostErrors[keyof StartDomainBusinessEntityMgtCreateBusinessRuleStartPostErrors];

export type StartDomainBusinessEntityMgtCreateBusinessRuleStartPostResponses = {
    /**
     * Successful Response
     */
    200: BusinessRule;
};

export type StartDomainBusinessEntityMgtCreateBusinessRuleStartPostResponse = StartDomainBusinessEntityMgtCreateBusinessRuleStartPostResponses[keyof StartDomainBusinessEntityMgtCreateBusinessRuleStartPostResponses];

export type StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_linkable_business_entities/start';
};

export type StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostError = StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostErrors[keyof StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostErrors];

export type StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostResponses = {
    /**
     * Response Start Domain Business Entity Mgt Get Linkable Business Entities Start Post
     *
     * Successful Response
     */
    200: Array<LinkableBusinessEntity>;
};

export type StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostResponse = StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostResponses[keyof StartDomainBusinessEntityMgtGetLinkableBusinessEntitiesStartPostResponses];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetBusinessEntitiesStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_business_entities/start';
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostError = StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostErrors];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses = {
    /**
     * Response Start Domain Business Entity Mgt Get Business Entities Start Post
     *
     * Successful Response
     */
    200: Array<BusinessEntity>;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponse = StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesStartPostResponses];

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData = {
    body: BodyStartDomainBusinessEntityMgtDeleteBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/delete_business_entity/start';
};

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostError = StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors[keyof StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostErrors];

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData = {
    body: BodyStartDomainBusinessEntityMgtCreateBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/create_business_entity/start';
};

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostError = StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors[keyof StartDomainBusinessEntityMgtCreateBusinessEntityStartPostErrors];

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainBusinessEntityMgtConvertToDomainTermStartPostData = {
    body: BodyStartDomainBusinessEntityMgtConvertToDomainTermStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/convert_to_domain_term/start';
};

export type StartDomainBusinessEntityMgtConvertToDomainTermStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtConvertToDomainTermStartPostError = StartDomainBusinessEntityMgtConvertToDomainTermStartPostErrors[keyof StartDomainBusinessEntityMgtConvertToDomainTermStartPostErrors];

export type StartDomainBusinessEntityMgtConvertToDomainTermStartPostResponses = {
    /**
     * Successful Response
     */
    200: DomainTerm;
};

export type StartDomainBusinessEntityMgtConvertToDomainTermStartPostResponse = StartDomainBusinessEntityMgtConvertToDomainTermStartPostResponses[keyof StartDomainBusinessEntityMgtConvertToDomainTermStartPostResponses];

export type StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostData = {
    body: BodyStartDomainBusinessEntityMgtRemoveLinkedConceptStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/remove_linked_concept/start';
};

export type StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostError = StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostErrors[keyof StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostErrors];

export type StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostResponses = {
    /**
     * Successful Response
     */
    200: BusinessEntity;
};

export type StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostResponse = StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostResponses[keyof StartDomainBusinessEntityMgtRemoveLinkedConceptStartPostResponses];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_business_entities_by_product/start';
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostError = StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostErrors[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostErrors];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostResponses = {
    /**
     * Response Start Domain Business Entity Mgt Get Business Entities By Product Start Post
     *
     * Successful Response
     */
    200: Array<BusinessEntity>;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostResponse = StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostResponses[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesByProductStartPostResponses];

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_business_entity/start';
};

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostError = StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors[keyof StartDomainBusinessEntityMgtGetBusinessEntityStartPostErrors];

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: BusinessEntity;
};

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponse = StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses[keyof StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponses];

export type StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostData = {
    body: BodyStartDomainBusinessEntityMgtUpdateLinkedConceptsStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/update_linked_concepts/start';
};

export type StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostError = StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostErrors[keyof StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostErrors];

export type StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostResponses = {
    /**
     * Successful Response
     */
    200: BusinessEntity;
};

export type StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostResponse = StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostResponses[keyof StartDomainBusinessEntityMgtUpdateLinkedConceptsStartPostResponses];

export type StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostData = {
    body: BodyStartDomainBusinessEntityMgtDeleteBusinessRuleStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/delete_business_rule/start';
};

export type StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostError = StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostErrors[keyof StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostErrors];

export type StartDomainBusinessEntityMgtDeleteBusinessRuleStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostData = {
    body: BodyStartDomainBusinessEntityMgtUpdateBusinessRuleStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/update_business_rule/start';
};

export type StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostError = StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostErrors[keyof StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostErrors];

export type StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostResponses = {
    /**
     * Successful Response
     */
    200: BusinessRule;
};

export type StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostResponse = StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostResponses[keyof StartDomainBusinessEntityMgtUpdateBusinessRuleStartPostResponses];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_business_entities_grouped_by_process/start';
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostError = StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostErrors[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostErrors];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostResponses = {
    /**
     * Response Start Domain Business Entity Mgt Get Business Entities Grouped By Process Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<BusinessEntity>;
    };
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostResponse = StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostResponses[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProcessStartPostResponses];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_business_entities_by_process/start';
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostError = StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostErrors[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostErrors];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostResponses = {
    /**
     * Response Start Domain Business Entity Mgt Get Business Entities By Process Start Post
     *
     * Successful Response
     */
    200: Array<BusinessEntity>;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostResponse = StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostResponses[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesByProcessStartPostResponses];

export type StartDomainBusinessEntityMgtGetBusinessRuleStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetBusinessRuleStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_business_rule/start';
};

export type StartDomainBusinessEntityMgtGetBusinessRuleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetBusinessRuleStartPostError = StartDomainBusinessEntityMgtGetBusinessRuleStartPostErrors[keyof StartDomainBusinessEntityMgtGetBusinessRuleStartPostErrors];

export type StartDomainBusinessEntityMgtGetBusinessRuleStartPostResponses = {
    /**
     * Successful Response
     */
    200: BusinessRule;
};

export type StartDomainBusinessEntityMgtGetBusinessRuleStartPostResponse = StartDomainBusinessEntityMgtGetBusinessRuleStartPostResponses[keyof StartDomainBusinessEntityMgtGetBusinessRuleStartPostResponses];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_business_entities_grouped_by_domain/start';
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostError = StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostErrors[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostErrors];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostResponses = {
    /**
     * Response Start Domain Business Entity Mgt Get Business Entities Grouped By Domain Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<BusinessEntity>;
    };
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostResponse = StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostResponses[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByDomainStartPostResponses];

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData = {
    body: BodyStartDomainBusinessEntityMgtUpdateBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/update_business_entity/start';
};

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostError = StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors[keyof StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostErrors];

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetCrossDomainLinksStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_cross_domain_links/start';
};

export type StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostError = StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostErrors[keyof StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostErrors];

export type StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostResponses = {
    /**
     * Response Start Domain Business Entity Mgt Get Cross Domain Links Start Post
     *
     * Successful Response
     */
    200: Array<CrossDomainLink>;
};

export type StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostResponse = StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostResponses[keyof StartDomainBusinessEntityMgtGetCrossDomainLinksStartPostResponses];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostData = {
    body: BodyStartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPost;
    path?: never;
    query?: never;
    url: '/domain/business_entity_mgt/get_business_entities_grouped_by_product/start';
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostError = StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostErrors[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostErrors];

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostResponses = {
    /**
     * Response Start Domain Business Entity Mgt Get Business Entities Grouped By Product Start Post
     *
     * Successful Response
     */
    200: {
        [key: string]: Array<BusinessEntity>;
    };
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostResponse = StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostResponses[keyof StartDomainBusinessEntityMgtGetBusinessEntitiesGroupedByProductStartPostResponses];

export type StartDomainDomainMgtGetDomainStartPostData = {
    body: BodyStartDomainDomainMgtGetDomainStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/get_domain/start';
};

export type StartDomainDomainMgtGetDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainMgtGetDomainStartPostError = StartDomainDomainMgtGetDomainStartPostErrors[keyof StartDomainDomainMgtGetDomainStartPostErrors];

export type StartDomainDomainMgtGetDomainStartPostResponses = {
    /**
     * Successful Response
     */
    200: Domain;
};

export type StartDomainDomainMgtGetDomainStartPostResponse = StartDomainDomainMgtGetDomainStartPostResponses[keyof StartDomainDomainMgtGetDomainStartPostResponses];

export type StartDomainDomainMgtDeleteDomainStartPostData = {
    body: BodyStartDomainDomainMgtDeleteDomainStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/delete_domain/start';
};

export type StartDomainDomainMgtDeleteDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainMgtDeleteDomainStartPostError = StartDomainDomainMgtDeleteDomainStartPostErrors[keyof StartDomainDomainMgtDeleteDomainStartPostErrors];

export type StartDomainDomainMgtDeleteDomainStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainDomainMgtUpdateDomainStartPostData = {
    body: BodyStartDomainDomainMgtUpdateDomainStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/update_domain/start';
};

export type StartDomainDomainMgtUpdateDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainMgtUpdateDomainStartPostError = StartDomainDomainMgtUpdateDomainStartPostErrors[keyof StartDomainDomainMgtUpdateDomainStartPostErrors];

export type StartDomainDomainMgtUpdateDomainStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainDomainMgtCreateDomainStartPostData = {
    body: BodyStartDomainDomainMgtCreateDomainStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/create_domain/start';
};

export type StartDomainDomainMgtCreateDomainStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainMgtCreateDomainStartPostError = StartDomainDomainMgtCreateDomainStartPostErrors[keyof StartDomainDomainMgtCreateDomainStartPostErrors];

export type StartDomainDomainMgtCreateDomainStartPostResponses = {
    /**
     * Successful Response
     */
    200: Domain;
};

export type StartDomainDomainMgtCreateDomainStartPostResponse = StartDomainDomainMgtCreateDomainStartPostResponses[keyof StartDomainDomainMgtCreateDomainStartPostResponses];

export type StartDomainDomainMgtUpdateDomainOrdersStartPostData = {
    body: BodyStartDomainDomainMgtUpdateDomainOrdersStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/update_domain_orders/start';
};

export type StartDomainDomainMgtUpdateDomainOrdersStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainMgtUpdateDomainOrdersStartPostError = StartDomainDomainMgtUpdateDomainOrdersStartPostErrors[keyof StartDomainDomainMgtUpdateDomainOrdersStartPostErrors];

export type StartDomainDomainMgtUpdateDomainOrdersStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainDomainMgtGetDomainsByStekStartPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/domain/domain_mgt/get_domains_by_stek/start';
};

export type StartDomainDomainMgtGetDomainsByStekStartPostResponses = {
    /**
     * Response Start Domain Domain Mgt Get Domains By Stek Start Post
     *
     * Successful Response
     */
    200: Array<Domain>;
};

export type StartDomainDomainMgtGetDomainsByStekStartPostResponse = StartDomainDomainMgtGetDomainsByStekStartPostResponses[keyof StartDomainDomainMgtGetDomainsByStekStartPostResponses];

export type StartDomainRoleMgtUpdateRoleStartPostData = {
    body: BodyStartDomainRoleMgtUpdateRoleStartPost;
    path?: never;
    query?: never;
    url: '/domain/role_mgt/update_role/start';
};

export type StartDomainRoleMgtUpdateRoleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainRoleMgtUpdateRoleStartPostError = StartDomainRoleMgtUpdateRoleStartPostErrors[keyof StartDomainRoleMgtUpdateRoleStartPostErrors];

export type StartDomainRoleMgtUpdateRoleStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainRoleMgtDeleteRoleStartPostData = {
    body: BodyStartDomainRoleMgtDeleteRoleStartPost;
    path?: never;
    query?: never;
    url: '/domain/role_mgt/delete_role/start';
};

export type StartDomainRoleMgtDeleteRoleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainRoleMgtDeleteRoleStartPostError = StartDomainRoleMgtDeleteRoleStartPostErrors[keyof StartDomainRoleMgtDeleteRoleStartPostErrors];

export type StartDomainRoleMgtDeleteRoleStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainRoleMgtGetRoleStartPostData = {
    body: BodyStartDomainRoleMgtGetRoleStartPost;
    path?: never;
    query?: never;
    url: '/domain/role_mgt/get_role/start';
};

export type StartDomainRoleMgtGetRoleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainRoleMgtGetRoleStartPostError = StartDomainRoleMgtGetRoleStartPostErrors[keyof StartDomainRoleMgtGetRoleStartPostErrors];

export type StartDomainRoleMgtGetRoleStartPostResponses = {
    /**
     * Successful Response
     */
    200: Role;
};

export type StartDomainRoleMgtGetRoleStartPostResponse = StartDomainRoleMgtGetRoleStartPostResponses[keyof StartDomainRoleMgtGetRoleStartPostResponses];

export type StartDomainRoleMgtGetRolesStartPostData = {
    body: BodyStartDomainRoleMgtGetRolesStartPost;
    path?: never;
    query?: never;
    url: '/domain/role_mgt/get_roles/start';
};

export type StartDomainRoleMgtGetRolesStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainRoleMgtGetRolesStartPostError = StartDomainRoleMgtGetRolesStartPostErrors[keyof StartDomainRoleMgtGetRolesStartPostErrors];

export type StartDomainRoleMgtGetRolesStartPostResponses = {
    /**
     * Response Start Domain Role Mgt Get Roles Start Post
     *
     * Successful Response
     */
    200: Array<Role>;
};

export type StartDomainRoleMgtGetRolesStartPostResponse = StartDomainRoleMgtGetRolesStartPostResponses[keyof StartDomainRoleMgtGetRolesStartPostResponses];

export type StartDomainRoleMgtCreateRoleStartPostData = {
    body: BodyStartDomainRoleMgtCreateRoleStartPost;
    path?: never;
    query?: never;
    url: '/domain/role_mgt/create_role/start';
};

export type StartDomainRoleMgtCreateRoleStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainRoleMgtCreateRoleStartPostError = StartDomainRoleMgtCreateRoleStartPostErrors[keyof StartDomainRoleMgtCreateRoleStartPostErrors];

export type StartDomainRoleMgtCreateRoleStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainDomainTermMgtConvertToBusinessEntityStartPostData = {
    body: BodyStartDomainDomainTermMgtConvertToBusinessEntityStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/convert_to_business_entity/start';
};

export type StartDomainDomainTermMgtConvertToBusinessEntityStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtConvertToBusinessEntityStartPostError = StartDomainDomainTermMgtConvertToBusinessEntityStartPostErrors[keyof StartDomainDomainTermMgtConvertToBusinessEntityStartPostErrors];

export type StartDomainDomainTermMgtConvertToBusinessEntityStartPostResponses = {
    /**
     * Successful Response
     */
    200: BusinessEntity;
};

export type StartDomainDomainTermMgtConvertToBusinessEntityStartPostResponse = StartDomainDomainTermMgtConvertToBusinessEntityStartPostResponses[keyof StartDomainDomainTermMgtConvertToBusinessEntityStartPostResponses];

export type StartDomainDomainTermMgtGetDomainTermsStartPostData = {
    body: BodyStartDomainDomainTermMgtGetDomainTermsStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/get_domain_terms/start';
};

export type StartDomainDomainTermMgtGetDomainTermsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtGetDomainTermsStartPostError = StartDomainDomainTermMgtGetDomainTermsStartPostErrors[keyof StartDomainDomainTermMgtGetDomainTermsStartPostErrors];

export type StartDomainDomainTermMgtGetDomainTermsStartPostResponses = {
    /**
     * Response Start Domain Domain Term Mgt Get Domain Terms Start Post
     *
     * Successful Response
     */
    200: Array<DomainTerm>;
};

export type StartDomainDomainTermMgtGetDomainTermsStartPostResponse = StartDomainDomainTermMgtGetDomainTermsStartPostResponses[keyof StartDomainDomainTermMgtGetDomainTermsStartPostResponses];

export type StartDomainDomainTermMgtGetDomainTermStartPostData = {
    body: BodyStartDomainDomainTermMgtGetDomainTermStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/get_domain_term/start';
};

export type StartDomainDomainTermMgtGetDomainTermStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtGetDomainTermStartPostError = StartDomainDomainTermMgtGetDomainTermStartPostErrors[keyof StartDomainDomainTermMgtGetDomainTermStartPostErrors];

export type StartDomainDomainTermMgtGetDomainTermStartPostResponses = {
    /**
     * Successful Response
     */
    200: DomainTerm;
};

export type StartDomainDomainTermMgtGetDomainTermStartPostResponse = StartDomainDomainTermMgtGetDomainTermStartPostResponses[keyof StartDomainDomainTermMgtGetDomainTermStartPostResponses];

export type StartDomainDomainTermMgtDeleteDomainTermStartPostData = {
    body: BodyStartDomainDomainTermMgtDeleteDomainTermStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/delete_domain_term/start';
};

export type StartDomainDomainTermMgtDeleteDomainTermStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtDeleteDomainTermStartPostError = StartDomainDomainTermMgtDeleteDomainTermStartPostErrors[keyof StartDomainDomainTermMgtDeleteDomainTermStartPostErrors];

export type StartDomainDomainTermMgtDeleteDomainTermStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type StartDomainDomainTermMgtUpdateDomainTermStartPostData = {
    body: BodyStartDomainDomainTermMgtUpdateDomainTermStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/update_domain_term/start';
};

export type StartDomainDomainTermMgtUpdateDomainTermStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtUpdateDomainTermStartPostError = StartDomainDomainTermMgtUpdateDomainTermStartPostErrors[keyof StartDomainDomainTermMgtUpdateDomainTermStartPostErrors];

export type StartDomainDomainTermMgtUpdateDomainTermStartPostResponses = {
    /**
     * Successful Response
     */
    200: DomainTerm;
};

export type StartDomainDomainTermMgtUpdateDomainTermStartPostResponse = StartDomainDomainTermMgtUpdateDomainTermStartPostResponses[keyof StartDomainDomainTermMgtUpdateDomainTermStartPostResponses];

export type StartDomainDomainTermMgtCreateDomainTermStartPostData = {
    body: BodyStartDomainDomainTermMgtCreateDomainTermStartPost;
    path?: never;
    query?: never;
    url: '/domain/domain_term_mgt/create_domain_term/start';
};

export type StartDomainDomainTermMgtCreateDomainTermStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartDomainDomainTermMgtCreateDomainTermStartPostError = StartDomainDomainTermMgtCreateDomainTermStartPostErrors[keyof StartDomainDomainTermMgtCreateDomainTermStartPostErrors];

export type StartDomainDomainTermMgtCreateDomainTermStartPostResponses = {
    /**
     * Successful Response
     */
    200: DomainTerm;
};

export type StartDomainDomainTermMgtCreateDomainTermStartPostResponse = StartDomainDomainTermMgtCreateDomainTermStartPostResponses[keyof StartDomainDomainTermMgtCreateDomainTermStartPostResponses];

export type GetEntriesWhatsNewWhatsNewMgtEntriesGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Limit
         *
         * Maximum number of entries to return.
         */
        limit?: number;
        /**
         * Offset
         *
         * Number of entries to skip.
         */
        offset?: number;
    };
    url: '/whats_new/whats_new_mgt/entries';
};

export type GetEntriesWhatsNewWhatsNewMgtEntriesGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntriesWhatsNewWhatsNewMgtEntriesGetError = GetEntriesWhatsNewWhatsNewMgtEntriesGetErrors[keyof GetEntriesWhatsNewWhatsNewMgtEntriesGetErrors];

export type GetEntriesWhatsNewWhatsNewMgtEntriesGetResponses = {
    /**
     * Response Get Entries Whats New Whats New Mgt Entries Get
     *
     * Successful Response
     */
    200: Array<WhatsNewEntryResponse>;
};

export type GetEntriesWhatsNewWhatsNewMgtEntriesGetResponse = GetEntriesWhatsNewWhatsNewMgtEntriesGetResponses[keyof GetEntriesWhatsNewWhatsNewMgtEntriesGetResponses];

export type CreateEntryWhatsNewWhatsNewMgtEntriesPostData = {
    body: CreateWhatsNewEntry;
    path?: never;
    query?: never;
    url: '/whats_new/whats_new_mgt/entries';
};

export type CreateEntryWhatsNewWhatsNewMgtEntriesPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateEntryWhatsNewWhatsNewMgtEntriesPostError = CreateEntryWhatsNewWhatsNewMgtEntriesPostErrors[keyof CreateEntryWhatsNewWhatsNewMgtEntriesPostErrors];

export type CreateEntryWhatsNewWhatsNewMgtEntriesPostResponses = {
    /**
     * Successful Response
     */
    201: WhatsNewEntryResponse;
};

export type CreateEntryWhatsNewWhatsNewMgtEntriesPostResponse = CreateEntryWhatsNewWhatsNewMgtEntriesPostResponses[keyof CreateEntryWhatsNewWhatsNewMgtEntriesPostResponses];

export type UploadMediaWhatsNewWhatsNewMgtUploadsPostData = {
    body: BodyUploadMediaWhatsNewWhatsNewMgtUploadsPost;
    path?: never;
    query?: never;
    url: '/whats_new/whats_new_mgt/uploads';
};

export type UploadMediaWhatsNewWhatsNewMgtUploadsPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UploadMediaWhatsNewWhatsNewMgtUploadsPostError = UploadMediaWhatsNewWhatsNewMgtUploadsPostErrors[keyof UploadMediaWhatsNewWhatsNewMgtUploadsPostErrors];

export type UploadMediaWhatsNewWhatsNewMgtUploadsPostResponses = {
    /**
     * Successful Response
     */
    200: UploadResponse;
};

export type UploadMediaWhatsNewWhatsNewMgtUploadsPostResponse = UploadMediaWhatsNewWhatsNewMgtUploadsPostResponses[keyof UploadMediaWhatsNewWhatsNewMgtUploadsPostResponses];

export type GetUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/whats_new/whats_new_mgt/entries/unseen';
};

export type GetUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGetResponses = {
    /**
     * Response Get Unseen Entries Whats New Whats New Mgt Entries Unseen Get
     *
     * Successful Response
     */
    200: Array<WhatsNewEntryResponse>;
};

export type GetUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGetResponse = GetUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGetResponses[keyof GetUnseenEntriesWhatsNewWhatsNewMgtEntriesUnseenGetResponses];

export type DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteData = {
    body?: never;
    path: {
        /**
         * Entry Id
         */
        entry_id: string;
    };
    query?: never;
    url: '/whats_new/whats_new_mgt/entries/{entry_id}';
};

export type DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteError = DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteErrors[keyof DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteErrors];

export type DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteResponse = DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteResponses[keyof DeleteEntryWhatsNewWhatsNewMgtEntriesEntryIdDeleteResponses];

export type UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutData = {
    body: UpdateWhatsNewEntry;
    path: {
        /**
         * Entry Id
         */
        entry_id: string;
    };
    query?: never;
    url: '/whats_new/whats_new_mgt/entries/{entry_id}';
};

export type UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutError = UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutErrors[keyof UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutErrors];

export type UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutResponses = {
    /**
     * Successful Response
     */
    200: WhatsNewEntryResponse;
};

export type UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutResponse = UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutResponses[keyof UpdateEntryWhatsNewWhatsNewMgtEntriesEntryIdPutResponses];

export type MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostData = {
    body?: never;
    path: {
        /**
         * Entry Id
         */
        entry_id: string;
    };
    query?: never;
    url: '/whats_new/whats_new_mgt/entries/{entry_id}/seen';
};

export type MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostError = MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostErrors[keyof MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostErrors];

export type MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostResponse = MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostResponses[keyof MarkSeenWhatsNewWhatsNewMgtEntriesEntryIdSeenPostResponses];

export type GetUsersUserGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/';
};

export type GetUsersUserGetResponses = {
    /**
     * Response Get Users User  Get
     *
     * Successful Response
     */
    200: Array<OrganizationUser>;
};

export type GetUsersUserGetResponse = GetUsersUserGetResponses[keyof GetUsersUserGetResponses];

export type CreateUserUserPostData = {
    body: CreateUser;
    path?: never;
    query?: never;
    url: '/user/';
};

export type CreateUserUserPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateUserUserPostError = CreateUserUserPostErrors[keyof CreateUserUserPostErrors];

export type CreateUserUserPostResponses = {
    /**
     * Successful Response
     */
    200: OrganizationUser;
};

export type CreateUserUserPostResponse = CreateUserUserPostResponses[keyof CreateUserUserPostResponses];

export type SignupUserSignupPostData = {
    body: CreateUser;
    path?: never;
    query?: never;
    url: '/user/signup';
};

export type SignupUserSignupPostErrors = {
    /**
     * Bad Request
     */
    400: HttpExceptionModel;
    /**
     * Unauthorized
     */
    401: HttpExceptionModel;
    /**
     * Forbidden
     */
    403: HttpExceptionModel;
    /**
     * Not Found
     */
    404: HttpExceptionModel;
    /**
     * Conflict
     */
    409: HttpExceptionModel;
    /**
     * Precondition Failed
     */
    412: HttpExceptionModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
    /**
     * Service Unavailable
     */
    503: HttpExceptionModel;
};

export type SignupUserSignupPostError = SignupUserSignupPostErrors[keyof SignupUserSignupPostErrors];

export type SignupUserSignupPostResponses = {
    /**
     * Successful Response
     */
    200: MeUser;
};

export type SignupUserSignupPostResponse = SignupUserSignupPostResponses[keyof SignupUserSignupPostResponses];

export type ValidateInvitationUserInvitationValidatePostData = {
    body: ValidateInvitationRequest;
    path?: never;
    query?: never;
    url: '/user/invitation/validate';
};

export type ValidateInvitationUserInvitationValidatePostErrors = {
    /**
     * Bad Request
     */
    400: HttpExceptionModel;
    /**
     * Unauthorized
     */
    401: HttpExceptionModel;
    /**
     * Forbidden
     */
    403: HttpExceptionModel;
    /**
     * Not Found
     */
    404: HttpExceptionModel;
    /**
     * Conflict
     */
    409: HttpExceptionModel;
    /**
     * Precondition Failed
     */
    412: HttpExceptionModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
    /**
     * Service Unavailable
     */
    503: HttpExceptionModel;
};

export type ValidateInvitationUserInvitationValidatePostError = ValidateInvitationUserInvitationValidatePostErrors[keyof ValidateInvitationUserInvitationValidatePostErrors];

export type ValidateInvitationUserInvitationValidatePostResponses = {
    /**
     * Successful Response
     */
    200: InvitationValidation;
};

export type ValidateInvitationUserInvitationValidatePostResponse = ValidateInvitationUserInvitationValidatePostResponses[keyof ValidateInvitationUserInvitationValidatePostResponses];

export type SignupWithInvitationUserSignupWithInvitationPostData = {
    body: CreateUserWithInvitation;
    path?: never;
    query?: never;
    url: '/user/signup-with-invitation';
};

export type SignupWithInvitationUserSignupWithInvitationPostErrors = {
    /**
     * Bad Request
     */
    400: HttpExceptionModel;
    /**
     * Unauthorized
     */
    401: HttpExceptionModel;
    /**
     * Forbidden
     */
    403: HttpExceptionModel;
    /**
     * Not Found
     */
    404: HttpExceptionModel;
    /**
     * Conflict
     */
    409: HttpExceptionModel;
    /**
     * Precondition Failed
     */
    412: HttpExceptionModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
    /**
     * Service Unavailable
     */
    503: HttpExceptionModel;
};

export type SignupWithInvitationUserSignupWithInvitationPostError = SignupWithInvitationUserSignupWithInvitationPostErrors[keyof SignupWithInvitationUserSignupWithInvitationPostErrors];

export type SignupWithInvitationUserSignupWithInvitationPostResponses = {
    /**
     * Successful Response
     */
    200: MeUser;
};

export type SignupWithInvitationUserSignupWithInvitationPostResponse = SignupWithInvitationUserSignupWithInvitationPostResponses[keyof SignupWithInvitationUserSignupWithInvitationPostResponses];

export type ResendInvitationEndpointUserUserIdResendInvitationPostData = {
    body?: never;
    path: {
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/user/{user_id}/resend-invitation';
};

export type ResendInvitationEndpointUserUserIdResendInvitationPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ResendInvitationEndpointUserUserIdResendInvitationPostError = ResendInvitationEndpointUserUserIdResendInvitationPostErrors[keyof ResendInvitationEndpointUserUserIdResendInvitationPostErrors];

export type ResendInvitationEndpointUserUserIdResendInvitationPostResponses = {
    /**
     * Successful Response
     */
    200: OrganizationUser;
};

export type ResendInvitationEndpointUserUserIdResendInvitationPostResponse = ResendInvitationEndpointUserUserIdResendInvitationPostResponses[keyof ResendInvitationEndpointUserUserIdResendInvitationPostResponses];

export type DeleteUserUserUserIdDeleteData = {
    body?: never;
    path: {
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/user/{user_id}';
};

export type DeleteUserUserUserIdDeleteErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteUserUserUserIdDeleteError = DeleteUserUserUserIdDeleteErrors[keyof DeleteUserUserUserIdDeleteErrors];

export type DeleteUserUserUserIdDeleteResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetSelfUserMeGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/me';
};

export type GetSelfUserMeGetResponses = {
    /**
     * Successful Response
     */
    200: MeUser;
};

export type GetSelfUserMeGetResponse = GetSelfUserMeGetResponses[keyof GetSelfUserMeGetResponses];

export type UpdateSelfUserMePutData = {
    body: UpdateUser;
    path?: never;
    query?: never;
    url: '/user/me';
};

export type UpdateSelfUserMePutErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateSelfUserMePutError = UpdateSelfUserMePutErrors[keyof UpdateSelfUserMePutErrors];

export type UpdateSelfUserMePutResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UpdateSelfPreferencesUserMePreferencesPatchData = {
    body: UpdatePreferences;
    path?: never;
    query?: never;
    url: '/user/me/preferences';
};

export type UpdateSelfPreferencesUserMePreferencesPatchErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateSelfPreferencesUserMePreferencesPatchError = UpdateSelfPreferencesUserMePreferencesPatchErrors[keyof UpdateSelfPreferencesUserMePreferencesPatchErrors];

export type UpdateSelfPreferencesUserMePreferencesPatchResponses = {
    /**
     * Successful Response
     */
    200: MeUser;
};

export type UpdateSelfPreferencesUserMePreferencesPatchResponse = UpdateSelfPreferencesUserMePreferencesPatchResponses[keyof UpdateSelfPreferencesUserMePreferencesPatchResponses];

export type GetDomainRolesUserUserIdDomainRolesGetData = {
    body?: never;
    path: {
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/user/{user_id}/domain-roles';
};

export type GetDomainRolesUserUserIdDomainRolesGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDomainRolesUserUserIdDomainRolesGetError = GetDomainRolesUserUserIdDomainRolesGetErrors[keyof GetDomainRolesUserUserIdDomainRolesGetErrors];

export type GetDomainRolesUserUserIdDomainRolesGetResponses = {
    /**
     * Response Get Domain Roles User  User Id  Domain Roles Get
     *
     * Successful Response
     */
    200: Array<DomainRole>;
};

export type GetDomainRolesUserUserIdDomainRolesGetResponse = GetDomainRolesUserUserIdDomainRolesGetResponses[keyof GetDomainRolesUserUserIdDomainRolesGetResponses];

export type UpdateAuthorizationUserUserIdAuthorizationPutData = {
    body: UpdateUserAuthorization;
    path: {
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/user/{user_id}/authorization';
};

export type UpdateAuthorizationUserUserIdAuthorizationPutErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateAuthorizationUserUserIdAuthorizationPutError = UpdateAuthorizationUserUserIdAuthorizationPutErrors[keyof UpdateAuthorizationUserUserIdAuthorizationPutErrors];

export type UpdateAuthorizationUserUserIdAuthorizationPutResponses = {
    /**
     * Successful Response
     */
    200: OrganizationUser;
};

export type UpdateAuthorizationUserUserIdAuthorizationPutResponse = UpdateAuthorizationUserUserIdAuthorizationPutResponses[keyof UpdateAuthorizationUserUserIdAuthorizationPutResponses];

export type ListApiKeysUserApiKeysGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/api-keys';
};

export type ListApiKeysUserApiKeysGetResponses = {
    /**
     * Successful Response
     */
    200: ApiKeysList;
};

export type ListApiKeysUserApiKeysGetResponse = ListApiKeysUserApiKeysGetResponses[keyof ListApiKeysUserApiKeysGetResponses];

export type CreateApiKeyUserApiKeyPostData = {
    body: BodyCreateApiKeyUserApiKeyPost;
    path?: never;
    query?: never;
    url: '/user/api-key';
};

export type CreateApiKeyUserApiKeyPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateApiKeyUserApiKeyPostError = CreateApiKeyUserApiKeyPostErrors[keyof CreateApiKeyUserApiKeyPostErrors];

export type CreateApiKeyUserApiKeyPostResponses = {
    /**
     * Successful Response
     */
    201: ApiKeyCreated;
};

export type CreateApiKeyUserApiKeyPostResponse = CreateApiKeyUserApiKeyPostResponses[keyof CreateApiKeyUserApiKeyPostResponses];

export type RevokeApiKeyUserApiKeyApiKeyIdDeleteData = {
    body?: never;
    path: {
        /**
         * Api Key Id
         */
        api_key_id: string;
    };
    query?: never;
    url: '/user/api-key/{api_key_id}';
};

export type RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RevokeApiKeyUserApiKeyApiKeyIdDeleteError = RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors[keyof RevokeApiKeyUserApiKeyApiKeyIdDeleteErrors];

export type RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type RevokeApiKeyUserApiKeyApiKeyIdDeleteResponse = RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses[keyof RevokeApiKeyUserApiKeyApiKeyIdDeleteResponses];

export type RecordPolicyAcceptanceUserPolicyAcceptancePostData = {
    body: PolicyAcceptanceRequest;
    path?: never;
    query?: never;
    url: '/user/policy-acceptance';
};

export type RecordPolicyAcceptanceUserPolicyAcceptancePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RecordPolicyAcceptanceUserPolicyAcceptancePostError = RecordPolicyAcceptanceUserPolicyAcceptancePostErrors[keyof RecordPolicyAcceptanceUserPolicyAcceptancePostErrors];

export type RecordPolicyAcceptanceUserPolicyAcceptancePostResponses = {
    /**
     * Successful Response
     */
    200: PolicyAcceptance;
};

export type RecordPolicyAcceptanceUserPolicyAcceptancePostResponse = RecordPolicyAcceptanceUserPolicyAcceptancePostResponses[keyof RecordPolicyAcceptanceUserPolicyAcceptancePostResponses];

export type GetPolicyAcceptancesUserPolicyAcceptancesGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Policy Type
         */
        policy_type?: string | null;
    };
    url: '/user/policy-acceptances';
};

export type GetPolicyAcceptancesUserPolicyAcceptancesGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPolicyAcceptancesUserPolicyAcceptancesGetError = GetPolicyAcceptancesUserPolicyAcceptancesGetErrors[keyof GetPolicyAcceptancesUserPolicyAcceptancesGetErrors];

export type GetPolicyAcceptancesUserPolicyAcceptancesGetResponses = {
    /**
     * Response Get Policy Acceptances  User Policy Acceptances Get
     *
     * Successful Response
     */
    200: Array<PolicyAcceptance>;
};

export type GetPolicyAcceptancesUserPolicyAcceptancesGetResponse = GetPolicyAcceptancesUserPolicyAcceptancesGetResponses[keyof GetPolicyAcceptancesUserPolicyAcceptancesGetResponses];

export type GetPolicyStatusUserPolicyStatusGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/policy-status';
};

export type GetPolicyStatusUserPolicyStatusGetResponses = {
    /**
     * Successful Response
     */
    200: PolicyAcceptanceStatus;
};

export type GetPolicyStatusUserPolicyStatusGetResponse = GetPolicyStatusUserPolicyStatusGetResponses[keyof GetPolicyStatusUserPolicyStatusGetResponses];

export type GetAllPlatformUsersUserAllGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user/all/';
};

export type GetAllPlatformUsersUserAllGetErrors = {
    /**
     * Bad Request
     */
    400: HttpExceptionModel;
    /**
     * Unauthorized
     */
    401: HttpExceptionModel;
    /**
     * Forbidden
     */
    403: HttpExceptionModel;
    /**
     * Not Found
     */
    404: HttpExceptionModel;
    /**
     * Conflict
     */
    409: HttpExceptionModel;
    /**
     * Precondition Failed
     */
    412: HttpExceptionModel;
    /**
     * Service Unavailable
     */
    503: HttpExceptionModel;
};

export type GetAllPlatformUsersUserAllGetError = GetAllPlatformUsersUserAllGetErrors[keyof GetAllPlatformUsersUserAllGetErrors];

export type GetAllPlatformUsersUserAllGetResponses = {
    /**
     * Response Get All Platform Users User All  Get
     *
     * Successful Response
     */
    200: Array<MeUser>;
};

export type GetAllPlatformUsersUserAllGetResponse = GetAllPlatformUsersUserAllGetResponses[keyof GetAllPlatformUsersUserAllGetResponses];

export type GetFirebaseUserByEmailUserFirebaseEmailGetData = {
    body?: never;
    path: {
        /**
         * Email
         */
        email: string;
    };
    query?: never;
    url: '/user/firebase/{email}';
};

export type GetFirebaseUserByEmailUserFirebaseEmailGetErrors = {
    /**
     * Bad Request
     */
    400: HttpExceptionModel;
    /**
     * Unauthorized
     */
    401: HttpExceptionModel;
    /**
     * Forbidden
     */
    403: HttpExceptionModel;
    /**
     * Not Found
     */
    404: HttpExceptionModel;
    /**
     * Conflict
     */
    409: HttpExceptionModel;
    /**
     * Precondition Failed
     */
    412: HttpExceptionModel;
    /**
     * Validation Error
     */
    422: HttpValidationError;
    /**
     * Service Unavailable
     */
    503: HttpExceptionModel;
};

export type GetFirebaseUserByEmailUserFirebaseEmailGetError = GetFirebaseUserByEmailUserFirebaseEmailGetErrors[keyof GetFirebaseUserByEmailUserFirebaseEmailGetErrors];

export type GetFirebaseUserByEmailUserFirebaseEmailGetResponses = {
    /**
     * Successful Response
     */
    200: FirebaseUser;
};

export type GetFirebaseUserByEmailUserFirebaseEmailGetResponse = GetFirebaseUserByEmailUserFirebaseEmailGetResponses[keyof GetFirebaseUserByEmailUserFirebaseEmailGetResponses];

export type StartAiTaskMgtGetTaskProvidersStartPostData = {
    body: GetTaskProvidersRequest;
    path?: never;
    query?: never;
    url: '/ai/task_mgt/get_task_providers/start';
};

export type StartAiTaskMgtGetTaskProvidersStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartAiTaskMgtGetTaskProvidersStartPostError = StartAiTaskMgtGetTaskProvidersStartPostErrors[keyof StartAiTaskMgtGetTaskProvidersStartPostErrors];

export type StartAiTaskMgtGetTaskProvidersStartPostResponses = {
    /**
     * Successful Response
     */
    200: SupportedProvidersResponse;
};

export type StartAiTaskMgtGetTaskProvidersStartPostResponse = StartAiTaskMgtGetTaskProvidersStartPostResponses[keyof StartAiTaskMgtGetTaskProvidersStartPostResponses];

export type StartAiEvaluationGetTaskEvaluationsStartPostData = {
    body: GetTaskEvaluationsRequest;
    path?: never;
    query?: never;
    url: '/ai/evaluation/get_task_evaluations/start';
};

export type StartAiEvaluationGetTaskEvaluationsStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartAiEvaluationGetTaskEvaluationsStartPostError = StartAiEvaluationGetTaskEvaluationsStartPostErrors[keyof StartAiEvaluationGetTaskEvaluationsStartPostErrors];

export type StartAiEvaluationGetTaskEvaluationsStartPostResponses = {
    /**
     * Successful Response
     */
    200: TaskEvaluationListResponse;
};

export type StartAiEvaluationGetTaskEvaluationsStartPostResponse = StartAiEvaluationGetTaskEvaluationsStartPostResponses[keyof StartAiEvaluationGetTaskEvaluationsStartPostResponses];

export type StartAiTaskMgtRunTaskStartPostData = {
    body: TaskEvaluationRequest;
    path?: never;
    query?: never;
    url: '/ai/task_mgt/run_task/start';
};

export type StartAiTaskMgtRunTaskStartPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StartAiTaskMgtRunTaskStartPostError = StartAiTaskMgtRunTaskStartPostErrors[keyof StartAiTaskMgtRunTaskStartPostErrors];

export type StartAiTaskMgtRunTaskStartPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type SearchSearchGetData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Q
         */
        q: string;
    };
    url: '/search/';
};

export type SearchSearchGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SearchSearchGetError = SearchSearchGetErrors[keyof SearchSearchGetErrors];

export type SearchSearchGetResponses = {
    /**
     * Successful Response
     */
    200: SearchResponse;
};

export type SearchSearchGetResponse = SearchSearchGetResponses[keyof SearchSearchGetResponses];

export type RecordAttentionEventsMeAttentionEventsPostData = {
    body: AttentionEventsSchema;
    path?: never;
    query?: never;
    url: '/me/attention/events';
};

export type RecordAttentionEventsMeAttentionEventsPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RecordAttentionEventsMeAttentionEventsPostError = RecordAttentionEventsMeAttentionEventsPostErrors[keyof RecordAttentionEventsMeAttentionEventsPostErrors];

export type RecordAttentionEventsMeAttentionEventsPostResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type RecordAttentionEventsMeAttentionEventsPostResponse = RecordAttentionEventsMeAttentionEventsPostResponses[keyof RecordAttentionEventsMeAttentionEventsPostResponses];

export type ListMemoryMeMemoryGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/me/memory';
};

export type ListMemoryMeMemoryGetResponses = {
    /**
     * Response List Memory Me Memory Get
     *
     * Successful Response
     */
    200: Array<MemoryEntrySchema>;
};

export type ListMemoryMeMemoryGetResponse = ListMemoryMeMemoryGetResponses[keyof ListMemoryMeMemoryGetResponses];

export type DeleteMemoryEntryMeMemoryEntryIdDeleteData = {
    body?: never;
    path: {
        /**
         * Entry Id
         */
        entry_id: string;
    };
    query?: never;
    url: '/me/memory/{entry_id}';
};

export type DeleteMemoryEntryMeMemoryEntryIdDeleteErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteMemoryEntryMeMemoryEntryIdDeleteError = DeleteMemoryEntryMeMemoryEntryIdDeleteErrors[keyof DeleteMemoryEntryMeMemoryEntryIdDeleteErrors];

export type DeleteMemoryEntryMeMemoryEntryIdDeleteResponses = {
    /**
     * Response Delete Memory Entry Me Memory  Entry Id  Delete
     *
     * Successful Response
     */
    200: MemoryEntrySchema | null;
};

export type DeleteMemoryEntryMeMemoryEntryIdDeleteResponse = DeleteMemoryEntryMeMemoryEntryIdDeleteResponses[keyof DeleteMemoryEntryMeMemoryEntryIdDeleteResponses];

export type GetPersonalMemorySettingsMePersonalMemorySettingsGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/me/personal-memory-settings';
};

export type GetPersonalMemorySettingsMePersonalMemorySettingsGetResponses = {
    /**
     * Successful Response
     */
    200: PersonalMemorySettingsSchema;
};

export type GetPersonalMemorySettingsMePersonalMemorySettingsGetResponse = GetPersonalMemorySettingsMePersonalMemorySettingsGetResponses[keyof GetPersonalMemorySettingsMePersonalMemorySettingsGetResponses];

export type SetAttentionProbeEnabledMeAttentionProbeEnabledPutData = {
    body: BodySetAttentionProbeEnabledMeAttentionProbeEnabledPut;
    path?: never;
    query?: never;
    url: '/me/attention-probe-enabled';
};

export type SetAttentionProbeEnabledMeAttentionProbeEnabledPutErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SetAttentionProbeEnabledMeAttentionProbeEnabledPutError = SetAttentionProbeEnabledMeAttentionProbeEnabledPutErrors[keyof SetAttentionProbeEnabledMeAttentionProbeEnabledPutErrors];

export type SetAttentionProbeEnabledMeAttentionProbeEnabledPutResponses = {
    /**
     * Successful Response
     */
    200: PersonalMemoryEnabledSchema;
};

export type SetAttentionProbeEnabledMeAttentionProbeEnabledPutResponse = SetAttentionProbeEnabledMeAttentionProbeEnabledPutResponses[keyof SetAttentionProbeEnabledMeAttentionProbeEnabledPutResponses];

export type SetPersonalMemoryEnabledMePersonalMemoryEnabledPutData = {
    body: BodySetPersonalMemoryEnabledMePersonalMemoryEnabledPut;
    path?: never;
    query?: never;
    url: '/me/personal-memory-enabled';
};

export type SetPersonalMemoryEnabledMePersonalMemoryEnabledPutErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SetPersonalMemoryEnabledMePersonalMemoryEnabledPutError = SetPersonalMemoryEnabledMePersonalMemoryEnabledPutErrors[keyof SetPersonalMemoryEnabledMePersonalMemoryEnabledPutErrors];

export type SetPersonalMemoryEnabledMePersonalMemoryEnabledPutResponses = {
    /**
     * Successful Response
     */
    200: PersonalMemoryEnabledSchema;
};

export type SetPersonalMemoryEnabledMePersonalMemoryEnabledPutResponse = SetPersonalMemoryEnabledMePersonalMemoryEnabledPutResponses[keyof SetPersonalMemoryEnabledMePersonalMemoryEnabledPutResponses];

export type ExportContextMePersonalContextExportGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/me/personal-context/export';
};

export type ExportContextMePersonalContextExportGetResponses = {
    /**
     * Successful Response
     */
    200: PersonalContextExportSchema;
};

export type ExportContextMePersonalContextExportGetResponse = ExportContextMePersonalContextExportGetResponses[keyof ExportContextMePersonalContextExportGetResponses];

export type WipeContextMePersonalContextDeleteData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/me/personal-context';
};

export type WipeContextMePersonalContextDeleteResponses = {
    /**
     * Successful Response
     */
    200: WipeReceiptSchema;
};

export type WipeContextMePersonalContextDeleteResponse = WipeContextMePersonalContextDeleteResponses[keyof WipeContextMePersonalContextDeleteResponses];

export type PreviewLinkProxyPreviewLinkGetData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Url
         */
        url: string;
    };
    url: '/proxy/preview-link';
};

export type PreviewLinkProxyPreviewLinkGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PreviewLinkProxyPreviewLinkGetError = PreviewLinkProxyPreviewLinkGetErrors[keyof PreviewLinkProxyPreviewLinkGetErrors];

export type PreviewLinkProxyPreviewLinkGetResponses = {
    /**
     * Successful Response
     */
    200: LinkPreview;
};

export type PreviewLinkProxyPreviewLinkGetResponse = PreviewLinkProxyPreviewLinkGetResponses[keyof PreviewLinkProxyPreviewLinkGetResponses];

export type PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetData = {
    body?: never;
    path: {
        integration_type: IntegrationType;
    };
    query: {
        /**
         * Redirect Uri
         */
        redirect_uri: string;
    };
    url: '/integrations/oauth2/client/prepare/{integration_type}';
};

export type PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetError = PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors[keyof PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetErrors];

export type PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses = {
    /**
     * Successful Response
     */
    200: PrepareResponse;
};

export type PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponse = PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses[keyof PrepareIntegrationsOauth2ClientPrepareIntegrationTypeGetResponses];

export type ExchangeTokenIntegrationsOauth2ClientTokenPostData = {
    body: TokenRequest;
    path?: never;
    query?: never;
    url: '/integrations/oauth2/client/token';
};

export type ExchangeTokenIntegrationsOauth2ClientTokenPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExchangeTokenIntegrationsOauth2ClientTokenPostError = ExchangeTokenIntegrationsOauth2ClientTokenPostErrors[keyof ExchangeTokenIntegrationsOauth2ClientTokenPostErrors];

export type ExchangeTokenIntegrationsOauth2ClientTokenPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Client Id
         */
        client_id?: string | null;
        /**
         * Response Type
         */
        response_type?: string | null;
        /**
         * Redirect Uri
         */
        redirect_uri?: string | null;
        /**
         * Scope
         */
        scope?: string | null;
        /**
         * State
         */
        state?: string | null;
        /**
         * Code Challenge
         */
        code_challenge?: string | null;
        /**
         * Code Challenge Method
         */
        code_challenge_method?: string;
    };
    url: '/integrations/oauth2/server/authorize';
};

export type AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetError = AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors[keyof AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetErrors];

export type AuthorizeRequestIntegrationsOauth2ServerAuthorizeGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostData = {
    body: BodyGenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePost;
    path?: never;
    query?: never;
    url: '/integrations/oauth2/server/authorize';
};

export type GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostError = GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors[keyof GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostErrors];

export type GenerateAuthorizationCodeIntegrationsOauth2ServerAuthorizePostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetData = {
    body?: never;
    path: {
        /**
         * Consent Request Id
         */
        consent_request_id: string;
    };
    query?: never;
    url: '/integrations/oauth2/server/consent/{consent_request_id}';
};

export type GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetError = GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetErrors[keyof GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetErrors];

export type GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetResponses = {
    /**
     * Successful Response
     */
    200: ConsentContext;
};

export type GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetResponse = GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetResponses[keyof GetConsentContextIntegrationsOauth2ServerConsentConsentRequestIdGetResponses];

export type TokenEndpointIntegrationsOauth2ServerTokenPostData = {
    body: BodyTokenEndpointIntegrationsOauth2ServerTokenPost;
    path?: never;
    query?: never;
    url: '/integrations/oauth2/server/token';
};

export type TokenEndpointIntegrationsOauth2ServerTokenPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type TokenEndpointIntegrationsOauth2ServerTokenPostError = TokenEndpointIntegrationsOauth2ServerTokenPostErrors[keyof TokenEndpointIntegrationsOauth2ServerTokenPostErrors];

export type TokenEndpointIntegrationsOauth2ServerTokenPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type RegisterClientIntegrationsOauth2ServerRegisterPostData = {
    body: ClientRegistrationRequest;
    path?: never;
    query?: never;
    url: '/integrations/oauth2/server/register';
};

export type RegisterClientIntegrationsOauth2ServerRegisterPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RegisterClientIntegrationsOauth2ServerRegisterPostError = RegisterClientIntegrationsOauth2ServerRegisterPostErrors[keyof RegisterClientIntegrationsOauth2ServerRegisterPostErrors];

export type RegisterClientIntegrationsOauth2ServerRegisterPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type RevokeTokenIntegrationsOauth2ServerRevokePostData = {
    body: RevocationRequest;
    path?: never;
    query?: never;
    url: '/integrations/oauth2/server/revoke';
};

export type RevokeTokenIntegrationsOauth2ServerRevokePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RevokeTokenIntegrationsOauth2ServerRevokePostError = RevokeTokenIntegrationsOauth2ServerRevokePostErrors[keyof RevokeTokenIntegrationsOauth2ServerRevokePostErrors];

export type RevokeTokenIntegrationsOauth2ServerRevokePostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type McpStreamableHttpDeleteData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/integrations/mcp';
};

export type McpStreamableHttpDeleteResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type McpStreamableHttpGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/integrations/mcp';
};

export type McpStreamableHttpGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type McpStreamableHttpPostData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/integrations/mcp';
};

export type McpStreamableHttpPostResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type McpWhoamiData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/integrations/mcp/whoami';
};

export type McpWhoamiResponses = {
    /**
     * Successful Response
     */
    200: WhoAmI;
};

export type McpWhoamiResponse = McpWhoamiResponses[keyof McpWhoamiResponses];

export type RegisterSessionIntegrationsDevPreviewSessionsPostData = {
    body: RegisterSessionRequest;
    headers?: {
        /**
         * Authorization
         */
        authorization?: string;
    };
    path?: never;
    query?: never;
    url: '/integrations/dev-preview/sessions';
};

export type RegisterSessionIntegrationsDevPreviewSessionsPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RegisterSessionIntegrationsDevPreviewSessionsPostError = RegisterSessionIntegrationsDevPreviewSessionsPostErrors[keyof RegisterSessionIntegrationsDevPreviewSessionsPostErrors];

export type RegisterSessionIntegrationsDevPreviewSessionsPostResponses = {
    /**
     * Successful Response
     */
    201: RegisterSessionResponse;
};

export type RegisterSessionIntegrationsDevPreviewSessionsPostResponse = RegisterSessionIntegrationsDevPreviewSessionsPostResponses[keyof RegisterSessionIntegrationsDevPreviewSessionsPostResponses];

export type SessionStatusIntegrationsDevPreviewSessionsHostGetData = {
    body?: never;
    headers?: {
        /**
         * Authorization
         */
        authorization?: string;
    };
    path: {
        /**
         * Host
         */
        host: string;
    };
    query?: never;
    url: '/integrations/dev-preview/sessions/{host}';
};

export type SessionStatusIntegrationsDevPreviewSessionsHostGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SessionStatusIntegrationsDevPreviewSessionsHostGetError = SessionStatusIntegrationsDevPreviewSessionsHostGetErrors[keyof SessionStatusIntegrationsDevPreviewSessionsHostGetErrors];

export type SessionStatusIntegrationsDevPreviewSessionsHostGetResponses = {
    /**
     * Successful Response
     */
    200: SessionStatusResponse;
};

export type SessionStatusIntegrationsDevPreviewSessionsHostGetResponse = SessionStatusIntegrationsDevPreviewSessionsHostGetResponses[keyof SessionStatusIntegrationsDevPreviewSessionsHostGetResponses];

export type SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostData = {
    body: HeartbeatRequest;
    headers?: {
        /**
         * Authorization
         */
        authorization?: string;
    };
    path: {
        /**
         * Host
         */
        host: string;
    };
    query?: never;
    url: '/integrations/dev-preview/sessions/{host}/heartbeat';
};

export type SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostError = SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostErrors[keyof SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostErrors];

export type SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostResponses = {
    /**
     * Successful Response
     */
    200: HeartbeatResponse;
};

export type SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostResponse = SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostResponses[keyof SessionHeartbeatIntegrationsDevPreviewSessionsHostHeartbeatPostResponses];

export type RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostData = {
    body?: never;
    headers?: {
        /**
         * Authorization
         */
        authorization?: string;
    };
    path: {
        /**
         * Host
         */
        host: string;
    };
    query?: never;
    url: '/integrations/dev-preview/sessions/{host}/revoke';
};

export type RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostError = RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostErrors[keyof RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostErrors];

export type RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostResponses = {
    /**
     * Successful Response
     */
    200: SessionStatusResponse;
};

export type RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostResponse = RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostResponses[keyof RevokeSessionIntegrationsDevPreviewSessionsHostRevokePostResponses];

export type EnterPreviewIntegrationsDevPreviewEnterHostGetData = {
    body?: never;
    path: {
        /**
         * Host
         */
        host: string;
    };
    query?: {
        /**
         * Next
         */
        next?: string | null;
    };
    url: '/integrations/dev-preview/enter/{host}';
};

export type EnterPreviewIntegrationsDevPreviewEnterHostGetErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type EnterPreviewIntegrationsDevPreviewEnterHostGetError = EnterPreviewIntegrationsDevPreviewEnterHostGetErrors[keyof EnterPreviewIntegrationsDevPreviewEnterHostGetErrors];

export type EnterPreviewIntegrationsDevPreviewEnterHostGetResponses = {
    /**
     * Successful Response
     */
    200: EnterResponse;
};

export type EnterPreviewIntegrationsDevPreviewEnterHostGetResponse = EnterPreviewIntegrationsDevPreviewEnterHostGetResponses[keyof EnterPreviewIntegrationsDevPreviewEnterHostGetResponses];

export type PreviewJwksIntegrationsDevPreviewJwksJsonGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/integrations/dev-preview/jwks.json';
};

export type PreviewJwksIntegrationsDevPreviewJwksJsonGetResponses = {
    /**
     * Response Preview Jwks Integrations Dev Preview Jwks Json Get
     *
     * Successful Response
     */
    200: {
        [key: string]: unknown;
    };
};

export type PreviewJwksIntegrationsDevPreviewJwksJsonGetResponse = PreviewJwksIntegrationsDevPreviewJwksJsonGetResponses[keyof PreviewJwksIntegrationsDevPreviewJwksJsonGetResponses];

export type HealthcheckHealthcheckGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/healthcheck';
};

export type HealthcheckHealthcheckGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};
